  (function () {

    var rentalPageConfig = window.PlayforceRentalConfig || {};
    var rentalEditRequestedGroupId = '';
    var rentalEditModeActive = false;
    var rentalEditOriginalItems = [];
    var rentalEditMainItem = null;
    var rentalEditQuantity = 1;
    var rentalEditLoadedCart = null;
    var rentalEditCachedSnapshot = null;
    var rentalEditFastPathApplied = false;
    var rentalInitialValidationPromise = null;
    var RENTAL_EDIT_CACHE_PREFIX = 'playforceRentalEditCacheV1:';
    var RENTAL_EDIT_CACHE_MAX_AGE_MS = 15 * 60 * 1000;

    try {
      rentalEditRequestedGroupId = String(
        new URLSearchParams(window.location.search || '').get('edit_rental') || ''
      ).trim();
    } catch (error) {
      rentalEditRequestedGroupId = '';
    }

    var securityDepositDescriptionByVariantId = rentalPageConfig.securityDepositDescriptionByVariantId || {};
    var initialSecurityDepositStockByVariantId = rentalPageConfig.securityDepositInitialStockByVariantId || {};
    var initialPlayTimeStatusLoaded = rentalPageConfig.playTimeInitialLoaded === true;
    var initialPlayTimeSameDayEnabled = initialPlayTimeStatusLoaded && rentalPageConfig.playTimeSameDayEnabled === true;
    var initialServerRenderedAtMs = Number(rentalPageConfig.serverRenderedAtMs || 0);

    var securityDepositProductHandleCandidatesByVariantId = {
      '47526006063291': ['security-deposit'],
      '47994120241339': ['security-deposit-business-i5', 'security-deposit-i5'],
      '47994120339643': ['security-deposit-business-i7', 'security-deposit-i7'],
      '48111443509435': ['security-deposit-ultra-5-ryzen-5-new', 'security-deposit-ultra-5'],
      '48111444099259': ['security-deposit-ultra-7-ryzen-7-new', 'security-deposit-ultra-7'],
      '48000206274747': ['security-deposit-gtx-1650'],
      '48000206700731': ['security-deposit-rtx-2060'],
      '48000207061179': ['security-deposit-rtx-3050'],
      '48000207388859': ['security-deposit-rtx-3060', 'security-deposit-rtx-3060-below'],
      '48000136282299': ['security-deposit-rtx-3070'],
      '48000145031355': ['security-deposit-rtx-3080'],
      '47939105030331': ['security-deposit-rtx-4050'],
      '47939105980603': ['security-deposit-rtx-4060'],
      '47939106078907': ['security-deposit-rtx-4070'],
      '48205548290235': ['security-deposit-rtx-5050'],
      '48221763272891': ['security-deposit-rtx-5080'],
      '48220729606331': ['security-deposit-imac-m1'],
      '47939187343547': ['security-deposit-macbook-air-m1'],
      '47939187605691': ['security-deposit-macbook-air-m2'],
      '47939187671227': ['security-deposit-macbook-air-m4'],
      '47939188719803': ['security-deposit-macbook-pro-m1'],
      '47939189276859': ['security-deposit-macbook-pro-m2'],
      '47939190161595': ['security-deposit-macbook-pro-m1-pro'],
      '47939191931067': ['security-deposit-macbook-pro-m2-pro'],
      '47939192258747': ['security-deposit-macbook-pro-m3-pro'],
      '48000175931579': ['security-deposit-macbook-pro-m3-max'],
      '47939193307323': ['security-deposit-macbook-pro-m4-pro'],
      '48220744155323': ['security-deposit-macbook-pro-m5-pro', 'security-deposit-m5-pro'],
      '48012018843835': ['security-deposit-ipad-8th'],
      '47940834984123': ['security-deposit-ipad-9th'],
      '48011984797883': ['security-deposit-ipad-10th'],
      '48221678796987': ['security-deposit-ipad-11th'],
      '47940837474491': ['security-deposit-ipad-air-m1', 'security-deposit-ipad-air-5th'],
      '48221653827771': ['security-deposit-ipad-air-m4'],
      '47940838621371': ['security-deposit-ipad-pro-m1', 'security-deposit-ipad-m1'],
      '47940843143355': ['security-deposit-ipad-pro-m2', 'security-deposit-ipad-m2'],
      '48199708836027': ['security-deposit-ipad-8th-cellular'],
      '48199708967099': ['security-deposit-ipad-9th-cellular'],
      '48199708999867': ['security-deposit-ipad-10th-cellular'],
      '48221681189051': ['security-deposit-ipad-11th-cellular'],
      '48199709163707': ['security-deposit-ipad-air-m1-cellular', 'security-deposit-ipad-air-5th-cellular'],
      '48221655466171': ['security-deposit-ipad-air-m4-cellular'],
      '48199710081211': ['security-deposit-ipad-pro-m1-cellular', 'security-deposit-ipad-m1-cellular'],
      '48199710212283': ['security-deposit-ipad-pro-m2-cellular', 'security-deposit-ipad-m2-cellular']
    };

    var securityDepositLeadDaysByVariantId = {};
    var securityDepositLeadDaysRequestByVariantId = {};
    var securityDepositProductCatalogPromise = null;

    function stripSecurityDepositDescriptionHtml(value) {
      var html = String(value || '');
      if (!html) return '';

      var temporary = document.createElement('div');
      temporary.innerHTML = html;
      return String(temporary.textContent || temporary.innerText || '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function parseSecurityDepositLeadDays(description) {
      var text = stripSecurityDepositDescriptionHtml(description);
      var match = text.match(/\bday\s*[:=\-]?\s*(\d{1,3})\b/i);

      if (!match) return 0;

      var days = parseInt(match[1], 10);
      if (!isFinite(days) || days < 0) return 0;

      return Math.min(days, 365);
    }

    function normaliseSecurityDepositProductPayload(payload) {
      if (!payload || typeof payload !== 'object') return null;
      return payload.product && typeof payload.product === 'object'
        ? payload.product
        : payload;
    }

    function productContainsSecurityDepositVariant(productData, variantId) {
      if (!productData || !Array.isArray(productData.variants)) return false;

      return productData.variants.some(function (variant) {
        return String(variant && variant.id) === String(variantId);
      });
    }

    function readSecurityDepositDescriptionFromProduct(productData) {
      if (!productData) return '';
      return productData.body_html || productData.description || '';
    }

    function fetchSecurityDepositProductByHandle(handle, variantId) {
      if (!handle) return Promise.resolve(null);

      return fetch('/products/' + encodeURIComponent(handle) + '.json?rental_deposit_day=' + Date.now(), {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Cache-Control': 'no-cache'
        },
        cache: 'no-store'
      })
        .then(function (response) {
          if (typeof setTrustedNowFromResponse === 'function') {
            setTrustedNowFromResponse(response);
          }

          if (!response.ok) return null;
          return response.json();
        })
        .then(function (payload) {
          var productData = normaliseSecurityDepositProductPayload(payload);
          return productContainsSecurityDepositVariant(productData, variantId)
            ? productData
            : null;
        })
        .catch(function () {
          return null;
        });
    }

    function fetchSecurityDepositFromHandleCandidates(variantId) {
      var candidates = securityDepositProductHandleCandidatesByVariantId[String(variantId)] || [];
      var index = 0;

      function tryNextCandidate() {
        if (index >= candidates.length) return Promise.resolve(null);

        var handle = candidates[index];
        index += 1;

        return fetchSecurityDepositProductByHandle(handle, variantId)
          .then(function (productData) {
            return productData || tryNextCandidate();
          });
      }

      return tryNextCandidate();
    }

    function loadSecurityDepositProductCatalog() {
      if (securityDepositProductCatalogPromise) return securityDepositProductCatalogPromise;

      securityDepositProductCatalogPromise = fetch('/products.json?limit=250&rental_deposit_day=' + Date.now(), {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Cache-Control': 'no-cache'
        },
        cache: 'no-store'
      })
        .then(function (response) {
          if (typeof setTrustedNowFromResponse === 'function') {
            setTrustedNowFromResponse(response);
          }

          if (!response.ok) return [];
          return response.json();
        })
        .then(function (payload) {
          if (Array.isArray(payload)) return payload;
          return payload && Array.isArray(payload.products) ? payload.products : [];
        })
        .catch(function () {
          return [];
        });

      return securityDepositProductCatalogPromise;
    }

    function findSecurityDepositInProductCatalog(variantId) {
      return loadSecurityDepositProductCatalog()
        .then(function (products) {
          return products.find(function (productData) {
            return productContainsSecurityDepositVariant(productData, variantId);
          }) || null;
        });
    }

    function cacheSecurityDepositLeadDays(variantId, description) {
      var key = String(variantId);
      var normalisedDescription = stripSecurityDepositDescriptionHtml(description);
      securityDepositDescriptionByVariantId[key] = normalisedDescription;
      securityDepositLeadDaysByVariantId[key] = parseSecurityDepositLeadDays(normalisedDescription);
      return securityDepositLeadDaysByVariantId[key];
    }

    function loadSecurityDepositLeadDaysForVariantId(variantId) {
      var key = String(variantId || '');
      if (!key) return Promise.resolve(0);

      if (Object.prototype.hasOwnProperty.call(securityDepositLeadDaysByVariantId, key)) {
        return Promise.resolve(securityDepositLeadDaysByVariantId[key]);
      }

      if (securityDepositDescriptionByVariantId[key]) {
        return Promise.resolve(cacheSecurityDepositLeadDays(key, securityDepositDescriptionByVariantId[key]));
      }

      if (securityDepositLeadDaysRequestByVariantId[key]) {
        return securityDepositLeadDaysRequestByVariantId[key];
      }

      securityDepositLeadDaysRequestByVariantId[key] = fetchSecurityDepositFromHandleCandidates(key)
        .then(function (productData) {
          if (productData) return productData;
          return findSecurityDepositInProductCatalog(key);
        })
        .then(function (productData) {
          var description = readSecurityDepositDescriptionFromProduct(productData);
          return cacheSecurityDepositLeadDays(key, description);
        })
        .catch(function (error) {
          console.error('Security deposit Day setting lookup error:', error);
          return cacheSecurityDepositLeadDays(key, 'Day 0');
        });

      return securityDepositLeadDaysRequestByVariantId[key];
    }

    function getSecurityDepositLeadDaysForVariantId(variantId) {
      var key = String(variantId || '');

      if (Object.prototype.hasOwnProperty.call(securityDepositLeadDaysByVariantId, key)) {
        return securityDepositLeadDaysByVariantId[key];
      }

      return parseSecurityDepositLeadDays(securityDepositDescriptionByVariantId[key] || '');
    }

    function getSelectedSecurityDepositLeadDays() {
      var config = getSecurityDepositConfig();
      return config && config.variantId
        ? getSecurityDepositLeadDaysForVariantId(config.variantId)
        : 0;
    }

    function loadSelectedSecurityDepositLeadDays() {
      var config = getSecurityDepositConfig();
      if (!config || !config.variantId) return Promise.resolve(0);

      var requestedVariantId = String(config.variantId);

      return loadSecurityDepositLeadDaysForVariantId(requestedVariantId)
        .then(function (days) {
          var currentConfig = getSecurityDepositConfig();
          if (currentConfig && String(currentConfig.variantId) === requestedVariantId) {
            refreshPlayTimeDependentUi(true);
          }
          return days;
        });
    }

    var weekendSurchargeVariantId = 47525588238523;
    var earlyDeliveryVariantId = 47541269823675;
    var standardUrgentChargeVariantId = 47943771488443;
    var priorityUrgentChargeVariantId = 47943772995771;
    var standardReturnExtensionVariantId = 47943792853179;
    var priorityReturnExtensionVariantId = 47943796097211;
    var memoryAddonVariantId = 47939116859579;
    var officeAddonVariantId = 47939117285563;
    var appleMouseAddonVariantId = 48226709143739;
    var appleMouseAddonStockStatus = null;
    var appleMouseAddonStockRequestSequence = 0;
    var hdmiAddonVariantId = 48028946235579;

    var pencilAddonVariantPriority = [
      {
        key: 'gen-1',
        label: 'Pencil Gen 1',
        variantId: 47943499776187,
        compatibleModels: [
          'ipad 8th',
          'ipad 9th'
        ]
      },
      {
        key: 'gen-2',
        label: 'Pencil Gen 2',
        variantId: 48199696548027,
        compatibleModels: [
          'ipad mini 6',
          'ipad air m1',
          'ipad pro m1',
          'ipad pro m2'
        ]
      },
      {
        key: 'usb-c',
        label: 'Pencil USB-C',
        variantId: 48199699824827,
        compatibleModels: [
          'ipad 10th',
          'ipad a16',
          'ipad mini 6',
          'ipad mini a17 pro',
          'ipad air m1',
          'ipad air m2',
          'ipad air m3',
          'ipad air m4',
          'ipad pro m1',
          'ipad pro m2',
          'ipad pro m4',
          'ipad pro m5'
        ]
      }
    ];
    var pencilAddonVariantId = 0;
    var selectedPencilAddonConfig = null;
    var pencilAddonStockStatusByVariantId = {};
    var pencilAddonStockRequestSequence = 0;
    var defaultSecurityDepositVariantId = 47526006063291;

    var weekendSurchargeCents = null;
    var earlyDeliverySurchargeCents = null;
    var standardUrgentChargeCents = null;
    var priorityUrgentChargeCents = null;
    var standardReturnExtensionCents = null;
    var priorityReturnExtensionCents = null;
    var memoryAddonCents = null;
    var officeAddonCents = null;
    var appleMouseAddonCents = null;
    var hdmiAddonCents = null;
    var pencilAddonCents = null;

    var businessLaptopSecurityDepositMap = {
      i5: { variantId: 47994120241339 },
      i7: { variantId: 47994120339643 },
      ultra5: { variantId: 48111443509435 },
      ultra7: { variantId: 48111444099259 }
    };

    function hasStandaloneBusinessTierWord(text, word) {
      return new RegExp('(^|[^a-z0-9])' + word + '([^a-z0-9]|$)', 'i').test(text);
    }

    function getBusinessLaptopSecurityDepositConfig(searchText) {
      var text = String(searchText || '').toLowerCase();
      var isNewTier = hasStandaloneBusinessTierWord(text, 'new');

      if (text.indexOf('ultra 7') !== -1 || (text.indexOf('ryzen 7') !== -1 && isNewTier)) {
        return businessLaptopSecurityDepositMap.ultra7;
      }

      if (text.indexOf('ultra 5') !== -1 || (text.indexOf('ryzen 5') !== -1 && isNewTier)) {
        return businessLaptopSecurityDepositMap.ultra5;
      }

      if (hasStandaloneBusinessTierWord(text, 'i7') || text.indexOf('ryzen 7') !== -1) {
        return businessLaptopSecurityDepositMap.i7;
      }

      if (hasStandaloneBusinessTierWord(text, 'i5') || text.indexOf('ryzen 5') !== -1) {
        return businessLaptopSecurityDepositMap.i5;
      }

      return null;
    }

    var gamingSecurityDepositMap = {
      'gtx 1650': {
        variantId: 48000206274747
      },
      'rtx 2060': {
        variantId: 48000206700731
      },
      'rtx 3050': {
        variantId: 48000207061179
      },
      'rtx 3060': {
        variantId: 48000207388859
      },
      'rtx 3070': {
        variantId: 48000136282299
      },
      'rtx 3080': {
        variantId: 48000145031355
      },
      'rtx 4050': {
        variantId: 47939105030331
      },
      'rtx 4060': {
        variantId: 47939105980603
      },
      'rtx 4070': {
        variantId: 47939106078907
      },
      'rtx 5050': {
        variantId: 48205548290235
      },
      'rtx 5080': {
        variantId: 48221763272891
      }
    };

    var macbookSecurityDepositMap = {
      'imac m1': { variantId: 48220729606331 },
      'macbook air m1': { variantId: 47939187343547 },
      'macbook air m2': { variantId: 47939187605691 },
      'macbook air m4': { variantId: 47939187671227 },
      'macbook pro m3 max': { variantId: 48000175931579 },
      'm3 max': { variantId: 48000175931579 },
      'macbook pro m1 pro': { variantId: 47939190161595 },
      'macbook pro m2 pro': { variantId: 47939191931067 },
      'm2 pro': { variantId: 47939191931067 },
      'macbook pro m3 pro': { variantId: 47939192258747 },
      'm3 pro': { variantId: 47939192258747 },
      'macbook pro m4 pro': { variantId: 47939193307323 },
      'm4 pro': { variantId: 47939193307323 },
      'macbook pro m5 pro': { variantId: 48220744155323 },
      'm5 pro': { variantId: 48220744155323 },
      'macbook pro m1': { variantId: 47939188719803 },
      'macbook pro m2': { variantId: 47939189276859 }
    };

    var ipadSecurityDepositMap = {
      'ipad air m4 cellular': { variantId: 48221655466171 },
      'ipad air m1 cellular': { variantId: 48199709163707 },
      'ipad air 5th cellular': { variantId: 48199709163707 },
      'ipad air 5 cellular': { variantId: 48199709163707 },
      'ipad pro m1 cellular': { variantId: 48199710081211 },
      'ipad m1 cellular': { variantId: 48199710081211 },
      'ipad pro m2 cellular': { variantId: 48199710212283 },
      'ipad m2 cellular': { variantId: 48199710212283 },
      'ipad 11th cellular': { variantId: 48221681189051 },
      'ipad 10th cellular': { variantId: 48199708999867 },
      'ipad 9th cellular': { variantId: 48199708967099 },
      'ipad 8th cellular': { variantId: 48199708836027 },
      'ipad air m4': { variantId: 48221653827771 },
      'ipad air m1': { variantId: 47940837474491 },
      'ipad air 5th': { variantId: 47940837474491 },
      'ipad air 5': { variantId: 47940837474491 },
      'ipad pro m1': { variantId: 47940838621371 },
      'ipad m1': { variantId: 47940838621371 },
      'ipad pro m2': { variantId: 47940843143355 },
      'ipad m2': { variantId: 47940843143355 },
      'ipad 11th': { variantId: 48221678796987 },
      'ipad 10th': { variantId: 48011984797883 },
      'ipad 9th': { variantId: 47940834984123 },
      'ipad 8th': { variantId: 48012018843835 }
    };

    var rentalTermsAgree = document.getElementById('RentalTermsAgree');
    var rentalTermsToggle = document.getElementById('RentalTermsToggle');
    var rentalTermsBox = document.getElementById('RentalTermsBox');
    var deliveryTimeInput = document.getElementById('RentalDeliveryTime');
    var rentalDeliveryTimeLabel = document.getElementById('RentalDeliveryTimeLabel');
    var returnTimeInput = document.getElementById('RentalReturnTime');
    var rentalReturnTimeLabel = document.getElementById('RentalReturnTimeLabel');
    var startPreview = document.getElementById('RentalStartPreview');
    var endPreview = document.getElementById('RentalEndPreview');
    var endInfoWrap = document.getElementById('RentalEndInfoWrap');
    var returnNote = document.getElementById('RentalReturnNote');
    var rentalPriceMobilePeriod = document.getElementById('RentalPriceMobilePeriod');
    var rentalPriceMobileTimingRows = document.getElementById('RentalPriceMobileTimingRows');
    var rentalPriceMobileStart = document.getElementById('RentalPriceMobileStart');
    var rentalPriceMobileEnd = document.getElementById('RentalPriceMobileEnd');
    var mainImage = document.getElementById('RentalMainImage');
    var rentalGalleryMain = document.querySelector('.rental-gallery-main');
    var thumbs = document.querySelectorAll('.rental-thumb');
    var optionInputs = document.querySelectorAll('.rental-option-radio');
    var rentalPeriodSelect = document.getElementById('RentalPeriodSelect');
    var rentalProcessorSelect = document.getElementById('RentalProcessorSelect');
    var rentalProcessorClosedDisplay = null;
    var rentalProcessorClosedDisplayLabel = null;
    var rentalProcessorNativePickerExpanded = false;
    var rentalProcessorSelectOriginalOverlayStyles = null;

    function removeLegacyRentalPeriodPriceNote() {
      Array.prototype.forEach.call(
        document.querySelectorAll('#RentalPeriodSelectedPrice, [data-rental-period-price-note]'),
        function (note) {
          if (note && note.parentNode) note.parentNode.removeChild(note);
        }
      );

      if (!rentalPeriodSelect || !rentalPeriodSelect.parentNode) return;

      Array.prototype.forEach.call(rentalPeriodSelect.parentNode.children, function (child) {
        if (!child || child === rentalPeriodSelect) return;

        var noteText = String(child.textContent || '')
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase();

        if (noteText.indexOf('rental price:') === 0) {
          if (child.parentNode) child.parentNode.removeChild(child);
        }
      });
    }

    removeLegacyRentalPeriodPriceNote();

    if (rentalPeriodSelect && rentalPeriodSelect.parentNode && window.MutationObserver) {
      var rentalPeriodPriceNoteObserver = new MutationObserver(function () {
        removeLegacyRentalPeriodPriceNote();
      });

      rentalPeriodPriceNoteObserver.observe(rentalPeriodSelect.parentNode, {
        childList: true
      });
    }
    var rentalPeriodOriginalOptions = rentalPeriodSelect
      ? Array.prototype.map.call(rentalPeriodSelect.options, function (option) {
          return {
            option: option,
            originallyDisabled: !!option.disabled,
            originalText: option.textContent
          };
        })
      : [];
    var allVariants = Array.isArray(rentalPageConfig.allVariants) ? rentalPageConfig.allVariants : [];

    function isIpadRentalPage() {
      return String(rentalPageConfig.productTitle || '').toLowerCase().indexOf('ipad rental') !== -1;
    }

    function getRentalProcessorOptionIndex() {
      if (!rentalProcessorSelect) return -1;

      var position = parseInt(rentalProcessorSelect.getAttribute('data-option-position'), 10);
      return Number.isFinite(position) && position > 0 ? position - 1 : -1;
    }

    function normaliseIpadProcessorValue(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();
    }

    function isIpadCellularProcessorValue(value) {
      return /\bcellular\b/i.test(String(value || ''));
    }

    function getBaseIpadProcessorValue(value) {
      return String(value || '')
        .replace(/\s+cellular\s*$/i, '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function getRawSelectedProcessorValue() {
      var optionPosition = rentalProcessorSelect
        ? rentalProcessorSelect.getAttribute('data-option-position')
        : '';
      var checked = Array.prototype.find.call(optionInputs, function (input) {
        return input.getAttribute('data-option-position') === optionPosition &&
          input.checked &&
          !isIpadCellularProcessorValue(input.value);
      });

      if (checked && checked.value) return String(checked.value).trim();
      if (rentalProcessorSelect && rentalProcessorSelect.value) {
        return getBaseIpadProcessorValue(rentalProcessorSelect.value);
      }

      return '';
    }

    function findIpadProcessorValue(targetValue) {
      var processorIndex = getRentalProcessorOptionIndex();
      var targetKey = normaliseIpadProcessorValue(targetValue);
      var matchedValue = '';

      if (processorIndex < 0 || !targetKey) return '';

      allVariants.some(function (variant) {
        if (!variant || !Array.isArray(variant.options)) return false;

        var candidate = String(variant.options[processorIndex] || '').trim();
        if (normaliseIpadProcessorValue(candidate) !== targetKey) return false;

        matchedValue = candidate;
        return true;
      });

      return matchedValue;
    }

    function getCellularIpadProcessorValue(baseValue) {
      var base = getBaseIpadProcessorValue(baseValue);
      return base ? findIpadProcessorValue(base + ' Cellular') : '';
    }

    function getEffectiveIpadProcessorValue() {
      var baseValue = getRawSelectedProcessorValue();

      if (!isIpadRentalPage() || !cellularAddonInput || !cellularAddonInput.checked) {
        return baseValue;
      }

      return getCellularIpadProcessorValue(baseValue) || baseValue;
    }

    function getRawSelectedOptions() {
      var selected = [];
      var groups = document.querySelectorAll('.rental-option-group[data-option-position]');

      groups.forEach(function (group) {
        var checked = group.querySelector('.rental-option-radio:checked');
        selected.push(checked ? checked.value : null);
      });

      return selected;
    }

    function hideInternalIpadCellularProcessorOptions() {
      if (!isIpadRentalPage() || !rentalProcessorSelect) return;

      var processorPosition = rentalProcessorSelect.getAttribute('data-option-position');

      Array.prototype.slice.call(rentalProcessorSelect.options).forEach(function (option) {
        if (isIpadCellularProcessorValue(option.value)) {
          option.remove();
        }
      });

      Array.prototype.forEach.call(optionInputs, function (input) {
        if (input.getAttribute('data-option-position') !== processorPosition) return;
        if (!isIpadCellularProcessorValue(input.value)) return;

        input.setAttribute('data-internal-cellular-processor', 'true');
        input.setAttribute('tabindex', '-1');

        var card = input.closest('.rental-option-card');
        if (card) {
          card.hidden = true;
          card.style.display = 'none';
          card.setAttribute('aria-hidden', 'true');
        }
      });
    }

    var variantIdInput = document.getElementById('RentalVariantId');
    var basePriceLabelEl = document.getElementById('RentalBasePriceLabel');
    var basePriceEl = document.getElementById('RentalBasePrice');
    var totalPriceEl = document.getElementById('RentalTotalPrice');
    var mobileSummaryJump = document.getElementById('RentalMobileSummaryJump');
    var mobileSummaryJumpRentalCost = document.getElementById('RentalMobileSummaryJumpRentalCost');
    var mobileSummaryJumpDeposit = document.getElementById('RentalMobileSummaryJumpDeposit');
    var mobileSummaryJumpSuppressedForValidation = false;
    var priceBoxEl = document.querySelector('.rental-price-box');
    var rentalOptionsField = document.querySelector('.rental-field--options');
    var rentalTermsField = document.querySelector('.rental-terms-field');
    var rentalFormWrap = document.querySelector('.rental-form-wrap');
    var rentalDetails = document.querySelector('.rental-details');

    var priceBoxOriginalParent = priceBoxEl ? priceBoxEl.parentNode : null;
    var priceBoxOriginalNextSibling = priceBoxEl ? priceBoxEl.nextSibling : null;
    var surchargeRow = document.getElementById('WeekendSurchargeRow');
    var earlyDeliveryRow = document.getElementById('EarlyDeliveryRow');
    var priorityUrgentChargeRow = document.getElementById('PriorityUrgentChargeRow');
    var standardUrgentChargeRow = document.getElementById('StandardUrgentChargeRow');
    var standardReturnExtensionRow = document.getElementById('StandardReturnExtensionRow');
    var priorityReturnExtensionRow = document.getElementById('PriorityReturnExtensionRow');
    var memoryAddonRow = document.getElementById('MemoryAddonRow');
    var officeAddonRow = document.getElementById('OfficeAddonRow');
    var appleMouseAddonRow = document.getElementById('AppleMouseAddonRow');
    var hdmiAddonRow = document.getElementById('HdmiAddonRow');
    var cellularAddonRow = document.getElementById('CellularAddonRow');
    var pencilAddonRow = document.getElementById('PencilAddonRow');
    var memoryAddonInput = document.getElementById('GamingAddon32GB');
    var officeAddonInput = document.getElementById('GamingAddonOffice');
    var appleMouseAddonInput = document.getElementById('MacbookAddonAppleMouse');
    var hdmiAddonInput = document.getElementById('BusinessAddonHdmiPort');
    var cellularAddonInput = document.getElementById('IpadAddonCellular');
    var pencilAddonInput = document.getElementById('IpadAddonPencil');
    var securityDepositValueEl = document.getElementById('SecurityDepositValue');
    var surchargeAppliedInput = document.getElementById('WeekendSurchargeApplied');
    var surchargeAmountInput = document.getElementById('WeekendSurchargeAmount');
    var startDateInput = document.getElementById('RentalStartDate');
    var rentalStartDateLabel = document.getElementById('RentalStartDateLabel');
    var rentalStartDateDisplay = document.getElementById('RentalStartDateDisplay');
    var rentalStartDateDisplayText = document.getElementById('RentalStartDateDisplayText');
    var rentalMobileCalendar = document.getElementById('RentalMobileCalendar');
    var rentalMobileCalendarTitle = document.getElementById('RentalMobileCalendarTitle');
    var rentalMobileCalendarGrid = document.getElementById('RentalMobileCalendarGrid');
    var rentalMobileCalendarPrev = document.getElementById('RentalMobileCalendarPrev');
    var rentalMobileCalendarNext = document.getElementById('RentalMobileCalendarNext');
    var rentalMobileCalendarViewDate = null;

    var useCustomRentalDatePicker = true;
    var dateError = document.getElementById('RentalDateError');
    var submitButton = document.getElementById('RentalSubmitButton');
    var rentalForm = document.getElementById('RentalProductForm');
    var rentalNotes = document.getElementById('RentalNotes');
    var rentalQuantityInput = rentalForm
      ? rentalForm.querySelector('input[name="quantity"]')
      : document.querySelector('#RentalProductForm input[name="quantity"]');
    var jotformSubmittedInput = document.getElementById('JotformSubmitted');
    var documentsReusedFromActiveRentalCart = false;
    var documentsSubmittedOnCurrentPage = false;
    var RENTAL_DOCUMENT_SESSION_MINUTES = 15;
    var jotformStatusNote = document.getElementById('JotformStatusNote');
    var requiredDocumentsHeading = document.getElementById('RentalRequiredDocumentsHeading');
    var requiredDocumentsStepNote = document.querySelector('.rental-step-note--documents');
    var rentalOptionsStepTitle = document.getElementById('RentalOptionsStepTitle');
    var rentalOptionsStepNote = document.querySelector('.rental-step-heading--options .rental-step-note');
    var requiredDocumentsPanel = document.getElementById('RentalRequiredDocumentsPanel');
    var documentsStepSection = document.getElementById('RentalDocumentsStepSection');
    var uploadDocumentsPanel = document.getElementById('RentalUploadDocumentsPanel');
    var requiredDocumentsOriginalParent = requiredDocumentsPanel ? requiredDocumentsPanel.parentNode : null;
    var requiredDocumentsOriginalNextSibling = requiredDocumentsPanel ? requiredDocumentsPanel.nextSibling : null;
    var rentalTermsOriginalParent = rentalTermsField ? rentalTermsField.parentNode : null;
    var rentalTermsOriginalNextSibling = rentalTermsField ? rentalTermsField.nextSibling : null;
    var submitButtonOriginalParent = submitButton ? submitButton.parentNode : null;
    var submitButtonOriginalNextSibling = submitButton ? submitButton.nextSibling : null;
    var mobileStandaloneReviewHost = null;
    var mobileFinalConfirmationCard = null;
    var mobileReviewLayoutApplied = false;
    var compatibilityPanel = document.querySelector('.rental-compatibility-panel');
    var rentalIncludesList = document.getElementById('RentalIncludesList');
    var rentalPortsList = document.getElementById('RentalPortsList');
    var compatibilitySelectedOptionEl = document.getElementById('RentalCompatibilitySelectedOption');
    var rentalProductTitle = String(rentalPageConfig.productTitle || '').toLowerCase();

    var liveVariantPriceCentsById = {};
    var liveVariantPriceRequestById = {};

    function normaliseVariantId(value) {
      var numericId = Number(value);
      return Number.isFinite(numericId) && numericId > 0 ? String(Math.trunc(numericId)) : '';
    }

    function parseLiveVariantPriceCents(variantData) {
      if (!variantData || typeof variantData !== 'object') return null;

      var rawPrice = variantData.price;

      if (typeof rawPrice === 'number') {
        return Number.isFinite(rawPrice) && rawPrice >= 0 ? Math.round(rawPrice) : null;
      }

      var priceText = String(rawPrice == null ? '' : rawPrice).replace(/,/g, '').trim();
      if (!priceText || !/^-?\d+(?:\.\d+)?$/.test(priceText)) return null;

      var numericPrice = Number(priceText);
      if (!Number.isFinite(numericPrice) || numericPrice < 0) return null;

      return priceText.indexOf('.') !== -1
        ? Math.round(numericPrice * 100)
        : Math.round(numericPrice);
    }

    function syncKnownLivePriceVariable(variantId, cents) {
      var key = normaliseVariantId(variantId);

      if (key === normaliseVariantId(weekendSurchargeVariantId)) weekendSurchargeCents = cents;
      if (key === normaliseVariantId(earlyDeliveryVariantId)) earlyDeliverySurchargeCents = cents;
      if (key === normaliseVariantId(standardUrgentChargeVariantId)) standardUrgentChargeCents = cents;
      if (key === normaliseVariantId(priorityUrgentChargeVariantId)) priorityUrgentChargeCents = cents;
      if (key === normaliseVariantId(standardReturnExtensionVariantId)) standardReturnExtensionCents = cents;
      if (key === normaliseVariantId(priorityReturnExtensionVariantId)) priorityReturnExtensionCents = cents;
      if (key === normaliseVariantId(memoryAddonVariantId)) memoryAddonCents = cents;
      if (key === normaliseVariantId(officeAddonVariantId)) officeAddonCents = cents;
      if (key === normaliseVariantId(appleMouseAddonVariantId)) appleMouseAddonCents = cents;
      if (key === normaliseVariantId(hdmiAddonVariantId)) hdmiAddonCents = cents;
      if (key === normaliseVariantId(pencilAddonVariantId)) pencilAddonCents = cents;
    }

    function cacheLiveVariantPrice(variantId, cents) {
      var key = normaliseVariantId(variantId);
      var numericCents = Number(cents);

      if (!key || !Number.isFinite(numericCents) || numericCents < 0) return null;

      liveVariantPriceCentsById[key] = Math.round(numericCents);
      syncKnownLivePriceVariable(key, liveVariantPriceCentsById[key]);
      return liveVariantPriceCentsById[key];
    }

    function getLiveVariantPriceCents(variantId) {
      var key = normaliseVariantId(variantId);
      if (!key || !Object.prototype.hasOwnProperty.call(liveVariantPriceCentsById, key)) {
        return null;
      }

      return liveVariantPriceCentsById[key];
    }

    function fetchLiveVariantPrice(variantId, forceRefresh) {
      var key = normaliseVariantId(variantId);
      if (!key) return Promise.reject(new Error('Invalid Shopify variant ID.'));

      if (!forceRefresh && Object.prototype.hasOwnProperty.call(liveVariantPriceCentsById, key)) {
        return Promise.resolve(liveVariantPriceCentsById[key]);
      }

      if (!forceRefresh && liveVariantPriceRequestById[key]) {
        return liveVariantPriceRequestById[key];
      }

      var request = fetch('/variants/' + encodeURIComponent(key) + '.js?rental_live_price=' + Date.now(), {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Cache-Control': 'no-cache'
        },
        cache: 'no-store'
      })
        .then(function (response) {
          setTrustedNowFromResponse(response);

          if (!response.ok) {
            throw new Error('Unable to read Shopify variant ' + key + '.');
          }

          return response.json();
        })
        .then(function (variantData) {
          if (!variantData || normaliseVariantId(variantData.id) !== key) {
            throw new Error('Shopify returned the wrong variant for ' + key + '.');
          }

          var cents = parseLiveVariantPriceCents(variantData);
          if (!Number.isFinite(cents)) {
            throw new Error('Shopify variant ' + key + ' returned an invalid price.');
          }

          return cacheLiveVariantPrice(key, cents);
        })
        .finally(function () {
          delete liveVariantPriceRequestById[key];
        });

      liveVariantPriceRequestById[key] = request;
      return request;
    }

    function uniqueVariantIds(values) {
      var seen = {};

      return (values || []).map(normaliseVariantId).filter(function (variantId) {
        if (!variantId || seen[variantId]) return false;
        seen[variantId] = true;
        return true;
      });
    }

    function loadLiveVariantPrices(variantIds, forceRefresh) {
      var ids = uniqueVariantIds(variantIds);

      return Promise.all(ids.map(function (variantId) {
        return fetchLiveVariantPrice(variantId, !!forceRefresh);
      }));
    }

    function loadLiveVariantPricesBestEffort(variantIds, forceRefresh) {
      var ids = uniqueVariantIds(variantIds);

      return Promise.all(ids.map(function (variantId) {
        return fetchLiveVariantPrice(variantId, !!forceRefresh).catch(function (error) {
          console.error('Live Shopify price lookup failed for variant ' + variantId + ':', error);
          return null;
        });
      }));
    }

    function setRentalPriceRowValue(row, variantId) {
      if (!row) return;

      var valueElement = row.querySelector('.rental-price-value');
      if (!valueElement) return;

      var cents = getLiveVariantPriceCents(variantId);
      valueElement.textContent = Number.isFinite(cents) ? formatMoney(cents) : 'Loading…';
    }

    function syncLiveVariantPriceRows() {
      setRentalPriceRowValue(surchargeRow, weekendSurchargeVariantId);
      setRentalPriceRowValue(earlyDeliveryRow, earlyDeliveryVariantId);
      setRentalPriceRowValue(priorityUrgentChargeRow, priorityUrgentChargeVariantId);
      setRentalPriceRowValue(standardUrgentChargeRow, standardUrgentChargeVariantId);
      setRentalPriceRowValue(standardReturnExtensionRow, standardReturnExtensionVariantId);
      setRentalPriceRowValue(priorityReturnExtensionRow, priorityReturnExtensionVariantId);
      setRentalPriceRowValue(memoryAddonRow, memoryAddonVariantId);
      setRentalPriceRowValue(officeAddonRow, officeAddonVariantId);
      setRentalPriceRowValue(appleMouseAddonRow, appleMouseAddonVariantId);
      setRentalPriceRowValue(hdmiAddonRow, hdmiAddonVariantId);
      if (cellularAddonRow) cellularAddonRow.style.display = 'none';
      setRentalPriceRowValue(pencilAddonRow, pencilAddonVariantId);
      syncReturnTimingOptionPrices();
    }

    function getInitialLivePriceVariantIds() {
      var ids = [
        variantIdInput ? variantIdInput.value : '',
        weekendSurchargeVariantId,
        earlyDeliveryVariantId,
        standardUrgentChargeVariantId,
        priorityUrgentChargeVariantId,
        standardReturnExtensionVariantId,
        priorityReturnExtensionVariantId
      ];

      if (memoryAddonInput) ids.push(memoryAddonVariantId);
      if (officeAddonInput) ids.push(officeAddonVariantId);
      if (appleMouseAddonInput) ids.push(appleMouseAddonVariantId);
      if (hdmiAddonInput) ids.push(hdmiAddonVariantId);
      if (pencilAddonInput) {
        pencilAddonVariantPriority.forEach(function (config) {
          ids.push(config.variantId);
        });
      }

      var depositConfig = getSecurityDepositConfig();
      if (depositConfig && depositConfig.variantId) ids.push(depositConfig.variantId);

      ids = ids.concat(getSelectedModelRentalPeriodVariantIds());

      return uniqueVariantIds(ids);
    }

    function getRequiredLivePriceVariantIdsForCurrentSelection() {
      var ids = [
        variantIdInput ? variantIdInput.value : ''
      ];
      var depositConfig = getSecurityDepositConfig();

      if (depositConfig && depositConfig.variantId) ids.push(depositConfig.variantId);
      if (weekendApplied()) ids.push(weekendSurchargeVariantId);
      if (earlyDeliveryApplied()) ids.push(earlyDeliveryVariantId);
      if (priorityUrgentChargeApplied()) ids.push(priorityUrgentChargeVariantId);
      if (standardUrgentChargeApplied()) ids.push(standardUrgentChargeVariantId);
      if (standardReturnExtensionApplied()) ids.push(standardReturnExtensionVariantId);
      if (priorityReturnExtensionApplied()) ids.push(priorityReturnExtensionVariantId);
      if (memoryAddonApplied()) ids.push(memoryAddonVariantId);
      if (officeAddonApplied()) ids.push(officeAddonVariantId);
      if (appleMouseAddonApplied()) ids.push(appleMouseAddonVariantId);
      if (hdmiAddonApplied()) ids.push(hdmiAddonVariantId);
      if (pencilAddonApplied()) ids.push(pencilAddonVariantId);

      ids = ids.concat(getSelectedModelRentalPeriodVariantIds());

      return uniqueVariantIds(ids);
    }

    function applySelectedRentalVariantLivePrice() {
      if (!variantIdInput) return;

      var cents = getLiveVariantPriceCents(variantIdInput.value);
      if (Number.isFinite(cents)) {
        setBasePrice(cents);
      }
    }

    function refreshUiAfterLiveVariantPrices() {
      var selectedPeriodWasHidden = applyMinimumRentalPeriodRule();

      syncRentalPeriodSelectFromRadio();
      syncRentalPeriodSelectDisabledOptions();
      updateSelectedCards();

      if (!selectedPeriodWasHidden) {
        applySelectedRentalVariantLivePrice();
      }

      syncLiveVariantPriceRows();
      rebuildDeliveryOptions();
      updateRentalEndInfo();
      updateTotal();
    }

    function loadInitialLiveVariantPrices() {
      return loadLiveVariantPricesBestEffort(getInitialLivePriceVariantIds(), false)
        .then(function () {
          refreshUiAfterLiveVariantPrices();
        });
    }

    function loadSelectedVariantAndDepositPrices(forceRefresh) {
      var ids = [variantIdInput ? variantIdInput.value : ''];
      var depositConfig = getSecurityDepositConfig();

      if (depositConfig && depositConfig.variantId) ids.push(depositConfig.variantId);
      ids = ids.concat(getSelectedModelRentalPeriodVariantIds());

      return loadLiveVariantPrices(ids, !!forceRefresh)
        .then(function () {
          refreshUiAfterLiveVariantPrices();
        });
    }

    function getSelectedOptions() {
      var selected = getRawSelectedOptions();
      var processorIndex = getRentalProcessorOptionIndex();

      if (isIpadRentalPage() && processorIndex >= 0) {
        var effectiveProcessor = getEffectiveIpadProcessorValue();
        if (effectiveProcessor) selected[processorIndex] = effectiveProcessor;
      }

      return selected;
    }

    function findMatchingVariant() {
      var selectedOptions = getSelectedOptions();

      return allVariants.find(function (variant) {
        return variant.options.every(function (optionValue, index) {
          return optionValue === selectedOptions[index];
        });
      });
    }

    function updateSelectedCards() {
      document.querySelectorAll('.rental-option-card').forEach(function (card) {
        card.classList.remove('is-selected');
      });

      document.querySelectorAll('.rental-option-radio:checked').forEach(function (input) {
        var card = input.closest('.rental-option-card');
        if (card) card.classList.add('is-selected');
      });
    }

    function updateAddonCards() {
      document.querySelectorAll('.rental-addon-card').forEach(function (card) {
        var input = card.querySelector('.rental-addon-checkbox');
        card.classList.toggle('is-selected', !!(input && input.checked));
      });

      if (isIpadRentalPage() && cellularAddonInput) {
        var cellularTitle = getCellularAddonTitleElement();
        if (cellularTitle) cellularTitle.textContent = 'Cellular';
      }
    }

    function dispatchRentalInputChange(input) {
      if (!input) return;

      if (typeof Event === 'function') {
        input.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      var event = document.createEvent('Event');
      event.initEvent('change', true, true);
      input.dispatchEvent(event);
    }

    function normaliseMinimumRentalPeriodText(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();
    }

    function getRentalPeriodComparableDays(value) {
      var text = normaliseMinimumRentalPeriodText(value);
      var match = text.match(/(\d+)\s*(day|week|month)s?/i);

      if (!match) return 0;

      var amount = parseInt(match[1], 10);
      if (!isFinite(amount) || amount < 1) return 0;

      if (match[2].toLowerCase() === 'week') return amount * 7;
      if (match[2].toLowerCase() === 'month') return amount * 30;
      return amount;
    }

    function getSelectedProcessorDisplayValue() {
      var optionPosition = rentalProcessorSelect
        ? rentalProcessorSelect.getAttribute('data-option-position')
        : '';
      var checked = Array.prototype.find.call(optionInputs, function (input) {
        return input.getAttribute('data-option-position') === optionPosition && input.checked;
      });

      if (checked && checked.value) return String(checked.value).trim();

      if (rentalProcessorSelect && rentalProcessorSelect.value) {
        return String(rentalProcessorSelect.value).trim();
      }

      return '';
    }

    function getRentalOptionIndexFromSelect(selectElement) {
      if (!selectElement) return -1;

      var position = parseInt(selectElement.getAttribute('data-option-position'), 10);
      return Number.isFinite(position) && position > 0 ? position - 1 : -1;
    }

    function getSelectedModelRentalPeriodVariants() {
      var periodIndex = getRentalOptionIndexFromSelect(rentalPeriodSelect);
      var selectedOptions = getSelectedOptions();
      var recordsByPeriod = {};

      if (periodIndex < 0) return [];

      allVariants.forEach(function (variant) {
        if (!variant || !Array.isArray(variant.options)) return;

        var matchesSelectedModel = variant.options.every(function (optionValue, index) {
          if (index === periodIndex) return true;

          var selectedValue = selectedOptions[index];
          return !selectedValue || optionValue === selectedValue;
        });

        if (!matchesSelectedModel) return;

        var period = String(variant.options[periodIndex] || '').trim();
        var days = getRentalPeriodComparableDays(period);
        var variantId = normaliseVariantId(variant.id);

        if (!period || !days || !variantId) return;

        var key = normaliseMinimumRentalPeriodText(period);
        if (!recordsByPeriod[key]) {
          recordsByPeriod[key] = {
            variant: variant,
            variantId: variantId,
            period: period,
            days: days
          };
        }
      });

      return Object.keys(recordsByPeriod)
        .map(function (key) { return recordsByPeriod[key]; })
        .sort(function (a, b) { return a.days - b.days; });
    }

    function getSelectedModelRentalPeriodVariantIds() {
      return getSelectedModelRentalPeriodVariants().map(function (record) {
        return record.variantId;
      });
    }

    function getRentalPeriodVariantPriceCents(record) {
      if (!record) return null;

      var livePrice = getLiveVariantPriceCents(record.variantId);
      if (Number.isFinite(livePrice)) return livePrice;

      return parseLiveVariantPriceCents(record.variant);
    }

    function getSelectedMinimumRentalPeriodRule() {
      var selectedModel = getSelectedProcessorDisplayValue();
      var records = getSelectedModelRentalPeriodVariants();

      if (!selectedModel || records.length < 2) return null;

      var firstPrice = getRentalPeriodVariantPriceCents(records[0]);
      if (!Number.isFinite(firstPrice)) return null;

      var longestMatchingIndex = 0;

      for (var index = 1; index < records.length; index += 1) {
        var currentPrice = getRentalPeriodVariantPriceCents(records[index]);

        if (!Number.isFinite(currentPrice)) return null;
        if (currentPrice !== firstPrice) break;

        longestMatchingIndex = index;
      }

      if (longestMatchingIndex === 0) return null;

      var minimumRecord = records[longestMatchingIndex];

      return {
        model: selectedModel,
        minimumPeriod: minimumRecord.period,
        minimumDays: minimumRecord.days,
        matchingPriceCents: firstPrice
      };
    }

    function applyMinimumRentalPeriodRule() {
      if (!rentalPeriodSelect) return false;

      removeLegacyRentalPeriodPriceNote();

      var periodRecords = getSelectedModelRentalPeriodVariants();
      var periodRecordByKey = {};

      periodRecords.forEach(function (record) {
        periodRecordByKey[normaliseMinimumRentalPeriodText(record.period)] = record;
      });

      var rule = getSelectedMinimumRentalPeriodRule();
      var minimumDays = rule && rule.minimumDays ? rule.minimumDays : 0;
      var selectedPeriodWasHidden = false;
      var optionPosition = getRentalPeriodSelectPosition();
      var selectedPeriodValue = rentalPeriodSelect.value;

      Array.prototype.forEach.call(optionInputs, function (input) {
        if (input.getAttribute('data-option-position') !== optionPosition) return;

        if (!input.hasAttribute('data-minimum-period-original-disabled')) {
          input.setAttribute(
            'data-minimum-period-original-disabled',
            input.disabled ? 'true' : 'false'
          );
        }

        var periodDays = getRentalPeriodComparableDays(input.value);
        var hideForMinimum = minimumDays > 0 && periodDays > 0 && periodDays < minimumDays;
        var originallyDisabled = input.getAttribute('data-minimum-period-original-disabled') === 'true';
        var card = input.closest('.rental-option-card');

        if (hideForMinimum && input.checked) {
          input.checked = false;
          selectedPeriodWasHidden = true;
        }

        input.disabled = originallyDisabled || hideForMinimum;
        input.setAttribute('data-minimum-period-hidden', hideForMinimum ? 'true' : 'false');

        if (card) {
          card.hidden = hideForMinimum;
          card.style.display = hideForMinimum ? 'none' : '';
          card.setAttribute('aria-hidden', hideForMinimum ? 'true' : 'false');
        }
      });

      rentalPeriodSelect.innerHTML = '';
      rentalPeriodOriginalOptions.forEach(function (optionRecord) {
        var option = optionRecord.option;
        var periodDays = getRentalPeriodComparableDays(option.value);
        var hideForMinimum = minimumDays > 0 && periodDays > 0 && periodDays < minimumDays;
        var periodRecord = periodRecordByKey[normaliseMinimumRentalPeriodText(option.value)];
        var livePriceCents = getRentalPeriodVariantPriceCents(periodRecord);
        var isDetectedMinimum = !!(
          rule &&
          periodRecord &&
          periodRecord.days === rule.minimumDays
        );
        var baseOptionText = String(optionRecord.originalText || option.value || '').trim();

        if (isDetectedMinimum) {
          option.textContent = baseOptionText + ' — Minimum for this model';
        } else {
          option.textContent = baseOptionText;
        }

        if (hideForMinimum) {
          if (option.value === selectedPeriodValue) selectedPeriodWasHidden = true;
          return;
        }

        option.disabled = !!optionRecord.originallyDisabled;
        rentalPeriodSelect.appendChild(option);
      });

      var replacementPeriodValue = '';

      if (selectedPeriodWasHidden) {
        var replacementInput = rule && rule.minimumPeriod
          ? findRentalPeriodRadioByValue(rule.minimumPeriod)
          : null;

        if (
          !replacementInput ||
          replacementInput.disabled ||
          replacementInput.getAttribute('data-minimum-period-hidden') === 'true'
        ) {
          replacementInput = Array.prototype.find.call(optionInputs, function (input) {
            return input.getAttribute('data-option-position') === optionPosition &&
              !input.disabled &&
              input.getAttribute('data-minimum-period-hidden') !== 'true';
          });
        }

        if (replacementInput) {
          replacementInput.checked = true;
          replacementPeriodValue = replacementInput.value;
          rentalPeriodSelect.value = replacementPeriodValue;

          var replacementVariant = findMatchingVariant();
          if (replacementVariant) {
            if (variantIdInput) variantIdInput.value = replacementVariant.id;

            var replacementLivePrice = getLiveVariantPriceCents(replacementVariant.id);
            if (basePriceEl) {
              setBasePrice(
                Number.isFinite(replacementLivePrice)
                  ? replacementLivePrice
                  : replacementVariant.price
              );
            }
          }
        } else {
          rentalPeriodSelect.value = '';
          if (variantIdInput) variantIdInput.value = '';
          if (basePriceEl) setBasePrice(0);
        }
      } else if (selectedPeriodValue) {
        rentalPeriodSelect.value = selectedPeriodValue;
      }

      var existingMinimumNote = document.getElementById('RentalMinimumPeriodNote');
      if (existingMinimumNote && existingMinimumNote.parentNode) {
        existingMinimumNote.parentNode.removeChild(existingMinimumNote);
      }

      return selectedPeriodWasHidden && !replacementPeriodValue;
    }

    function getRentalPeriodSelectPosition() {
      return rentalPeriodSelect ? rentalPeriodSelect.getAttribute('data-option-position') : '';
    }

    function findRentalPeriodRadioByValue(value) {
      var optionPosition = getRentalPeriodSelectPosition();

      return Array.prototype.find.call(optionInputs, function (input) {
        return input.getAttribute('data-option-position') === optionPosition && input.value === value;
      });
    }

    function syncRentalPeriodSelectFromRadio() {
      if (!rentalPeriodSelect) return;

      var optionPosition = getRentalPeriodSelectPosition();
      var checked = Array.prototype.find.call(optionInputs, function (input) {
        return input.getAttribute('data-option-position') === optionPosition && input.checked;
      });

      if (checked) {
        rentalPeriodSelect.value = checked.value;
      }
    }

    function syncRentalPeriodSelectDisabledOptions() {
      if (!rentalPeriodSelect) return;

      Array.prototype.forEach.call(rentalPeriodSelect.options, function (option) {
        var matchingRadio = findRentalPeriodRadioByValue(option.value);
        option.disabled = !!(matchingRadio && matchingRadio.disabled);
      });
    }

    function handleRentalPeriodSelectChange() {
      if (!rentalPeriodSelect) return;

      var matchingRadio = findRentalPeriodRadioByValue(rentalPeriodSelect.value);
      if (!matchingRadio || matchingRadio.disabled) {
        syncRentalPeriodSelectFromRadio();
        return;
      }

      matchingRadio.checked = true;
      dispatchRentalInputChange(matchingRadio);
    }

    function getRentalProcessorSelectPosition() {
      return rentalProcessorSelect ? rentalProcessorSelect.getAttribute('data-option-position') : '';
    }

    function findRentalProcessorRadioByValue(value) {
      var optionPosition = getRentalProcessorSelectPosition();

      return Array.prototype.find.call(optionInputs, function (input) {
        return input.getAttribute('data-option-position') === optionPosition && input.value === value;
      });
    }

    function syncRentalProcessorSelectFromRadio() {
      if (!rentalProcessorSelect) return;

      var optionPosition = getRentalProcessorSelectPosition();
      var checked = Array.prototype.find.call(optionInputs, function (input) {
        return input.getAttribute('data-option-position') === optionPosition && input.checked;
      });

      if (checked) {
        rentalProcessorSelect.value = checked.value;
      }

      updateRentalProcessorClosedDisplay();
    }

    function syncRentalProcessorSelectDisabledOptions() {
      if (!rentalProcessorSelect) return;

      Array.prototype.forEach.call(rentalProcessorSelect.options, function (option) {
        var matchingRadio = findRentalProcessorRadioByValue(option.value);
        var unavailable = !!(matchingRadio && matchingRadio.disabled);
        var isCustomerFacingIpadProcessor = !!(
          isIpadRentalPage() &&
          String(option.value || '').trim() &&
          !isIpadCellularProcessorValue(option.value)
        );
        var hideUnavailableIpadProcessor = isCustomerFacingIpadProcessor && unavailable;

        option.disabled = unavailable;
        option.setAttribute('aria-disabled', unavailable ? 'true' : 'false');

        option.hidden = hideUnavailableIpadProcessor;
        if (hideUnavailableIpadProcessor) {
          option.style.display = 'none';
          option.setAttribute('aria-hidden', 'true');
        } else if (!isIpadCellularProcessorValue(option.value)) {
          option.style.removeProperty('display');
          option.removeAttribute('aria-hidden');
        }
      });

      updateProcessorAvailabilityNote();
    }

    function handleRentalProcessorSelectChange() {
      if (!rentalProcessorSelect) return;

      updateRentalProcessorClosedDisplay();

      var matchingRadio = findRentalProcessorRadioByValue(rentalProcessorSelect.value);
      if (!matchingRadio || matchingRadio.disabled) {
        syncRentalProcessorSelectFromRadio();
        return;
      }

      matchingRadio.checked = true;
      dispatchRentalInputChange(matchingRadio);
    }

    function getTapPoint(event) {
      var touch = event.changedTouches && event.changedTouches.length
        ? event.changedTouches[0]
        : null;

      return {
        x: touch ? touch.clientX : event.clientX,
        y: touch ? touch.clientY : event.clientY
      };
    }

    function bindRentalCardSingleTap(card, input, isCheckbox) {
      if (!card || !input || card.getAttribute('data-rental-tap-bound') === 'true') return;

      var startPoint = null;
      var lastTouchActivation = 0;

      function rememberTapStart(event) {
        startPoint = getTapPoint(event);
      }

      function movedTooMuch(event) {
        if (!startPoint) return false;

        var point = getTapPoint(event);
        if (typeof point.x !== 'number' || typeof point.y !== 'number') return false;

        return Math.abs(point.x - startPoint.x) > 12 || Math.abs(point.y - startPoint.y) > 12;
      }

      function activateCard(event) {
        var now = Date.now();

        if (event.type === 'click' && now - lastTouchActivation < 700) {
          event.preventDefault();
          return;
        }

        if ((event.type === 'pointerup' || event.type === 'touchend') && movedTooMuch(event)) {
          return;
        }

        if (event.cancelable) {
          event.preventDefault();
        }

        if (input.disabled || card.classList.contains('is-rental-stock-unavailable')) {
          return;
        }

        if (event.type === 'pointerup' || event.type === 'touchend') {
          lastTouchActivation = now;
        }

        if (isCheckbox) {
          if (input.getAttribute('data-cellular-forced') === 'true') {
            return;
          }

          input.checked = !input.checked;
          updateAddonCards();
          dispatchRentalInputChange(input);
          return;
        }

        if (!input.checked) {
          input.checked = true;
          dispatchRentalInputChange(input);
        }
      }

      card.setAttribute('data-rental-tap-bound', 'true');

      if (window.PointerEvent) {
        card.addEventListener('pointerdown', rememberTapStart, { passive: true });
        card.addEventListener('pointerup', activateCard);
      } else {
        card.addEventListener('touchstart', rememberTapStart, { passive: true });
        card.addEventListener('touchend', activateCard, { passive: false });
      }

      card.addEventListener('click', activateCard);
    }

    function bindRentalCardTapHandlers() {
      document.querySelectorAll('.rental-option-card').forEach(function (card) {
        bindRentalCardSingleTap(card, card.querySelector('.rental-option-radio'), false);
      });

      document.querySelectorAll('.rental-addon-card').forEach(function (card) {
        bindRentalCardSingleTap(card, card.querySelector('.rental-addon-checkbox'), true);
      });
    }

    function formatMoney(cents) {
      var numericCents = Number(cents);
      if (!Number.isFinite(numericCents)) numericCents = 0;

      return '$' + (numericCents / 100).toLocaleString('en-SG', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }

    function formatFinalRentalTotalMoney(cents) {
      var numericCents = Number(cents);
      if (!Number.isFinite(numericCents)) numericCents = 0;

      return 'S$' + (numericCents / 100).toLocaleString('en-SG', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }

    function formatCompactMoney(cents) {
      var numericCents = Number(cents);
      if (!Number.isFinite(numericCents)) return '';

      var amount = numericCents / 100;
      return '$' + amount.toLocaleString('en-SG', {
        minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
        maximumFractionDigits: 2
      });
    }

    function stripDeliveryChargeSuffix(value) {
      return String(value || '')
        .replace(/\s*\((?:Early Delivery|Priority Urgent Delivery|Standard Urgent Delivery|Priority Urgent Charge|Standard Urgent Charge)(?:\s+\+\$[\d,]+(?:\.\d{1,2})?)?\)\s*$/i, '')
        .trim();
    }

    function formatTimingOptionChargeLabel(baseLabel, chargeLabel, cents) {
      var price = formatCompactMoney(cents);
      return baseLabel + ' (' + chargeLabel + (price ? ' +' + price : '') + ')';
    }

    function syncReturnTimingOptionPrices() {
      if (!returnTimeInput) return;

      Array.prototype.forEach.call(returnTimeInput.options, function (option) {
        if (option.value === '1pm–3pm') {
          option.textContent = formatTimingOptionChargeLabel(
            '1pm–3pm',
            'Standard Return Extension',
            standardReturnExtensionCents
          );
        }

        if (option.value === '3pm–5pm') {
          option.textContent = formatTimingOptionChargeLabel(
            '3pm–5pm',
            'Priority Return Extension',
            priorityReturnExtensionCents
          );
        }
      });
    }

    function getBasePrice() {
      return parseInt(basePriceEl.getAttribute('data-base-price'), 10) || 0;
    }

    function setBasePrice(cents) {
      basePriceEl.setAttribute('data-base-price', String(cents));
      basePriceEl.textContent = formatMoney(cents);
      removeLegacyRentalPeriodPriceNote();
    }

    var rentalStartDateBlockedDates = [

    ];

    var rentalStartDateBlockedRanges = [

    ];

    function getRentalStartDateMaxString() {
      var singaporeNow = getSingaporeNowParts();
      return singaporeNow.year + '-12-31';
    }

    function isRentalStartDateBlocked(dateString) {
      if (!dateString) return false;

      if (rentalStartDateBlockedDates.indexOf(dateString) !== -1) {
        return true;
      }

      var selected = parseLocalDate(dateString);
      if (!selected) return false;

      for (var index = 0; index < rentalStartDateBlockedRanges.length; index += 1) {
        var range = rentalStartDateBlockedRanges[index];
        if (!range || !range.start || !range.end) continue;

        var rangeStart = parseLocalDate(range.start);
        var rangeEnd = parseLocalDate(range.end);
        if (!rangeStart || !rangeEnd) continue;

        if (selected >= rangeStart && selected <= rangeEnd) {
          return true;
        }
      }

      return false;
    }

    function isWeekend(dateString) {
      if (!dateString) return false;
      var parts = dateString.split('-');
      if (parts.length !== 3) return false;
      var date = new Date(parts[0], parts[1] - 1, parts[2]);
      var day = date.getDay();
      return day === 0 || day === 6;
    }

    function getRentalStartDateInvalidReason(dateString) {
      if (!dateString) return 'empty';

      var selected = parseLocalDate(dateString);
      var minDate = parseLocalDate(getRentalStartDateMinimumString());
      var maxDate = parseLocalDate(getRentalStartDateMaxString());
      if (!selected || !minDate || !maxDate) return 'invalid';

      if (selected < minDate) {
        if (dateString === getSingaporeTodayString()) {
          return playTimeSameDayEnabled ? 'same-day-closed' : 'same-day-unavailable';
        }

        return 'past';
      }

      if (selected > maxDate) return 'out-of-year';
      if (isRentalStartDateBlocked(dateString)) return 'blocked';

      return '';
    }

    function getRentalStartDateErrorMessage(dateString) {
      var reason = getRentalStartDateInvalidReason(dateString);

      if (reason === 'blocked') {
        return 'This rental start date has been blocked out. Please choose another available date.';
      }

      if (reason === 'out-of-year') {
        return 'Please choose a rental start date within this calendar year.';
      }

      if (reason === 'same-day-unavailable') {
        
        if (getSelectedSecurityDepositLeadDays() > 0) return '';
        return 'Same-day bookings are not available online. Please contact us directly via WhatsApp.';
      }

      if (reason === 'same-day-closed') {
        
        if (getSelectedSecurityDepositLeadDays() > 0) return '';
        return 'Online same-day checkout is closed for today. Please contact us directly via WhatsApp.';
      }

      if (reason === 'past') {
        return 'Please choose a valid rental start date.';
      }

      if (reason === 'empty') {
        return '';
      }

      if (reason === 'invalid') {
        return 'Please choose a valid rental start date.';
      }

      return '';
    }

    function showRentalStartDateError(message) {
      if (!dateError) return;
      dateError.textContent = message || 'Please choose a valid rental start date.';
      dateError.hidden = false;
    }

    function isInvalidDate(dateString) {
      return !!getRentalStartDateInvalidReason(dateString);
    }

    function getTomorrowString() {
      return getRentalStartDateMinimumString();
    }

    function isIOSDatePickerDevice() {
      var userAgent = window.navigator.userAgent || '';
      var platform = window.navigator.platform || '';
      var maxTouchPoints = window.navigator.maxTouchPoints || 0;

      return /iPad|iPhone|iPod/i.test(userAgent) || (platform === 'MacIntel' && maxTouchPoints > 1);
    }

    function getMonthStart(date) {
      return new Date(date.getFullYear(), date.getMonth(), 1);
    }

    function sameCalendarDay(firstDate, secondDate) {
      if (!firstDate || !secondDate) return false;
      return firstDate.getFullYear() === secondDate.getFullYear()
        && firstDate.getMonth() === secondDate.getMonth()
        && firstDate.getDate() === secondDate.getDate();
    }

    function setRentalStartDateDisplayText() {
      if (!rentalStartDateDisplayText || !startDateInput) return;

      var selectedDate = parseLocalDate(startDateInput.value);
      rentalStartDateDisplayText.textContent = selectedDate
        ? formatDisplayDate(selectedDate)
        : 'Select rental start date';
    }

    function setRentalMobileCalendarOpen(isOpen) {
      if (!rentalMobileCalendar || !rentalStartDateDisplay) return;

      if (isOpen) {
        rentalMobileCalendar.hidden = false;
        rentalStartDateDisplay.setAttribute('aria-expanded', 'true');
        renderRentalMobileCalendar();
      } else {
        rentalMobileCalendar.hidden = true;
        rentalStartDateDisplay.setAttribute('aria-expanded', 'false');
      }
    }

    function setupCustomRentalDatePicker() {
      if (!useCustomRentalDatePicker || !startDateInput || !rentalStartDateDisplay || !rentalMobileCalendar) return;

      var root = document.querySelector('.rental-product-page');
      if (root) {
        root.classList.add('is-custom-rental-datepicker');
      }

      rentalStartDateDisplay.hidden = false;
      startDateInput.setAttribute('aria-hidden', 'true');
      startDateInput.setAttribute('tabindex', '-1');
      setRentalStartDateDisplayText();
      renderRentalMobileCalendar();
    }

    function prepareRentalCalendarView() {
      refreshRentalStartDateMinimum(true);

      var calendarDefaultDate = parseLocalDate(startDateInput.value) || parseLocalDate(getTomorrowString());
      var calendarMaxDate = parseLocalDate(getRentalStartDateMaxString());

      if (calendarDefaultDate && calendarMaxDate && calendarDefaultDate > calendarMaxDate) {
        calendarDefaultDate = calendarMaxDate;
      }

      rentalMobileCalendarViewDate = getMonthStart(calendarDefaultDate);
    }

    function openRentalStartDateCalendar() {
      if (!useCustomRentalDatePicker || !rentalMobileCalendar) return;

      prepareRentalCalendarView();
      setRentalMobileCalendarOpen(true);

      if (rentalStartDateDisplay) {
        rentalStartDateDisplay.focus({ preventScroll: true });
      }
    }

    function toggleRentalStartDateCalendar() {
      if (!useCustomRentalDatePicker || !rentalMobileCalendar) return;

      prepareRentalCalendarView();
      setRentalMobileCalendarOpen(rentalMobileCalendar.hidden);
    }

    function renderRentalMobileCalendar() {
      if (!useCustomRentalDatePicker || !startDateInput || !rentalMobileCalendarGrid || !rentalMobileCalendarTitle) return;

      var minDate = parseLocalDate(getTomorrowString());
      var maxDate = parseLocalDate(getRentalStartDateMaxString());
      var selectedDate = parseLocalDate(startDateInput.value);
      var noAvailableDates = !!(minDate && maxDate && minDate > maxDate);
      var minMonthStart = getMonthStart(noAvailableDates ? maxDate : minDate);
      var maxMonthStart = getMonthStart(maxDate);
      var preferredDate = selectedDate || (noAvailableDates ? maxDate : minDate);

      if (!rentalMobileCalendarViewDate) {
        rentalMobileCalendarViewDate = getMonthStart(preferredDate);
      }

      rentalMobileCalendarViewDate = getMonthStart(rentalMobileCalendarViewDate);

      if (rentalMobileCalendarViewDate < minMonthStart) {
        rentalMobileCalendarViewDate = minMonthStart;
      }

      if (rentalMobileCalendarViewDate > maxMonthStart) {
        rentalMobileCalendarViewDate = maxMonthStart;
      }

      var viewYear = rentalMobileCalendarViewDate.getFullYear();
      var viewMonth = rentalMobileCalendarViewDate.getMonth();
      var monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];

      rentalMobileCalendarTitle.textContent = monthNames[viewMonth] + ' ' + viewYear;
      rentalMobileCalendarGrid.innerHTML = '';

      var firstDay = new Date(viewYear, viewMonth, 1);
      var leadingEmptyDays = firstDay.getDay();
      var daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();

      for (var blankIndex = 0; blankIndex < leadingEmptyDays; blankIndex += 1) {
        var blankCell = document.createElement('span');
        blankCell.className = 'rental-mobile-calendar-empty';
        rentalMobileCalendarGrid.appendChild(blankCell);
      }

      for (var dayNumber = 1; dayNumber <= daysInMonth; dayNumber += 1) {
        (function (day) {
          var dayDate = new Date(viewYear, viewMonth, day);
          dayDate.setHours(0, 0, 0, 0);

          var dayDateString = formatDateProperty(dayDate);
          var invalidReason = noAvailableDates ? 'unavailable' : getRentalStartDateInvalidReason(dayDateString);
          var disabled = !!invalidReason;
          var selected = selectedDate && sameCalendarDay(dayDate, selectedDate);
          var dayButton = document.createElement('button');

          dayButton.type = 'button';
          dayButton.className = 'rental-mobile-calendar-day';
          dayButton.textContent = String(day);

          if (disabled) {
            dayButton.setAttribute('aria-disabled', 'true');
            dayButton.setAttribute('tabindex', '-1');
            dayButton.classList.add('is-disabled');

            if (invalidReason === 'blocked') {
              dayButton.classList.add('is-blocked');
              dayButton.setAttribute('aria-label', dayDateString + ' blocked out');
            } else if (invalidReason === 'past') {
              dayButton.classList.add('is-past');
              dayButton.setAttribute('aria-label', dayDateString + ' unavailable');
            } else if (invalidReason === 'out-of-year') {
              dayButton.classList.add('is-out-of-year');
              dayButton.setAttribute('aria-label', dayDateString + ' outside this calendar year');
            }

            dayButton.addEventListener('click', function () {
              var blockedMessage = invalidReason === 'unavailable'
                ? 'There are no available rental start dates left within this calendar year.'
                : getRentalStartDateErrorMessage(dayDateString);
              showRentalStartDateError(blockedMessage);
            });
          } else {
            dayButton.addEventListener('click', function () {
              startDateInput.value = dayDateString;
              setRentalStartDateDisplayText();
              setRentalMobileCalendarOpen(false);
              if (dateError) dateError.hidden = true;
              dispatchRentalInputChange(startDateInput);
            });
          }

          if (selected) {
            dayButton.classList.add('is-selected');
            dayButton.setAttribute('aria-current', 'date');
          }

          rentalMobileCalendarGrid.appendChild(dayButton);
        })(dayNumber);
      }

      if (rentalMobileCalendarPrev) {
        var previousMonthStart = new Date(viewYear, viewMonth - 1, 1);
        var previousDisabled = noAvailableDates || previousMonthStart < minMonthStart;
        rentalMobileCalendarPrev.disabled = previousDisabled;
        rentalMobileCalendarPrev.classList.toggle('is-disabled', previousDisabled);
      }

      if (rentalMobileCalendarNext) {
        var nextMonthStart = new Date(viewYear, viewMonth + 1, 1);
        var nextDisabled = noAvailableDates || nextMonthStart > maxMonthStart;
        rentalMobileCalendarNext.disabled = nextDisabled;
        rentalMobileCalendarNext.classList.toggle('is-disabled', nextDisabled);
      }
    }

    function changeRentalCalendarMonth(monthOffset) {
      if (!rentalMobileCalendarViewDate) {
        var defaultCalendarDate = parseLocalDate(startDateInput.value) || parseLocalDate(getTomorrowString());
        var maxCalendarDate = parseLocalDate(getRentalStartDateMaxString());
        if (defaultCalendarDate && maxCalendarDate && defaultCalendarDate > maxCalendarDate) {
          defaultCalendarDate = maxCalendarDate;
        }
        rentalMobileCalendarViewDate = getMonthStart(defaultCalendarDate);
      }

      rentalMobileCalendarViewDate = new Date(
        rentalMobileCalendarViewDate.getFullYear(),
        rentalMobileCalendarViewDate.getMonth() + monthOffset,
        1
      );

      renderRentalMobileCalendar();
    }

    function refreshRentalStartDateMinimum(clearInvalidValue) {
      if (!startDateInput) return '';

      var minDateString = getTomorrowString();
      var maxDateString = getRentalStartDateMaxString();

      startDateInput.setAttribute('min', minDateString);
      startDateInput.min = minDateString;
      startDateInput.setAttribute('max', maxDateString);
      startDateInput.max = maxDateString;
      startDateInput.setAttribute('step', '1');

      if (clearInvalidValue && startDateInput.value && isInvalidDate(startDateInput.value)) {
        startDateInput.value = '';
      }

      return minDateString;
    }

    function rejectInvalidRentalStartDateSelection() {
      if (!startDateInput || !startDateInput.value || !isInvalidDate(startDateInput.value)) {
        return false;
      }

      var errorMessage = getRentalStartDateErrorMessage(startDateInput.value);
      startDateInput.value = '';
      setRentalStartDateDisplayText();

      if (errorMessage) {
        showRentalStartDateError(errorMessage);
      } else if (dateError) {
        dateError.textContent = '';
        dateError.hidden = true;
      }

      if (submitButton) {
        submitButton.disabled = false;
        submitButton.classList.remove('is-disabled');
      }

      return true;
    }

    function weekendApplied() {
      var selectedDate = startDateInput ? startDateInput.value : '';
      return !!(selectedDate && !isInvalidDate(selectedDate) && isWeekend(selectedDate));
    }

    var playTimeVariantId = 48122982531259;
    var playTimeSameDayEnabled = initialPlayTimeSameDayEnabled;
    var playTimeStatusLoaded = initialPlayTimeStatusLoaded;
    var trustedNowBaseMs = initialServerRenderedAtMs > 0 ? initialServerRenderedAtMs : 0;
    var trustedPerformanceBaseMs = trustedNowBaseMs > 0 ? performance.now() : 0;

    var nextDayCutoffHourSingapore = 19;
    var nextDayCutoffMinuteSingapore = 0;

    var originalDeliveryOptions = deliveryTimeInput
      ? Array.prototype.map.call(deliveryTimeInput.options, function (option) {
          return {
            value: option.value,
            text: option.textContent
          };
        })
      : [];

    function setTrustedNowFromResponse(response) {
      if (!response || !response.headers) return;

      var serverDateHeader = response.headers.get('Date');
      var serverNowMs = Date.parse(serverDateHeader || '');

      if (!isNaN(serverNowMs)) {
        trustedNowBaseMs = serverNowMs;
        trustedPerformanceBaseMs = performance.now();
      }
    }

    function getTrustedNowMs() {
      if (trustedNowBaseMs && trustedPerformanceBaseMs) {
        return trustedNowBaseMs + (performance.now() - trustedPerformanceBaseMs);
      }

      return Date.now();
    }

    function getAvailabilityNowMs() {
      
      var leadDays = getSelectedSecurityDepositLeadDays();
      return getTrustedNowMs() + (leadDays * 24 * 60 * 60 * 1000);
    }

    function getSingaporeNowParts() {
      
      var singaporeNow = new Date(getAvailabilityNowMs() + (8 * 60 * 60 * 1000));

      return {
        year: singaporeNow.getUTCFullYear(),
        month: singaporeNow.getUTCMonth() + 1,
        day: singaporeNow.getUTCDate(),
        hour: singaporeNow.getUTCHours(),
        minute: singaporeNow.getUTCMinutes()
      };
    }

    function getSingaporeReferencePartsForLeadDays(leadDays) {
      var referenceDate = new Date(
        getTrustedNowMs() +
        (Math.max(0, Number(leadDays) || 0) * 24 * 60 * 60 * 1000) +
        (8 * 60 * 60 * 1000)
      );

      return {
        year: referenceDate.getUTCFullYear(),
        month: referenceDate.getUTCMonth() + 1,
        day: referenceDate.getUTCDate(),
        hour: referenceDate.getUTCHours(),
        minute: referenceDate.getUTCMinutes()
      };
    }

    function formatSingaporeReferenceDateString(leadDays, additionalDays) {
      var reference = getSingaporeReferencePartsForLeadDays(leadDays);
      var date = new Date(Date.UTC(
        reference.year,
        reference.month - 1,
        reference.day + (additionalDays || 0)
      ));

      return date.getUTCFullYear() + '-' +
        String(date.getUTCMonth() + 1).padStart(2, '0') + '-' +
        String(date.getUTCDate()).padStart(2, '0');
    }

    function getFirstSelectableRentalDateForLeadDays(leadDays) {
      var reference = getSingaporeReferencePartsForLeadDays(leadDays);
      var referenceMinutes = (reference.hour * 60) + reference.minute;

      var startOffsetDays = playTimeSameDayEnabled && referenceMinutes < ((14 * 60) + 45)
        ? 0
        : 1;
      var candidateDate = formatSingaporeReferenceDateString(leadDays, startOffsetDays);
      var candidate = parseLocalDate(candidateDate);
      var referenceYearEnd = new Date(reference.year, 11, 31);

      while (candidate && candidate <= referenceYearEnd && isRentalStartDateBlocked(candidateDate)) {
        candidate.setDate(candidate.getDate() + 1);
        candidateDate = candidate.getFullYear() + '-' +
          String(candidate.getMonth() + 1).padStart(2, '0') + '-' +
          String(candidate.getDate()).padStart(2, '0');
      }

      return candidate && candidate <= referenceYearEnd ? candidateDate : '';
    }

    function formatSecurityDepositAvailabilityDate(dateString) {
      var date = parseLocalDate(dateString);
      var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

      if (!date) return '';

      return String(date.getDate()) + ' ' + monthNames[date.getMonth()];
    }

    function getProcessorOptionBaseLabel(option) {
      if (!option) return '';

      if (isIpadRentalPage() && String(option.value || '').trim()) {
        option.dataset.rentalBaseLabel = getBaseIpadProcessorValue(option.value);
        return option.dataset.rentalBaseLabel;
      }

      if (!option.dataset.rentalBaseLabel) {
        option.dataset.rentalBaseLabel = String(option.textContent || '')
          .replace(/\s+—\s+(?:(?:Available from|Earliest start)\s+.+|Unavailable|(?:Cellular|Wi-?Fi)\s+only(?:,\s+earliest start\s+.+)?|Wi-?Fi\s+(?:available(?: now)?|from\s+[^·]+|unavailable)\s+·\s+Cellular\s+(?:available(?: now)?|from\s+.+|unavailable)|WiFi:\s*[^·]+\s+·\s+Cellular:\s*.+)$/i, '')
          .trim();
      }

      return option.dataset.rentalBaseLabel;
    }

    function isRentalProcessorMobileLabelMode() {
      if (!window.matchMedia) return window.innerWidth <= 749;
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function captureRentalProcessorOverlayStyles() {
      if (!rentalProcessorSelect || rentalProcessorSelectOriginalOverlayStyles) return;

      var parent = rentalProcessorSelect.parentElement;
      rentalProcessorSelectOriginalOverlayStyles = {
        selectPosition: rentalProcessorSelect.style.position || '',
        selectZIndex: rentalProcessorSelect.style.zIndex || '',
        selectOpacity: rentalProcessorSelect.style.opacity || '',
        selectColor: rentalProcessorSelect.style.color || '',
        selectWebkitTextFillColor: rentalProcessorSelect.style.webkitTextFillColor || '',
        selectBackgroundColor: rentalProcessorSelect.style.backgroundColor || '',
        selectCaretColor: rentalProcessorSelect.style.caretColor || '',
        selectPointerEvents: rentalProcessorSelect.style.pointerEvents || '',
        selectCursor: rentalProcessorSelect.style.cursor || '',
        parentPosition: parent ? (parent.style.position || '') : ''
      };
    }

    function restoreRentalProcessorOverlayStyles() {
      if (!rentalProcessorSelect || !rentalProcessorSelectOriginalOverlayStyles) return;

      var parent = rentalProcessorSelect.parentElement;
      rentalProcessorSelect.style.position = rentalProcessorSelectOriginalOverlayStyles.selectPosition;
      rentalProcessorSelect.style.zIndex = rentalProcessorSelectOriginalOverlayStyles.selectZIndex;
      rentalProcessorSelect.style.opacity = rentalProcessorSelectOriginalOverlayStyles.selectOpacity;
      rentalProcessorSelect.style.color = rentalProcessorSelectOriginalOverlayStyles.selectColor;
      rentalProcessorSelect.style.webkitTextFillColor = rentalProcessorSelectOriginalOverlayStyles.selectWebkitTextFillColor;
      rentalProcessorSelect.style.backgroundColor = rentalProcessorSelectOriginalOverlayStyles.selectBackgroundColor;
      rentalProcessorSelect.style.caretColor = rentalProcessorSelectOriginalOverlayStyles.selectCaretColor;
      rentalProcessorSelect.style.pointerEvents = rentalProcessorSelectOriginalOverlayStyles.selectPointerEvents;
      rentalProcessorSelect.style.cursor = rentalProcessorSelectOriginalOverlayStyles.selectCursor;

      if (parent) {
        parent.style.position = rentalProcessorSelectOriginalOverlayStyles.parentPosition;
      }
    }

    function positionRentalProcessorClosedDisplay() {
      if (!rentalProcessorClosedDisplay || !rentalProcessorSelect) return;

      var parent = rentalProcessorSelect.parentElement;
      if (!parent) return;

      captureRentalProcessorOverlayStyles();

      var parentStyle = window.getComputedStyle(parent);
      if (parentStyle.position === 'static') {
        parent.style.position = 'relative';
      }

      var mobileMode = isRentalProcessorMobileLabelMode();
      var selectRect = rentalProcessorSelect.getBoundingClientRect();
      var parentRect = parent.getBoundingClientRect();
      var selectStyle = window.getComputedStyle(rentalProcessorSelect);
      var inset = mobileMode ? 0 : 2;

      rentalProcessorClosedDisplay.style.left = (selectRect.left - parentRect.left + inset) + 'px';
      rentalProcessorClosedDisplay.style.top = (selectRect.top - parentRect.top + inset) + 'px';
      rentalProcessorClosedDisplay.style.width = Math.max(0, selectRect.width - (inset * 2)) + 'px';
      rentalProcessorClosedDisplay.style.height = Math.max(0, selectRect.height - (inset * 2)) + 'px';
      rentalProcessorClosedDisplay.style.paddingLeft = selectStyle.paddingLeft || '16px';
      rentalProcessorClosedDisplay.style.paddingRight = '18px';
      rentalProcessorClosedDisplay.style.backgroundColor =
        selectStyle.backgroundColor && selectStyle.backgroundColor !== 'rgba(0, 0, 0, 0)'
          ? selectStyle.backgroundColor
          : '#ffffff';
      rentalProcessorClosedDisplay.style.borderRadius = selectStyle.borderRadius || '14px';
      rentalProcessorClosedDisplay.style.fontFamily = selectStyle.fontFamily;
      rentalProcessorClosedDisplay.style.fontSize = selectStyle.fontSize;
      rentalProcessorClosedDisplay.style.fontWeight = selectStyle.fontWeight;
      rentalProcessorClosedDisplay.style.letterSpacing = selectStyle.letterSpacing;
      rentalProcessorClosedDisplay.style.color = selectStyle.color;
      rentalProcessorClosedDisplay.style.border = mobileMode ? selectStyle.border : '0';
      rentalProcessorClosedDisplay.style.boxShadow = mobileMode ? selectStyle.boxShadow : 'none';

      var overlayArrow = rentalProcessorClosedDisplay.querySelector('.rental-processor-closed-display__arrow');

      if (mobileMode) {
        
        rentalProcessorClosedDisplay.style.zIndex = '2';
        rentalProcessorClosedDisplay.style.border = '0';
        rentalProcessorClosedDisplay.style.boxShadow = 'none';
        if (overlayArrow) overlayArrow.style.display = 'none';

        rentalProcessorSelect.style.position = 'relative';
        rentalProcessorSelect.style.zIndex = '3';
        rentalProcessorSelect.style.opacity = rentalProcessorSelectOriginalOverlayStyles.selectOpacity || '1';
        rentalProcessorSelect.style.color = 'transparent';
        rentalProcessorSelect.style.webkitTextFillColor = 'transparent';
        rentalProcessorSelect.style.backgroundColor = 'transparent';
        rentalProcessorSelect.style.caretColor = 'transparent';
        rentalProcessorSelect.style.pointerEvents = 'auto';
        rentalProcessorSelect.style.cursor = 'pointer';
      } else {
        if (overlayArrow) overlayArrow.style.display = '';
        rentalProcessorClosedDisplay.style.zIndex = '2';
        rentalProcessorSelect.style.position = rentalProcessorSelectOriginalOverlayStyles.selectPosition;
        rentalProcessorSelect.style.zIndex = rentalProcessorSelectOriginalOverlayStyles.selectZIndex;
        rentalProcessorSelect.style.opacity = rentalProcessorSelectOriginalOverlayStyles.selectOpacity;
        rentalProcessorSelect.style.color = rentalProcessorSelectOriginalOverlayStyles.selectColor;
        rentalProcessorSelect.style.webkitTextFillColor = rentalProcessorSelectOriginalOverlayStyles.selectWebkitTextFillColor;
        rentalProcessorSelect.style.backgroundColor = rentalProcessorSelectOriginalOverlayStyles.selectBackgroundColor;
        rentalProcessorSelect.style.caretColor = rentalProcessorSelectOriginalOverlayStyles.selectCaretColor;
        rentalProcessorSelect.style.pointerEvents = rentalProcessorSelectOriginalOverlayStyles.selectPointerEvents;
        rentalProcessorSelect.style.cursor = rentalProcessorSelectOriginalOverlayStyles.selectCursor;
      }
    }

    function shouldUseRentalProcessorClosedDisplay() {
      return !!(isIpadRentalPage() && rentalProcessorSelect);
    }

    function removeRentalProcessorClosedDisplay() {
      if (rentalProcessorClosedDisplay && rentalProcessorClosedDisplay.parentNode) {
        rentalProcessorClosedDisplay.parentNode.removeChild(rentalProcessorClosedDisplay);
      }

      restoreRentalProcessorOverlayStyles();
      rentalProcessorClosedDisplay = null;
      rentalProcessorClosedDisplayLabel = null;
    }

    function ensureRentalProcessorClosedDisplay() {
      if (!isIpadRentalPage() || !rentalProcessorSelect || !rentalProcessorSelect.parentElement) {
        removeRentalProcessorClosedDisplay();
        return null;
      }

      if (rentalProcessorClosedDisplay && rentalProcessorClosedDisplay.parentNode) {
        positionRentalProcessorClosedDisplay();
        return rentalProcessorClosedDisplay;
      }

      var overlay = document.createElement('span');
      overlay.className = 'rental-processor-closed-display';
      overlay.setAttribute('aria-hidden', 'true');
      overlay.style.position = 'absolute';
      overlay.style.pointerEvents = 'none';
      overlay.style.display = 'flex';
      overlay.style.alignItems = 'center';
      overlay.style.justifyContent = 'space-between';
      overlay.style.gap = '12px';
      overlay.style.boxSizing = 'border-box';
      overlay.style.overflow = 'hidden';

      var label = document.createElement('span');
      label.className = 'rental-processor-closed-display__label';
      label.style.minWidth = '0';
      label.style.overflow = 'hidden';
      label.style.textOverflow = 'ellipsis';
      label.style.whiteSpace = 'nowrap';

      var arrow = document.createElement('span');
      arrow.className = 'rental-processor-closed-display__arrow';
      arrow.style.flex = '0 0 auto';
      arrow.style.width = '0';
      arrow.style.height = '0';
      arrow.style.borderLeft = '5px solid transparent';
      arrow.style.borderRight = '5px solid transparent';
      arrow.style.borderTop = '6px solid currentColor';
      arrow.style.opacity = '0.55';

      overlay.appendChild(label);
      overlay.appendChild(arrow);
      rentalProcessorSelect.parentElement.appendChild(overlay);

      rentalProcessorClosedDisplay = overlay;
      rentalProcessorClosedDisplayLabel = label;
      positionRentalProcessorClosedDisplay();

      return overlay;
    }

    function shouldUseNativeRentalProcessorCompactLabel() {
      return false;
    }

    function restoreRentalProcessorFullOptionLabels() {
      if (!rentalProcessorSelect || !isIpadRentalPage()) return;

      Array.prototype.forEach.call(rentalProcessorSelect.options, function (option) {
        var fullLabel = option.dataset.rentalFullLabel;
        if (fullLabel) option.textContent = fullLabel;
      });
    }

    function collapseSelectedRentalProcessorOptionLabel() {
      return;
    }

    function prepareNativeRentalProcessorPicker() {
      restoreRentalProcessorFullOptionLabels();
    }

    function closeNativeRentalProcessorPickerLabel() {
      rentalProcessorNativePickerExpanded = false;
      updateRentalProcessorClosedDisplay();
    }

    function updateRentalProcessorClosedDisplay() {
      
      removeRentalProcessorClosedDisplay();
    }

    function getSecurityDepositFirstSelectableDate(config) {
      if (!config || !config.variantId || !playTimeStatusLoaded) return '';

      var leadDays = getSecurityDepositLeadDaysForVariantId(config.variantId);
      return leadDays > 0
        ? getFirstSelectableRentalDateForLeadDays(leadDays)
        : '';
    }

    function getIpadModeAvailabilityState(available, config) {
      var leadDays = config && config.variantId
        ? getSecurityDepositLeadDaysForVariantId(config.variantId)
        : 0;
      var firstSelectableDate = '';

      if (available && leadDays > 0) {
        firstSelectableDate = getSecurityDepositFirstSelectableDate(config);
      }

      return {
        available: !!available,
        hasFutureDate: !!(available && leadDays > 0),
        firstSelectableDate: firstSelectableDate,
        formattedDate: firstSelectableDate
          ? formatSecurityDepositAvailabilityDate(firstSelectableDate)
          : ''
      };
    }

    function buildIpadConnectivityProcessorLabel(baseLabel, connectivity) {
      var wifiConfig = getSecurityDepositConfigForOptionText(
        connectivity.baseProcessor || baseLabel
      );
      var cellularConfig = getSecurityDepositConfigForOptionText(
        connectivity.cellularProcessor
      );
      var wifi = getIpadModeAvailabilityState(
        connectivity.wifiAvailable,
        wifiConfig
      );
      var cellular = getIpadModeAvailabilityState(
        connectivity.cellularAvailable,
        cellularConfig
      );

      if (
        (wifi.hasFutureDate && !wifi.formattedDate) ||
        (cellular.hasFutureDate && !cellular.formattedDate)
      ) {
        return baseLabel;
      }

      if (!wifi.available && !cellular.available) {
        return baseLabel + ' — Unavailable';
      }

      if (wifi.available && !cellular.available) {
        return wifi.hasFutureDate
          ? baseLabel + ' (WiFi only: from ' + wifi.formattedDate + ')'
          : baseLabel + ' (WiFi only)';
      }

      if (!wifi.available && cellular.available) {
        return cellular.hasFutureDate
          ? baseLabel + ' (Cellular only: from ' + cellular.formattedDate + ')'
          : baseLabel + ' (Cellular only)';
      }

      if (wifi.hasFutureDate && cellular.hasFutureDate) {
        if (wifi.firstSelectableDate === cellular.firstSelectableDate) {
          return baseLabel + ' — Earliest start ' + wifi.formattedDate;
        }

        return baseLabel + ' (WiFi: from ' + wifi.formattedDate +
          ' · Cellular: from ' + cellular.formattedDate + ')';
      }

      if (wifi.hasFutureDate) {
        return baseLabel + ' (WiFi: from ' + wifi.formattedDate + ')';
      }

      if (cellular.hasFutureDate) {
        return baseLabel + ' (Cellular: from ' + cellular.formattedDate + ')';
      }

      return baseLabel;
    }

    function updateProcessorAvailabilityNote() {
      if (!rentalProcessorSelect) return;

      Array.prototype.forEach.call(rentalProcessorSelect.options, function (option) {
        var baseLabel = getProcessorOptionBaseLabel(option);

        if (!String(option.value || '').trim()) {
          option.textContent = baseLabel;
          option.removeAttribute('title');
          return;
        }

        if (isIpadRentalPage() && !isIpadCellularProcessorValue(option.value)) {
          var connectivity = getIpadConnectivityAvailability(option.value);

          option.textContent = buildIpadConnectivityProcessorLabel(baseLabel, connectivity);

          if (!connectivity.wifiAvailable && !connectivity.cellularAvailable) {
            
            option.textContent = baseLabel;
            option.disabled = true;
            option.hidden = true;
            option.style.display = 'none';
            option.setAttribute('aria-disabled', 'true');
            option.setAttribute('aria-hidden', 'true');
            option.removeAttribute('title');
          } else if (!connectivity.wifiAvailable) {
            option.hidden = false;
            option.style.removeProperty('display');
            option.removeAttribute('aria-hidden');
            option.setAttribute('title', 'Only the Cellular model is available for the selected rental date.');
          } else if (!connectivity.cellularAvailable) {
            option.hidden = false;
            option.style.removeProperty('display');
            option.removeAttribute('aria-hidden');
            option.setAttribute('title', 'Only the WiFi model is available for the selected rental date.');
          } else {
            option.hidden = false;
            option.style.removeProperty('display');
            option.removeAttribute('aria-hidden');
            option.removeAttribute('title');
          }
          return;
        }

        var config = getSecurityDepositConfigForOptionText(option.value);
        var firstSelectableDate = getSecurityDepositFirstSelectableDate(config);

        if (option.disabled) {
          option.textContent = baseLabel + ' — Unavailable';
          option.setAttribute('title', 'This model is currently unavailable');
          return;
        }

        option.removeAttribute('title');
        option.textContent = firstSelectableDate
          ? baseLabel + ' — Earliest start ' + formatSecurityDepositAvailabilityDate(firstSelectableDate)
          : baseLabel;
      });

      Array.prototype.forEach.call(rentalProcessorSelect.options, function (option) {
        option.dataset.rentalFullLabel = String(option.textContent || '').trim();
      });

      updateRentalProcessorClosedDisplay();
    }

    function loadProcessorSecurityDepositAvailabilityLabels() {
      if (!rentalProcessorSelect) return Promise.resolve([]);

      var loadRequests = [];
      var requestedVariantIds = {};

      function queueSecurityDepositDayLookup(config) {
        if (!config || !config.variantId) return;

        var variantId = String(config.variantId);
        if (requestedVariantIds[variantId]) return;

        requestedVariantIds[variantId] = true;
        loadRequests.push(
          loadSecurityDepositLeadDaysForVariantId(variantId).then(function () {
            updateProcessorAvailabilityNote();
          })
        );
      }

      Array.prototype.forEach.call(rentalProcessorSelect.options, function (option) {
        getProcessorOptionBaseLabel(option);
        queueSecurityDepositDayLookup(getSecurityDepositConfigForOptionText(option.value));

        if (isIpadRentalPage() && !isIpadCellularProcessorValue(option.value)) {
          var cellularProcessor = getCellularIpadProcessorValue(option.value);
          if (cellularProcessor) {
            queueSecurityDepositDayLookup(
              getSecurityDepositConfigForOptionText(cellularProcessor)
            );
          }
        }
      });

      updateProcessorAvailabilityNote();

      return Promise.all(loadRequests).then(function (results) {
        updateProcessorAvailabilityNote();
        return results;
      });
    }

    function formatSingaporeDateParts(offsetDays) {
      var now = getSingaporeNowParts();
      var date = new Date(Date.UTC(
        now.year,
        now.month - 1,
        now.day + (offsetDays || 0)
      ));

      return date.getUTCFullYear() + '-' +
        String(date.getUTCMonth() + 1).padStart(2, '0') + '-' +
        String(date.getUTCDate()).padStart(2, '0');
    }

    function getSingaporeTodayString() {
      return formatSingaporeDateParts(0);
    }

    function getSingaporeTomorrowString() {
      return formatSingaporeDateParts(1);
    }

    function getCurrentSingaporeMinutes() {
      var singaporeNow = getSingaporeNowParts();
      return (singaporeNow.hour * 60) + singaporeNow.minute;
    }

    function getPlayTimeSameDayTier() {
      if (!playTimeSameDayEnabled) return '';

      var minutes = getCurrentSingaporeMinutes();

      if (minutes >= (19 * 60) || minutes < ((8 * 60) + 45)) {
        return 'overnight';
      }

      if (minutes < ((10 * 60) + 45)) {
        return 'morning';
      }

      if (minutes < ((12 * 60) + 45)) {
        return 'midday';
      }

      if (minutes < ((14 * 60) + 45)) {
        return 'afternoon';
      }

      return 'closed';
    }

    function playTimeAllowsTodayAsStartDate() {
      if (!playTimeSameDayEnabled) return false;

      var tier = getPlayTimeSameDayTier();
      return ['overnight', 'morning', 'midday', 'afternoon'].indexOf(tier) !== -1 &&
        getCurrentSingaporeMinutes() < ((14 * 60) + 45);
    }

    function getRentalStartDateMinimumString() {
      return playTimeAllowsTodayAsStartDate()
        ? getSingaporeTodayString()
        : getSingaporeTomorrowString();
    }

    function getPlayTimeControlledStartDateString() {
      var minutes = getCurrentSingaporeMinutes();

      if (minutes >= (19 * 60)) {
        return getSingaporeTomorrowString();
      }

      return getSingaporeTodayString();
    }

    function nextDayDeliveryRestrictionApplies() {
      if (!startDateInput || !startDateInput.value || playTimeSameDayEnabled) return false;

      var currentMinutes = getCurrentSingaporeMinutes();
      var cutoffMinutes =
        (nextDayCutoffHourSingapore * 60) +
        nextDayCutoffMinuteSingapore;

      return (
        currentMinutes >= cutoffMinutes &&
        startDateInput.value === getSingaporeTomorrowString()
      );
    }

    function getPlayTimeDeliveryTier() {
      if (!startDateInput || !startDateInput.value || !playTimeSameDayEnabled) return '';

      var selectedDate = startDateInput.value;
      var tier = getPlayTimeSameDayTier();

      if (tier === 'closed') {
        return '';
      }

      if (selectedDate === getSingaporeTodayString()) {
        return tier;
      }

      if (getCurrentSingaporeMinutes() >= (19 * 60) && selectedDate === getSingaporeTomorrowString()) {
        return 'overnight';
      }

      return '';
    }

    function isBlockedNextDaySlot(value) {
      return [
        'early',
        '9am–11am'
      ].indexOf(value) !== -1;
    }

    var playTimeDeliveryTierRules = {
      overnight: {
        allowed: {
          '11am–1pm': 'priority',
          '1pm–3pm': 'standard',
          '3pm–5pm': '',
          '5pm–7pm': '',
          '7pm–9pm': ''
        }
      },
      morning: {
        allowed: {
          '1pm–3pm': 'priority',
          '3pm–5pm': 'standard',
          '5pm–7pm': '',
          '7pm–9pm': ''
        }
      },
      midday: {
        allowed: {
          '3pm–5pm': 'priority',
          '5pm–7pm': 'standard',
          '7pm–9pm': ''
        }
      },
      afternoon: {
        allowed: {
          '5pm–7pm': 'priority',
          '7pm–9pm': 'standard'
        }
      }
    };

    function getPlayTimeChargeTypeForDelivery(value) {
      var tier = getPlayTimeDeliveryTier();
      if (!tier || !playTimeDeliveryTierRules[tier]) return null;
      if (!value) return '';

      var allowed = playTimeDeliveryTierRules[tier].allowed;
      if (!Object.prototype.hasOwnProperty.call(allowed, value)) {
        return 'blocked';
      }

      return allowed[value] || '';
    }

    function getDeliveryLabelWithCharge(item, chargeType) {
      if (!item || !item.value) {
        return item ? item.text : '';
      }

      if (item.value === 'early') {
        return formatTimingOptionChargeLabel(
          stripDeliveryChargeSuffix(item.text) || '8am–10am',
          'Early Delivery',
          earlyDeliverySurchargeCents
        );
      }

      if (chargeType === 'priority') {
        var priorityPrice = formatCompactMoney(priorityUrgentChargeCents);
        return item.value + ' (Priority Urgent Delivery' + (priorityPrice ? ' +' + priorityPrice : '') + ')';
      }

      if (chargeType === 'standard') {
        var standardPrice = formatCompactMoney(standardUrgentChargeCents);
        return item.value + ' (Standard Urgent Delivery' + (standardPrice ? ' +' + standardPrice : '') + ')';
      }

      if (chargeType === 'blocked') {
        return item.value + ' (Unavailable)';
      }

      return item.text;
    }

    function getRestrictedDeliveryLabel(item) {
      if (!item || !item.value) {
        return item ? item.text : '';
      }

      if (item.value === 'early') {
        return formatTimingOptionChargeLabel(
          stripDeliveryChargeSuffix(item.text) || '8am–10am',
          'Early Delivery',
          earlyDeliverySurchargeCents
        );
      }

      if (item.value === '11am–1pm') {
        var priorityPrice = formatCompactMoney(priorityUrgentChargeCents);
        return '11am–1pm (Priority Urgent Delivery' + (priorityPrice ? ' +' + priorityPrice : '') + ')';
      }

      if (item.value === '1pm–3pm') {
        var standardPrice = formatCompactMoney(standardUrgentChargeCents);
        return '1pm–3pm (Standard Urgent Delivery' + (standardPrice ? ' +' + standardPrice : '') + ')';
      }

      if (isBlockedNextDaySlot(item.value)) {
        return item.text + ' (Unavailable)';
      }

      return item.text;
    }

    function getSelectedDeliveryOption() {
      if (!deliveryTimeInput || deliveryTimeInput.selectedIndex < 0) return null;
      return deliveryTimeInput.options[deliveryTimeInput.selectedIndex] || null;
    }

    function selectedDeliveryOptionIsUnavailable() {
      var selectedOption = getSelectedDeliveryOption();
      return !!(selectedOption && selectedOption.disabled);
    }

    function priorityUrgentChargeApplied() {
      if (!deliveryTimeInput || selectedDeliveryOptionIsUnavailable()) return false;

      if (getPlayTimeChargeTypeForDelivery(deliveryTimeInput.value) === 'priority') {
        return true;
      }

      return !!(
        nextDayDeliveryRestrictionApplies() &&
        deliveryTimeInput.value === '11am–1pm'
      );
    }

    function standardUrgentChargeApplied() {
      if (!deliveryTimeInput || selectedDeliveryOptionIsUnavailable()) return false;

      if (getPlayTimeChargeTypeForDelivery(deliveryTimeInput.value) === 'standard') {
        return true;
      }

      return !!(
        nextDayDeliveryRestrictionApplies() &&
        deliveryTimeInput.value === '1pm–3pm'
      );
    }

    function rebuildDeliveryOptions() {
      if (!deliveryTimeInput) return false;

      var restricted = nextDayDeliveryRestrictionApplies();
      var playTimeTier = getPlayTimeDeliveryTier();
      var previousValue = deliveryTimeInput.value;

      deliveryTimeInput.innerHTML = '';

      originalDeliveryOptions.forEach(function (item) {
        var option = document.createElement('option');
        var playTimeChargeType = playTimeTier ? getPlayTimeChargeTypeForDelivery(item.value) : null;

        if (playTimeTier && playTimeChargeType === 'blocked') {
          return;
        }

        if (!playTimeTier && restricted && isBlockedNextDaySlot(item.value)) {
          return;
        }

        option.value = item.value;
        option.textContent = playTimeTier
          ? getDeliveryLabelWithCharge(item, playTimeChargeType)
          : (restricted ? getRestrictedDeliveryLabel(item) : getDeliveryLabelWithCharge(item, ''));

        deliveryTimeInput.appendChild(option);
      });

      var previousStillAvailable = Array.prototype.some.call(
        deliveryTimeInput.options,
        function (option) {
          return option.value === previousValue;
        }
      );

      deliveryTimeInput.value = previousStillAvailable ? previousValue : '';

      if (!previousStillAvailable && previousValue) {
        updateRentalEndInfo();
        updateTotal();
      }

      return !!(restricted || playTimeTier);
    }

    function refreshPlayTimeDependentUi(clearInvalidDate) {
      updateProcessorAvailabilityNote();
      refreshRentalStartDateMinimum(!!clearInvalidDate);
      setRentalStartDateDisplayText();
      validateDateField();
      rebuildDeliveryOptions();
      updateTotal();
      updateRentalEndInfo();

      if (useCustomRentalDatePicker) {
        renderRentalMobileCalendar();
      }
    }

    function loadPlayTimeAvailability() {
      return fetch('/variants/' + encodeURIComponent(playTimeVariantId) + '.js?rental_playtime=' + Date.now(), {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Cache-Control': 'no-cache'
        },
        cache: 'no-store'
      })
        .then(function (response) {
          setTrustedNowFromResponse(response);

          if (!response.ok) {
            throw new Error('Unable to read PlayTime availability.');
          }

          return response.json();
        })
        .then(function (variant) {
          playTimeSameDayEnabled = !!(variant && variant.available);
          playTimeStatusLoaded = true;
          refreshPlayTimeDependentUi(true);
        })
        .catch(function (error) {
          playTimeSameDayEnabled = false;
          playTimeStatusLoaded = true;
          console.error('PlayTime availability check error:', error);
          refreshPlayTimeDependentUi(true);
        });
    }

    function earlyDeliveryApplied() {
      return !!(deliveryTimeInput && deliveryTimeInput.value === 'early');
    }

    function getSelectedOptionText() {
      return getSelectedOptions()
        .filter(function (value) { return !!value; })
        .join(' ')
        .toLowerCase();
    }

    function getSelectedProcessorText() {
      if (isIpadRentalPage()) {
        return String(getEffectiveIpadProcessorValue() || getSelectedOptionText()).toLowerCase();
      }

      var processorText = '';
      var groups = document.querySelectorAll('.rental-option-group');

      groups.forEach(function (group) {
        var titleEl = group.querySelector('.rental-option-group-title');
        var checked = group.querySelector('.rental-option-radio:checked');

        if (!titleEl || !checked) return;

        var groupTitle = (titleEl.textContent || '').trim().toLowerCase();
        if (groupTitle.indexOf('processor') !== -1) {
          processorText = checked.value || '';
        }
      });

      return (processorText || getSelectedOptionText()).toLowerCase();
    }

    function setRentalInfoList(listEl, items) {
      if (!listEl) return;

      listEl.innerHTML = '';
      items.forEach(function (item) {
        var li = document.createElement('li');
        li.textContent = item;
        listEl.appendChild(li);
      });
    }

    function getSelectedCompatibilityOptionText() {
      if (isIpadRentalPage()) {
        return getEffectiveIpadProcessorValue();
      }

      var selectedOptions = [];
      var groups = document.querySelectorAll('.rental-option-group');

      groups.forEach(function (group) {
        var titleEl = group.querySelector('.rental-option-group-title');
        var checked = group.querySelector('.rental-option-radio:checked');

        if (!titleEl || !checked) return;

        var groupTitle = (titleEl.textContent || '').trim().toLowerCase();
        if (groupTitle.indexOf('rental period') !== -1 || groupTitle === 'period') {
          return;
        }

        if (checked.value) {
          selectedOptions.push(checked.value);
        }
      });

      if (selectedOptions.length) {
        return selectedOptions.join(' / ');
      }

      var matchedVariant = findMatchingVariant();
      if (matchedVariant && matchedVariant.title) {
        return matchedVariant.title.replace(/\s*\/\s*(2 Day|3 Day|4 Day|5 Day|6 Day|1 Week|2 Week|3 Week|\d+ Month).*$/i, '').trim();
      }

      return '';
    }

    function selectedCompatibilityOptionIsBusinessI5(selectedText) {
      if (rentalProductTitle.indexOf('business laptop rental') === -1) return false;

      var text = (selectedText || '').toLowerCase();
      var isNewRyzen5Tier =
        text.indexOf('ryzen 5') !== -1 &&
        /(^|[^a-z0-9])new([^a-z0-9]|$)/i.test(text);

      if (text.indexOf('ultra 5') !== -1 || isNewRyzen5Tier) {
        return false;
      }

      return /(^|[^a-z0-9])i5([^a-z0-9]|$)/i.test(text) || text.indexOf('ryzen 5') !== -1;
    }

    function updateCompatibilityItemAvailability(selectedText) {
      var limitedKeysForBusinessI5 = [
        'python-coding',
        'visual-studio',
        'docker',
        'sql-database',
        'ubuntu'
      ];
      var shouldLimitDeveloperApps = selectedCompatibilityOptionIsBusinessI5(selectedText);
      var shouldLimitMacbookCustomOs =
        rentalProductTitle.indexOf('macbook rental') !== -1 ||
        /\bimac\b/i.test(String(selectedText || ''));

      document.querySelectorAll('.rental-compatibility-item').forEach(function (item) {
        var key = item.getAttribute('data-rental-compatibility');
        var isLimited =
          (shouldLimitDeveloperApps && limitedKeysForBusinessI5.indexOf(key) !== -1) ||
          (shouldLimitMacbookCustomOs && key === 'ubuntu');

        item.classList.toggle('is-compatibility-limited', isLimited);

        if (isLimited) {
          item.setAttribute('data-rental-compatibility-limited', 'true');
          item.setAttribute('aria-disabled', 'true');
          item.disabled = true;
        } else {
          item.removeAttribute('data-rental-compatibility-limited');
          item.removeAttribute('aria-disabled');
          item.disabled = false;
        }
      });
    }

    function updateBasePriceLabel(selectedText) {
      if (!basePriceLabelEl) return;

      var labelText = (selectedText || getSelectedCompatibilityOptionText() || '').trim();
      var rentalPeriod = (getSelectedRentalPeriod() || '').trim();
      var labelPrefix = rentalPeriod ? rentalPeriod + ' Rental' : 'Rental Price';

      basePriceLabelEl.textContent = labelText ? labelPrefix + ' - ' + labelText : labelPrefix;
    }

    function updateCompatibilitySelectedOption() {
      var selectedText = getSelectedCompatibilityOptionText();

      if (compatibilitySelectedOptionEl) {
        compatibilitySelectedOptionEl.textContent = selectedText || '-';
      }

      updateBasePriceLabel(selectedText);
      updateCompatibilityItemAvailability(selectedText);
    }

    function getMacbookIncludes(processorText) {
      var text = processorText.toLowerCase();
      var firstLine = 'MacOS';
      var coreLine = '';

      if (text.indexOf('imac m1') !== -1) {
        return ['MacOS, 8GB, 256GB', '8C CPU, 8C GPU', 'Webcam & Microphone', 'Keyboard & Mouse', 'Charger'];
      }

      if (text.indexOf('macbook air m1') !== -1 || text.indexOf('air m1') !== -1) {
        firstLine = 'MacOS, 8GB, 256GB';
        coreLine = '8C CPU, 7C GPU';
      } else if (text.indexOf('macbook air m2') !== -1 || text.indexOf('air m2') !== -1) {
        firstLine = 'MacOS, 8GB, 256GB';
        coreLine = '8C CPU, 8C GPU';
      } else if (text.indexOf('macbook air m4') !== -1 || text.indexOf('air m4') !== -1) {
        firstLine = 'MacOS, 16GB, 256GB';
        coreLine = '10C CPU, 8C GPU';
      } else if (text.indexOf('macbook air m3') !== -1 || text.indexOf('air m3') !== -1) {
        firstLine = 'MacOS, 16GB, 256GB';
      } else if (text.indexOf('macbook air m5') !== -1 || text.indexOf('air m5') !== -1) {
        firstLine = 'MacOS, 16GB, 512GB';
      } else if (text.indexOf('macbook pro m5 pro') !== -1 || text.indexOf('m5 pro') !== -1) {
        firstLine = 'MacOS, 24GB, 1TB';
        coreLine = '15C CPU, 16C GPU';
      } else if (text.indexOf('macbook pro m3 max') !== -1 || text.indexOf('m3 max') !== -1) {
        firstLine = 'MacOS, 48GB, 1TB';
        coreLine = '16C CPU, 40C GPU';
      } else if (text.indexOf('macbook pro m4 pro') !== -1 || text.indexOf('m4 pro') !== -1) {
        firstLine = 'MacOS, 24GB, 512GB';
        coreLine = '12C CPU, 16C GPU';
      } else if (text.indexOf('macbook pro m3 pro') !== -1 || text.indexOf('m3 pro') !== -1) {
        firstLine = 'MacOS, 18GB, 512GB';
        coreLine = '11C CPU, 14C GPU';
      } else if (text.indexOf('macbook pro m2 pro') !== -1 || text.indexOf('m2 pro') !== -1) {
        firstLine = 'MacOS, 16GB, 512GB';
        coreLine = '12C CPU, 19C GPU';
      } else if (text.indexOf('macbook pro m1 pro') !== -1 || text.indexOf('m1 pro') !== -1) {
        firstLine = 'MacOS, 16GB, 512GB';
        coreLine = '10C CPU, 16C GPU';
      } else if (text.indexOf('macbook pro m4') !== -1 || text.indexOf('macbook pro m5') !== -1 || text.indexOf('pro m4') !== -1 || text.indexOf('pro m5') !== -1) {
        firstLine = 'MacOS, 16GB, 512GB';
      } else if (text.indexOf('macbook pro m3') !== -1 || text.indexOf('pro m3') !== -1) {
        firstLine = 'MacOS, 8GB, 512GB';
      } else if (text.indexOf('macbook pro m2') !== -1 || text.indexOf('pro m2') !== -1) {
        firstLine = 'MacOS, 8GB, 256GB';
        coreLine = '8C CPU, 10C GPU';
      } else if (text.indexOf('macbook pro m1') !== -1 || text.indexOf('pro m1') !== -1) {
        firstLine = 'MacOS, 8GB, 256GB';
        coreLine = '8C CPU, 8C GPU';
      }

      return coreLine
        ? [firstLine, coreLine, 'Webcam & Microphone', 'Charger & Bag']
        : [firstLine, 'Webcam & Microphone', 'Charger & Bag'];
    }

    function getMacbookPorts(processorText) {
      var text = processorText.toLowerCase();

      if (text.indexOf('imac m1') !== -1) {
        return ['2x Thunderbolt USB-C', 'Headphone Jack'];
      }

      if (
        text.indexOf('macbook pro m1 pro') !== -1 ||
        text.indexOf('macbook pro m2 pro') !== -1 ||
        text.indexOf('macbook pro m3 pro') !== -1 ||
        text.indexOf('macbook pro m4 pro') !== -1 ||
        text.indexOf('macbook pro m5 pro') !== -1 ||
        text.indexOf('macbook pro m1 max') !== -1 ||
        text.indexOf('macbook pro m2 max') !== -1 ||
        text.indexOf('macbook pro m3 max') !== -1 ||
        text.indexOf('macbook pro m4 max') !== -1 ||
        text.indexOf('macbook pro m5 max') !== -1 ||
        text.indexOf('m1 pro') !== -1 ||
        text.indexOf('m2 pro') !== -1 ||
        text.indexOf('m3 pro') !== -1 ||
        text.indexOf('m4 pro') !== -1 ||
        text.indexOf('m5 pro') !== -1 ||
        text.indexOf('m1 max') !== -1 ||
        text.indexOf('m2 max') !== -1 ||
        text.indexOf('m3 max') !== -1 ||
        text.indexOf('m4 max') !== -1 ||
        text.indexOf('m5 max') !== -1
      ) {
        return ['3x Thunderbolt USB-C', 'HDMI Port', 'SDXC Card Slot', 'Headphone Jack'];
      }

      if (text.indexOf('macbook pro m4') !== -1 || text.indexOf('macbook pro m5') !== -1 || text.indexOf('pro m4') !== -1 || text.indexOf('pro m5') !== -1) {
        return ['3x Thunderbolt USB-C', 'HDMI Port', 'SDXC Card Slot', 'Headphone Jack'];
      }

      if (text.indexOf('macbook pro m3') !== -1 || text.indexOf('pro m3') !== -1) {
        return ['2x Thunderbolt USB-C', 'HDMI Port', 'SDXC Card Slot', 'Headphone Jack'];
      }

      return ['2x Thunderbolt USB-C', 'Headphone Jack'];
    }

    function updateRentalInfoPanels() {
      updateCompatibilitySelectedOption();

      var processorText = getSelectedProcessorText();

      if (rentalProductTitle.indexOf('macbook rental') !== -1) {
        setRentalInfoList(rentalIncludesList, getMacbookIncludes(processorText));
        setRentalInfoList(rentalPortsList, getMacbookPorts(processorText));
        return;
      }

      if (rentalProductTitle.indexOf('gaming laptop rental') !== -1) {
        var gamingProcessorText = String(processorText || '').toLowerCase();
        var gamingIncludes = gamingProcessorText.indexOf('rtx 5080') !== -1
          ? ['Windows 11, 32GB, 1TB', 'Webcam & Microphone', 'Charger & Bag']
          : ['Windows 11, 16GB, 512GB', 'Webcam & Microphone', 'Charger & Bag'];

        setRentalInfoList(rentalIncludesList, gamingIncludes);
        setRentalInfoList(rentalPortsList, ['2x USB-A', '1x USB-C', 'HDMI Port', 'Headphone Jack']);
        return;
      }

      if (rentalProductTitle.indexOf('ipad rental') !== -1) {
        setRentalInfoList(rentalIncludesList, ['Charger & Bag']);
        setRentalInfoList(rentalPortsList, ['Nil']);
        return;
      }

      if (rentalProductTitle.indexOf('business laptop rental') !== -1) {
        var businessPorts = ['2x USB-A', '1x USB-C', 'Headphone Jack'];
        var businessProcessorText = String(processorText || '').toLowerCase();
        var businessIsNewTier = /(^|[^a-z0-9])new([^a-z0-9]|$)/i.test(businessProcessorText);
        var businessIncludes = ['Windows 11, 16GB, 512GB', 'Webcam & Microphone', 'Microsoft Office'];

        if (businessProcessorText.indexOf('ultra 7') !== -1 || (businessProcessorText.indexOf('ryzen 7') !== -1 && businessIsNewTier)) {
          businessIncludes = ['Windows 11, 16GB, 512GB', 'Core Ultra 7 / Ryzen 7 (New)', 'Webcam & Microphone', 'Microsoft Office'];
        } else if (businessProcessorText.indexOf('ultra 5') !== -1 || (businessProcessorText.indexOf('ryzen 5') !== -1 && businessIsNewTier)) {
          businessIncludes = ['Windows 11, 16GB, 512GB', 'Core Ultra 5 / Ryzen 5 (New)', 'Webcam & Microphone', 'Microsoft Office'];
        } else if (/(^|[^a-z0-9])i7([^a-z0-9]|$)/i.test(businessProcessorText) || businessProcessorText.indexOf('ryzen 7') !== -1) {
          businessIncludes = ['Windows 11, 16GB, 512GB', 'Intel i7 / Ryzen 7', 'Webcam & Microphone', 'Microsoft Office'];
        } else if (/(^|[^a-z0-9])i5([^a-z0-9]|$)/i.test(businessProcessorText) || businessProcessorText.indexOf('ryzen 5') !== -1) {
          businessIncludes = ['Windows 11, 16GB, 256GB', 'Intel i5 / Ryzen 5', 'Webcam & Microphone', 'Microsoft Office'];
        }

        if (hdmiAddonApplied()) {
          businessPorts = ['2x USB-A', '1x USB-C', 'HDMI Port', 'Headphone Jack'];
        }

        setRentalInfoList(rentalIncludesList, businessIncludes);
        setRentalInfoList(rentalPortsList, businessPorts);
        return;
      }

      setRentalInfoList(rentalIncludesList, ['Windows 11, 16GB, 512GB', 'Webcam & Microphone', 'Microsoft Office']);
      setRentalInfoList(rentalPortsList, ['2x USB-A', '1x USB-C', 'Headphone Jack']);
    }

    function attachLivePriceToVariantConfig(config) {
      if (!config || !config.variantId) return null;

      return {
        variantId: config.variantId,
        cents: getLiveVariantPriceCents(config.variantId)
      };
    }

    function getSecurityDepositConfig() {
      var productTitle = String(rentalPageConfig.productTitle || '').toLowerCase();
      var selectedOptionText = getSelectedOptionText();
      var matchedConfig = null;

      if (productTitle.indexOf('business laptop rental') !== -1) {
        var businessSearchText = (getSelectedProcessorText() + ' ' + selectedOptionText).toLowerCase();
        matchedConfig = getBusinessLaptopSecurityDepositConfig(businessSearchText) || businessLaptopSecurityDepositMap.i5;
      }

      if (!matchedConfig && productTitle.indexOf('gaming laptop rental') !== -1) {
        var matchedGraphicsKey = Object.keys(gamingSecurityDepositMap).find(function (graphicsName) {
          return selectedOptionText.indexOf(graphicsName) !== -1;
        });

        if (matchedGraphicsKey) {
          matchedConfig = gamingSecurityDepositMap[matchedGraphicsKey];
        }
      }

      if (!matchedConfig && productTitle.indexOf('macbook rental') !== -1) {
        var macbookSearchText = (productTitle + ' ' + selectedOptionText).toLowerCase();
        var matchedMacbookKey = Object.keys(macbookSecurityDepositMap)
          .sort(function (a, b) { return b.length - a.length; })
          .find(function (modelName) {
            return macbookSearchText.indexOf(modelName) !== -1;
          });

        if (matchedMacbookKey) {
          matchedConfig = macbookSecurityDepositMap[matchedMacbookKey];
        }
      }

      if (!matchedConfig && productTitle.indexOf('ipad rental') !== -1) {
        var ipadSearchText = (productTitle + ' ' + selectedOptionText).toLowerCase();
        var matchedIpadKey = Object.keys(ipadSecurityDepositMap)
          .sort(function (a, b) { return b.length - a.length; })
          .find(function (modelName) {
            return ipadSearchText.indexOf(modelName) !== -1;
          });

        if (matchedIpadKey) {
          matchedConfig = ipadSecurityDepositMap[matchedIpadKey];
        }
      }

      return attachLivePriceToVariantConfig(matchedConfig || {
        variantId: defaultSecurityDepositVariantId
      });
    }

    var securityDepositStockStatusByVariantId = {};

    function hydrateInitialSecurityDepositStockAvailability() {
      var hydratedCount = 0;

      Object.keys(initialSecurityDepositStockByVariantId).forEach(function (variantId) {
        var initialStatus = initialSecurityDepositStockByVariantId[variantId];
        if (!initialStatus || typeof initialStatus !== 'object') return;

        var availableQty = typeof initialStatus.availableQty === 'number'
          ? Math.max(Number(initialStatus.availableQty), 0)
          : null;

        if (typeof initialStatus.description === 'string') {
          cacheSecurityDepositLeadDays(variantId, initialStatus.description);
        }

        securityDepositStockStatusByVariantId[String(variantId)] = {
          variantId: String(variantId),
          available: initialStatus.available !== false,
          availableQty: availableQty,
          source: 'server-rendered'
        };

        hydratedCount += 1;
      });

      return hydratedCount;
    }

    function getSecurityDepositConfigForOptionText(optionText) {
      var productTitle = String(rentalPageConfig.productTitle || '').toLowerCase();
      var searchText = String(optionText || '').toLowerCase();
      var combinedSearchText = (productTitle + ' ' + searchText).toLowerCase();

      if (productTitle.indexOf('business laptop rental') !== -1) {
        return getBusinessLaptopSecurityDepositConfig(searchText);
      }

      if (productTitle.indexOf('gaming laptop rental') !== -1) {
        var matchedGraphicsKey = Object.keys(gamingSecurityDepositMap)
          .sort(function (a, b) { return b.length - a.length; })
          .find(function (graphicsName) {
            return searchText.indexOf(graphicsName) !== -1;
          });

        if (matchedGraphicsKey) {
          return gamingSecurityDepositMap[matchedGraphicsKey];
        }

        return null;
      }

      if (productTitle.indexOf('macbook rental') !== -1) {
        var matchedMacbookKey = Object.keys(macbookSecurityDepositMap)
          .sort(function (a, b) { return b.length - a.length; })
          .find(function (modelName) {
            return combinedSearchText.indexOf(modelName) !== -1;
          });

        if (matchedMacbookKey) {
          return macbookSecurityDepositMap[matchedMacbookKey];
        }

        return null;
      }

      if (productTitle.indexOf('ipad rental') !== -1) {
        var matchedIpadKey = Object.keys(ipadSecurityDepositMap)
          .sort(function (a, b) { return b.length - a.length; })
          .find(function (modelName) {
            return combinedSearchText.indexOf(modelName) !== -1;
          });

        if (matchedIpadKey) {
          return ipadSecurityDepositMap[matchedIpadKey];
        }

        return null;
      }

      return null;
    }

    function getRelevantSecurityDepositVariantIds() {
      var ids = [];

      optionInputs.forEach(function (input) {
        var config = getSecurityDepositConfigForOptionText(input.value);
        if (!config || !config.variantId) return;

        var variantId = String(config.variantId);
        if (ids.indexOf(variantId) === -1) {
          ids.push(variantId);
        }
      });

      var selectedConfig = getSecurityDepositConfig();
      if (selectedConfig && selectedConfig.variantId) {
        var selectedVariantId = String(selectedConfig.variantId);
        if (ids.indexOf(selectedVariantId) === -1) {
          ids.push(selectedVariantId);
        }
      }

      return ids;
    }

    function fetchCartQuantitiesByVariantId() {
      return fetch('/cart.js?rental_stock_cart=' + Date.now(), {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Cache-Control': 'no-cache'
        },
        cache: 'no-store'
      })
        .then(function (response) {
          setTrustedNowFromResponse(response);

          if (!response.ok) {
            throw new Error('Unable to read the current rental cart quantities.');
          }
          return response.json();
        })
        .then(function (cart) {
          var quantitiesByVariantId = {};

          if (!cart || !Array.isArray(cart.items)) {
            return quantitiesByVariantId;
          }

          cart.items.forEach(function (item) {
            var itemProperties = item && item.properties ? item.properties : {};
            var itemGroupId = String(itemProperties['Rental group ID'] || '').trim();

            if (
              rentalEditModeActive &&
              rentalEditRequestedGroupId &&
              itemGroupId === rentalEditRequestedGroupId
            ) {
              return;
            }

            var variantId = String(item.variant_id || item.id || '');
            if (!variantId) return;

            quantitiesByVariantId[variantId] =
              (quantitiesByVariantId[variantId] || 0) + Number(item.quantity || 0);
          });

          return quantitiesByVariantId;
        })
        .catch(function () {
          return {};
        });
    }

    function fetchSecurityDepositVariantStatus(variantId, cartQuantitiesByVariantId) {
      return fetch('/variants/' + encodeURIComponent(variantId) + '.js?rental_stock=' + Date.now(), {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Cache-Control': 'no-cache'
        },
        cache: 'no-store'
      })
        .then(function (response) {
          setTrustedNowFromResponse(response);

          if (!response.ok) {
            throw new Error('Unable to read rental stock.');
          }
          return response.json();
        })
        .then(function (variant) {
          var available = variant.available !== false;
          var inventoryQuantity = typeof variant.inventory_quantity === 'number'
            ? variant.inventory_quantity
            : null;
          var inventoryManagement = variant.inventory_management || '';
          var inventoryPolicy = variant.inventory_policy || '';
          var quantityInCart = Number(cartQuantitiesByVariantId[String(variantId)] || 0);

          if (
            inventoryQuantity !== null &&
            inventoryManagement &&
            inventoryPolicy !== 'continue'
          ) {
            available = (inventoryQuantity - quantityInCart) > 0;
          }

          return {
            variantId: String(variantId),
            available: available,
            availableQty: inventoryQuantity === null
              ? null
              : Math.max(inventoryQuantity - quantityInCart, 0)
          };
        })
        .catch(function () {
          
          return {
            variantId: String(variantId),
            available: true,
            availableQty: null,
            unknown: true
          };
        });
    }

    function getRequestedAppleMouseQuantity() {
      var quantityInput = rentalForm
        ? rentalForm.querySelector('input[name="quantity"]')
        : document.querySelector('#RentalProductForm input[name="quantity"]');
      var quantity = parseInt(quantityInput ? quantityInput.value : '1', 10);

      return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    }

    function appleMouseStockCanFulfil(status, requiredQuantity) {
      if (!status || status.unknown || status.available === false) return false;

      if (typeof status.availableQty === 'number') {
        return status.availableQty >= requiredQuantity;
      }

      return status.available !== false;
    }

    function updateAppleMouseAddonAvailability() {
      if (!appleMouseAddonInput || rentalProductTitle.indexOf('macbook rental') === -1) return false;

      var wasChecked = !!appleMouseAddonInput.checked;
      var wasDisabled = !!appleMouseAddonInput.disabled;
      var requiredQuantity = getRequestedAppleMouseQuantity();
      var statusLoaded = !!appleMouseAddonStockStatus;
      var available = statusLoaded && appleMouseStockCanFulfil(
        appleMouseAddonStockStatus,
        requiredQuantity
      );
      var card = appleMouseAddonInput.closest('.rental-addon-card');
      var title = card ? card.querySelector('.rental-addon-title') : null;

      appleMouseAddonInput.disabled = !available;
      appleMouseAddonInput.setAttribute('aria-disabled', available ? 'false' : 'true');

      if (!available && appleMouseAddonInput.checked) {
        appleMouseAddonInput.checked = false;
      }

      if (card) {
        card.classList.toggle('is-rental-stock-unavailable', !available);
        card.setAttribute('aria-disabled', available ? 'false' : 'true');

        if (available) {
          card.removeAttribute('title');
        } else if (!statusLoaded) {
          card.setAttribute('title', 'Checking Apple Mouse availability.');
        } else {
          card.setAttribute('title', 'Apple Mouse is currently unavailable.');
        }
      }

      if (title) title.textContent = 'Apple Mouse';

      var stateChanged =
        wasChecked !== !!appleMouseAddonInput.checked ||
        wasDisabled !== !!appleMouseAddonInput.disabled;

      if (stateChanged) {
        updateAddonCards();
      }

      return stateChanged;
    }

    function fetchAppleMouseAddonVariantStatus(cartQuantitiesByVariantId) {
      return fetchSecurityDepositVariantStatus(appleMouseAddonVariantId, cartQuantitiesByVariantId)
        .then(function (status) {
          
          if (status && status.unknown) {
            status.available = false;
            status.availableQty = 0;
          }
          return status;
        });
    }

    function loadAppleMouseAddonStockAvailability(forcePriceRefresh) {
      if (!appleMouseAddonInput || rentalProductTitle.indexOf('macbook rental') === -1) {
        return Promise.resolve(null);
      }

      var requestSequence = ++appleMouseAddonStockRequestSequence;

      return Promise.all([
        fetchCartQuantitiesByVariantId(),
        loadLiveVariantPricesBestEffort([appleMouseAddonVariantId], !!forcePriceRefresh)
      ])
        .then(function (results) {
          var cartQuantitiesByVariantId = results[0] || {};
          return fetchAppleMouseAddonVariantStatus(cartQuantitiesByVariantId);
        })
        .then(function (status) {
          if (requestSequence !== appleMouseAddonStockRequestSequence) {
            return appleMouseAddonStockStatus;
          }

          appleMouseAddonStockStatus = status || {
            variantId: String(appleMouseAddonVariantId),
            available: false,
            availableQty: 0,
            unknown: true
          };

          updateAppleMouseAddonAvailability();
          syncLiveVariantPriceRows();
          updateTotal();

          return appleMouseAddonStockStatus;
        })
        .catch(function (error) {
          console.error('Apple Mouse stock availability check error:', error);

          if (requestSequence === appleMouseAddonStockRequestSequence) {
            appleMouseAddonStockStatus = {
              variantId: String(appleMouseAddonVariantId),
              available: false,
              availableQty: 0,
              unknown: true
            };
            updateAppleMouseAddonAvailability();
            updateTotal();
          }

          return null;
        });
    }

    function normalisePencilIpadModel(value) {
      var text = getBaseIpadProcessorValue(value)
        .toLowerCase()
        .replace(/[()]/g, ' ')
        .replace(/\b(?:wi-?fi|cellular)\b/g, ' ')
        .replace(/\b(?:model|version|only|from)\b/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

      if (/\bipad\s+air\s+(?:5|5th)(?:\s+gen(?:eration)?)?\b/.test(text) || /\bipad\s+air\b.*\bm1\b/.test(text)) {
        return 'ipad air m1';
      }
      if (/\bipad\s+mini\b.*\ba17\s+pro\b/.test(text)) return 'ipad mini a17 pro';
      if (/\bipad\s+mini\b.*\b6(?:th)?\b/.test(text)) return 'ipad mini 6';
      if (/\bipad\s+pro\b.*\bm1\b/.test(text)) return 'ipad pro m1';
      if (/\bipad\s+pro\b.*\bm2\b/.test(text)) return 'ipad pro m2';
      if (/\bipad\s+pro\b.*\bm4\b/.test(text)) return 'ipad pro m4';
      if (/\bipad\s+pro\b.*\bm5\b/.test(text)) return 'ipad pro m5';
      if (/\bipad\s+air\b.*\bm2\b/.test(text)) return 'ipad air m2';
      if (/\bipad\s+air\b.*\bm3\b/.test(text)) return 'ipad air m3';
      if (/\bipad\s+air\b.*\bm4\b/.test(text)) return 'ipad air m4';
      if (/\bipad\b.*\ba16\b/.test(text)) return 'ipad a16';
      if (/\bipad\b.*\b10(?:th)?\b/.test(text)) return 'ipad 10th';
      if (/\bipad\b.*\b9(?:th)?\b/.test(text)) return 'ipad 9th';
      if (/\bipad\b.*\b8(?:th)?\b/.test(text)) return 'ipad 8th';

      return text;
    }

    function getCompatiblePencilAddonConfigs(processorValue) {
      if (!isIpadRentalPage()) return [];

      var modelKey = normalisePencilIpadModel(processorValue || getRawSelectedProcessorValue());
      if (!modelKey) return [];

      return pencilAddonVariantPriority.filter(function (config) {
        return config.compatibleModels.indexOf(modelKey) !== -1;
      });
    }

    function getRequestedPencilQuantity() {
      var quantityInput = rentalForm
        ? rentalForm.querySelector('input[name="quantity"]')
        : document.querySelector('#RentalProductForm input[name="quantity"]');
      var quantity = parseInt(quantityInput ? quantityInput.value : '1', 10);

      return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    }

    function pencilStockCanFulfil(status, requiredQuantity) {
      if (!status || status.unknown || status.available === false) return false;

      if (typeof status.availableQty === 'number') {
        return status.availableQty >= requiredQuantity;
      }

      return status.available !== false;
    }

    function getPreferredAvailablePencilAddonConfig(processorValue) {
      var requiredQuantity = getRequestedPencilQuantity();
      var compatibleConfigs = getCompatiblePencilAddonConfigs(processorValue);

      return compatibleConfigs.find(function (config) {
        var status = pencilAddonStockStatusByVariantId[String(config.variantId)];
        return pencilStockCanFulfil(status, requiredQuantity);
      }) || null;
    }

    function setSelectedPencilAddonConfig(config) {
      selectedPencilAddonConfig = config || null;
      pencilAddonVariantId = config ? Number(config.variantId) : 0;
      pencilAddonCents = config
        ? getLiveVariantPriceCents(config.variantId)
        : null;
    }

    function updatePencilAddonAvailability() {
      if (!pencilAddonInput || !isIpadRentalPage()) return false;

      var previousVariantId = Number(pencilAddonVariantId || 0);
      var wasChecked = !!pencilAddonInput.checked;
      var wasDisabled = !!pencilAddonInput.disabled;
      var compatibleConfigs = getCompatiblePencilAddonConfigs(getRawSelectedProcessorValue());
      var selectedConfig = getPreferredAvailablePencilAddonConfig(getRawSelectedProcessorValue());
      var card = pencilAddonInput.closest('.rental-addon-card');
      var title = card ? card.querySelector('.rental-addon-title') : null;
      var available = !!selectedConfig;
      var statusesLoaded = compatibleConfigs.length > 0 && compatibleConfigs.every(function (config) {
        return Object.prototype.hasOwnProperty.call(
          pencilAddonStockStatusByVariantId,
          String(config.variantId)
        );
      });

      setSelectedPencilAddonConfig(selectedConfig);

      pencilAddonInput.disabled = !available;
      pencilAddonInput.setAttribute('aria-disabled', available ? 'false' : 'true');

      if (!available && pencilAddonInput.checked) {
        pencilAddonInput.checked = false;
      }

      if (card) {
        card.classList.toggle('is-rental-stock-unavailable', !available);
        card.setAttribute('aria-disabled', available ? 'false' : 'true');

        if (available) {
          card.removeAttribute('title');
        } else if (!compatibleConfigs.length) {
          card.setAttribute('title', 'Pencil is not available for the selected iPad model.');
        } else if (!statusesLoaded) {
          card.setAttribute('title', 'Checking Pencil availability.');
        } else {
          card.setAttribute('title', 'Pencil is currently unavailable for the selected iPad model.');
        }
      }

      if (title) title.textContent = 'Pencil';

      var stateChanged =
        previousVariantId !== Number(pencilAddonVariantId || 0) ||
        wasChecked !== !!pencilAddonInput.checked ||
        wasDisabled !== !!pencilAddonInput.disabled;

      if (stateChanged) {
        updateAddonCards();
      }

      return stateChanged;
    }

    function fetchPencilAddonVariantStatus(variantId, cartQuantitiesByVariantId) {
      return fetchSecurityDepositVariantStatus(variantId, cartQuantitiesByVariantId)
        .then(function (status) {
          
          if (status && status.unknown) {
            status.available = false;
            status.availableQty = 0;
          }
          return status;
        });
    }

    function loadPencilAddonStockAvailability(forcePriceRefresh) {
      if (!pencilAddonInput || !isIpadRentalPage()) return Promise.resolve(null);

      var requestSequence = ++pencilAddonStockRequestSequence;
      var variantIds = pencilAddonVariantPriority.map(function (config) {
        return config.variantId;
      });

      return Promise.all([
        fetchCartQuantitiesByVariantId(),
        loadLiveVariantPricesBestEffort(variantIds, !!forcePriceRefresh)
      ])
        .then(function (results) {
          var cartQuantitiesByVariantId = results[0] || {};

          return Promise.all(variantIds.map(function (variantId) {
            return fetchPencilAddonVariantStatus(variantId, cartQuantitiesByVariantId);
          }));
        })
        .then(function (statuses) {
          if (requestSequence !== pencilAddonStockRequestSequence) {
            return selectedPencilAddonConfig;
          }

          statuses.forEach(function (status) {
            if (!status || !status.variantId) return;
            pencilAddonStockStatusByVariantId[String(status.variantId)] = status;
          });

          updatePencilAddonAvailability();
          syncLiveVariantPriceRows();
          updateTotal();

          return selectedPencilAddonConfig;
        })
        .catch(function (error) {
          console.error('Pencil stock availability check error:', error);
          updatePencilAddonAvailability();
          updateTotal();
          return null;
        });
    }

    function markRentalOptionStockState(input, unavailable) {
      if (!input) return;

      var card = input.closest('.rental-option-card');
      if (!card) return;

      input.disabled = unavailable;
      card.classList.toggle('is-rental-stock-unavailable', unavailable);
      card.setAttribute('aria-disabled', unavailable ? 'true' : 'false');

      if (unavailable) {
        card.setAttribute('title', 'This rental option is currently unavailable');
      } else {
        card.removeAttribute('title');
      }
    }

    function getCellularAddonTitleElement() {
      if (!cellularAddonInput) return null;
      var card = cellularAddonInput.closest('.rental-addon-card');
      return card ? card.querySelector('.rental-addon-title') : null;
    }

    function ipadCellularRentalVariantExists(baseProcessor) {
      if (!isIpadRentalPage()) return false;

      var cellularProcessor = getCellularIpadProcessorValue(baseProcessor);
      var processorIndex = getRentalProcessorOptionIndex();

      if (!cellularProcessor || processorIndex < 0) return false;

      return allVariants.some(function (variant) {
        return !!(
          variant &&
          Array.isArray(variant.options) &&
          variant.options[processorIndex] === cellularProcessor
        );
      });
    }

    function getIpadConnectivityAvailability(baseProcessor) {
      var baseValue = getBaseIpadProcessorValue(baseProcessor);
      var wifiConfig = baseValue
        ? getSecurityDepositConfigForOptionText(baseValue)
        : null;
      var cellularProcessor = baseValue
        ? getCellularIpadProcessorValue(baseValue)
        : '';
      var cellularConfig = cellularProcessor
        ? getSecurityDepositConfigForOptionText(cellularProcessor)
        : null;
      var wifiStatus = wifiConfig && wifiConfig.variantId
        ? securityDepositStockStatusByVariantId[String(wifiConfig.variantId)]
        : null;
      var cellularStatus = cellularConfig && cellularConfig.variantId
        ? securityDepositStockStatusByVariantId[String(cellularConfig.variantId)]
        : null;

      function stockStatusIsAvailable(status) {
        if (!status) return true;

        if (typeof status.availableQty === 'number' && status.availableQty <= 0) {
          return false;
        }

        return status.available !== false;
      }

      var wifiAvailable = stockStatusIsAvailable(wifiStatus);
      var cellularAvailable = !!(
        cellularProcessor &&
        cellularConfig &&
        cellularConfig.variantId &&
        ipadCellularRentalVariantExists(baseValue) &&
        stockStatusIsAvailable(cellularStatus)
      );

      return {
        baseProcessor: baseValue,
        cellularProcessor: cellularProcessor,
        wifiAvailable: wifiAvailable,
        cellularAvailable: cellularAvailable
      };
    }

    function updateIpadCellularModeAvailability() {
      if (!cellularAddonInput || !isIpadRentalPage()) return false;

      var availability = getIpadConnectivityAvailability(getRawSelectedProcessorValue());
      var forceCellular = !availability.wifiAvailable && availability.cellularAvailable;
      var wasChecked = !!cellularAddonInput.checked;
      var wasDisabled = !!cellularAddonInput.disabled;
      var wasForced = cellularAddonInput.getAttribute('data-cellular-forced') === 'true';
      var card = cellularAddonInput.closest('.rental-addon-card');
      var title = getCellularAddonTitleElement();

      if (forceCellular) {
        cellularAddonInput.checked = true;
        cellularAddonInput.disabled = false;
        cellularAddonInput.setAttribute('data-cellular-forced', 'true');
        cellularAddonInput.setAttribute('aria-disabled', 'true');
      } else {
        
        if (wasForced) {
          cellularAddonInput.checked = false;
        }

        cellularAddonInput.removeAttribute('data-cellular-forced');
        cellularAddonInput.disabled = !availability.cellularAvailable;
        cellularAddonInput.setAttribute(
          'aria-disabled',
          availability.cellularAvailable ? 'false' : 'true'
        );

        if (!availability.cellularAvailable && cellularAddonInput.checked) {
          cellularAddonInput.checked = false;
        }
      }

      if (card) {
        card.classList.toggle('is-rental-stock-unavailable', !availability.cellularAvailable);
        card.classList.toggle('is-cellular-only', forceCellular);
        card.setAttribute(
          'aria-disabled',
          forceCellular || !availability.cellularAvailable ? 'true' : 'false'
        );

        if (forceCellular) {
          card.setAttribute('title', 'Wi-Fi is unavailable for this model. Cellular has been selected.');
        } else if (availability.cellularAvailable) {
          card.removeAttribute('title');
        } else {
          card.setAttribute('title', 'Cellular is currently unavailable for this iPad model');
        }
      }

      if (title) {
        
        title.textContent = 'Cellular';
      }

      var modeChanged =
        wasChecked !== !!cellularAddonInput.checked ||
        wasDisabled !== !!cellularAddonInput.disabled ||
        wasForced !== forceCellular;

      if (modeChanged) {
        updateAddonCards();
      }

      return modeChanged;
    }

    function applySecurityDepositStockStatusToOptions() {
      optionInputs.forEach(function (input) {
        if (
          isIpadRentalPage() &&
          !isIpadCellularProcessorValue(input.value) &&
          input.getAttribute('data-option-position') === getRentalProcessorSelectPosition()
        ) {
          var connectivity = getIpadConnectivityAvailability(input.value);

          markRentalOptionStockState(
            input,
            !connectivity.wifiAvailable && !connectivity.cellularAvailable
          );
          return;
        }

        var config = getSecurityDepositConfigForOptionText(input.value);

        if (!config || !config.variantId) {
          return;
        }

        var status = securityDepositStockStatusByVariantId[String(config.variantId)];
        if (!status) return;

        markRentalOptionStockState(input, status.available === false);
      });

      document.querySelectorAll('.rental-option-group[data-option-position]').forEach(function (group) {
        var checked = group.querySelector('.rental-option-radio:checked');

        if (checked && checked.disabled) {
          var replacement = group.querySelector('.rental-option-radio:not(:disabled):not([data-internal-cellular-processor="true"])');

          if (replacement) {
            replacement.checked = true;
            replacement.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });

      var cellularModeChanged = updateIpadCellularModeAvailability();

      if (cellularModeChanged) {
        refreshSelectedRentalConfiguration();
        return;
      }

      applyMinimumRentalPeriodRule();
      syncRentalPeriodSelectFromRadio();
      syncRentalPeriodSelectDisabledOptions();
      syncRentalProcessorSelectFromRadio();
      syncRentalProcessorSelectDisabledOptions();
      updateSelectedCards();
      updateTotal();
      updateRentalInfoPanels();
      updateRentalEndInfo();
    }

    function loadSecurityDepositStockAvailability() {
      var variantIds = getRelevantSecurityDepositVariantIds();
      if (!variantIds.length) return Promise.resolve([]);

      return fetchCartQuantitiesByVariantId()
        .then(function (cartQuantitiesByVariantId) {
          return Promise.all(
            variantIds.map(function (variantId) {
              return fetchSecurityDepositVariantStatus(variantId, cartQuantitiesByVariantId);
            })
          );
        })
        .then(function (statuses) {
          statuses.forEach(function (status) {
            securityDepositStockStatusByVariantId[String(status.variantId)] = status;
          });

          applySecurityDepositStockStatusToOptions();
        })
        .catch(function (error) {
          console.error('Rental stock availability check error:', error);
        });
    }

    function selectedRentalOptionIsAvailable() {
      var selectedConfig = getSecurityDepositConfig();

      if (!selectedConfig || !selectedConfig.variantId) {
        return true;
      }

      var status = securityDepositStockStatusByVariantId[String(selectedConfig.variantId)];

      if (status && status.available === false) {
        return false;
      }

      if (
        status &&
        typeof status.availableQty === 'number' &&
        status.availableQty < getRequestedRentalQuantity()
      ) {
        return false;
      }

      var selectedUnavailableInput = Array.prototype.some.call(optionInputs, function (input) {
        return input.checked && input.disabled;
      });

      return !selectedUnavailableInput;
    }

    function selectedGamingProcessorIncludes32GB() {
      if (!memoryAddonInput || rentalProductTitle.indexOf('gaming laptop rental') === -1) return false;

      return String(getSelectedProcessorText() || '').toLowerCase().indexOf('rtx 5080') !== -1;
    }

    function updateMemoryAddonAvailability() {
      if (!memoryAddonInput) return false;

      var unavailable = selectedGamingProcessorIncludes32GB();
      var wasChecked = !!memoryAddonInput.checked;
      var wasDisabled = !!memoryAddonInput.disabled;
      var card = memoryAddonInput.closest('.rental-addon-card');
      var title = card ? card.querySelector('.rental-addon-title') : null;

      if (unavailable && memoryAddonInput.checked) {
        memoryAddonInput.checked = false;
      }

      memoryAddonInput.disabled = unavailable;
      memoryAddonInput.setAttribute('aria-disabled', unavailable ? 'true' : 'false');

      if (card) {
        card.classList.toggle('is-rental-stock-unavailable', unavailable);
        card.setAttribute('aria-disabled', unavailable ? 'true' : 'false');

        if (unavailable) {
          card.setAttribute('title', '32GB memory is already included with RTX 5080.');
        } else {
          card.removeAttribute('title');
        }
      }

      if (title) title.textContent = '32GB Memory';

      var stateChanged =
        wasChecked !== !!memoryAddonInput.checked ||
        wasDisabled !== !!memoryAddonInput.disabled;

      if (stateChanged) updateAddonCards();
      return stateChanged;
    }

    function memoryAddonApplied() {
      return !!(memoryAddonInput && memoryAddonInput.checked && !memoryAddonInput.disabled);
    }

    function officeAddonApplied() {
      return !!(officeAddonInput && officeAddonInput.checked);
    }

    function appleMouseAddonApplied() {
      return !!(appleMouseAddonInput && appleMouseAddonInput.checked);
    }

    function hdmiAddonApplied() {
      return !!(hdmiAddonInput && hdmiAddonInput.checked);
    }

    function cellularAddonApplied() {
      return !!(cellularAddonInput && cellularAddonInput.checked);
    }

    function pencilAddonApplied() {
      return !!(pencilAddonInput && pencilAddonInput.checked);
    }

    function standardReturnExtensionApplied() {
      return !!(returnTimeInput && returnTimeInput.value === '1pm–3pm');
    }

    function priorityReturnExtensionApplied() {
      return !!(returnTimeInput && returnTimeInput.value === '3pm–5pm');
    }

    function updateTotal() {
      updateBasePriceLabel();
      syncLiveVariantPriceRows();

      var basePrice = getBasePrice();
      var applyWeekend = weekendApplied();
      var applyEarly = earlyDeliveryApplied();
      var applyPriorityUrgent = priorityUrgentChargeApplied();
      var applyStandardUrgent = standardUrgentChargeApplied();
      var applyStandardReturnExtension = standardReturnExtensionApplied();
      var applyPriorityReturnExtension = priorityReturnExtensionApplied();
      var applyMemoryAddon = memoryAddonApplied();
      var applyOfficeAddon = officeAddonApplied();
      var applyAppleMouseAddon = appleMouseAddonApplied();
      var applyHdmiAddon = hdmiAddonApplied();
      var applyPencilAddon = pencilAddonApplied();
      var securityDepositConfig = getSecurityDepositConfig();
      var securityDepositCents = securityDepositConfig ? securityDepositConfig.cents : null;

      if (memoryAddonRow) memoryAddonRow.style.display = applyMemoryAddon ? 'flex' : 'none';
      if (officeAddonRow) officeAddonRow.style.display = applyOfficeAddon ? 'flex' : 'none';
      if (appleMouseAddonRow) appleMouseAddonRow.style.display = applyAppleMouseAddon ? 'flex' : 'none';
      if (hdmiAddonRow) hdmiAddonRow.style.display = applyHdmiAddon ? 'flex' : 'none';
      if (cellularAddonRow) cellularAddonRow.style.display = 'none';
      if (pencilAddonRow) pencilAddonRow.style.display = applyPencilAddon ? 'flex' : 'none';

      if (surchargeRow) surchargeRow.style.display = applyWeekend ? 'flex' : 'none';
      if (earlyDeliveryRow) earlyDeliveryRow.style.display = applyEarly ? 'flex' : 'none';
      if (priorityUrgentChargeRow) priorityUrgentChargeRow.style.display = applyPriorityUrgent ? 'flex' : 'none';
      if (standardUrgentChargeRow) standardUrgentChargeRow.style.display = applyStandardUrgent ? 'flex' : 'none';
      if (standardReturnExtensionRow) {
        standardReturnExtensionRow.style.display = applyStandardReturnExtension ? 'flex' : 'none';
      }
      if (priorityReturnExtensionRow) {
        priorityReturnExtensionRow.style.display = applyPriorityReturnExtension ? 'flex' : 'none';
      }

      if (surchargeAppliedInput) surchargeAppliedInput.value = applyWeekend ? 'Yes' : 'No';
      if (surchargeAmountInput) {
        surchargeAmountInput.value = applyWeekend && Number.isFinite(weekendSurchargeCents)
          ? formatMoney(weekendSurchargeCents)
          : (applyWeekend ? '' : formatMoney(0));
      }

      if (securityDepositValueEl) {
        securityDepositValueEl.textContent = Number.isFinite(securityDepositCents)
          ? formatMoney(securityDepositCents)
          : 'Loading…';
      }

      if (mobileSummaryJumpDeposit) {
        mobileSummaryJumpDeposit.textContent = Number.isFinite(securityDepositCents)
          ? formatMoney(securityDepositCents)
          : 'Loading…';
      }

      var requiredPrices = [securityDepositCents];
      if (applyWeekend) requiredPrices.push(weekendSurchargeCents);
      if (applyEarly) requiredPrices.push(earlyDeliverySurchargeCents);
      if (applyPriorityUrgent) requiredPrices.push(priorityUrgentChargeCents);
      if (applyStandardUrgent) requiredPrices.push(standardUrgentChargeCents);
      if (applyStandardReturnExtension) requiredPrices.push(standardReturnExtensionCents);
      if (applyPriorityReturnExtension) requiredPrices.push(priorityReturnExtensionCents);
      if (applyMemoryAddon) requiredPrices.push(memoryAddonCents);
      if (applyOfficeAddon) requiredPrices.push(officeAddonCents);
      if (applyAppleMouseAddon) requiredPrices.push(appleMouseAddonCents);
      if (applyHdmiAddon) requiredPrices.push(hdmiAddonCents);
      if (applyPencilAddon) requiredPrices.push(pencilAddonCents);

      var pricingReady = requiredPrices.every(function (cents) {
        return Number.isFinite(cents);
      });

      if (!pricingReady) {
        if (totalPriceEl) totalPriceEl.textContent = 'Loading…';
        if (mobileSummaryJumpRentalCost) mobileSummaryJumpRentalCost.textContent = 'Loading…';
        return;
      }

      var total = basePrice
        + securityDepositCents
        + (applyWeekend ? weekendSurchargeCents : 0)
        + (applyEarly ? earlyDeliverySurchargeCents : 0)
        + (applyPriorityUrgent ? priorityUrgentChargeCents : 0)
        + (applyStandardUrgent ? standardUrgentChargeCents : 0)
        + (applyStandardReturnExtension ? standardReturnExtensionCents : 0)
        + (applyPriorityReturnExtension ? priorityReturnExtensionCents : 0)
        + (applyMemoryAddon ? memoryAddonCents : 0)
        + (applyOfficeAddon ? officeAddonCents : 0)
        + (applyAppleMouseAddon ? appleMouseAddonCents : 0)
        + (applyHdmiAddon ? hdmiAddonCents : 0)
        + (applyPencilAddon ? pencilAddonCents : 0);

      if (totalPriceEl) totalPriceEl.textContent = formatFinalRentalTotalMoney(total);

      if (mobileSummaryJumpRentalCost) {
        mobileSummaryJumpRentalCost.textContent = formatMoney(total - securityDepositCents);
      }
    }

    function parseLocalDate(dateString) {
      if (!dateString) return null;
      var parts = dateString.split('-');
      if (parts.length !== 3) return null;

      var date = new Date(parts[0], parts[1] - 1, parts[2]);
      date.setHours(0, 0, 0, 0);
      return date;
    }

    function formatDisplayDate(date) {
      if (!date) return '-';

      var day = date.getDate();
      var year = date.getFullYear();

      var months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];

      var monthName = months[date.getMonth()];

      return day + ' ' + monthName + ' ' + year;
    }

    function formatDateProperty(date) {
      if (!date) return '';

      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');

      return year + '-' + month + '-' + day;
    }

    function getSelectedRentalPeriod() {
      var groups = document.querySelectorAll('.rental-option-group');
      var selectedValue = '';

      groups.forEach(function (group) {
        var titleEl = group.querySelector('.rental-option-group-title');
        var checked = group.querySelector('.rental-option-radio:checked');

        if (!titleEl || !checked) return;

        var groupTitle = (titleEl.textContent || '').trim().toLowerCase();
        if (groupTitle === 'rental period') {
          selectedValue = checked.value;
        }
      });

      return selectedValue;
    }

    function getRentalEndDate(startDate, rentalPeriod) {
  if (!startDate || !rentalPeriod) return null;

  var endDate = new Date(startDate.getTime());
  var period = String(rentalPeriod || '').toLowerCase();

  function getMonthDuration(value) {
    var match = String(value || '').match(/(\d+)\s*month/i);
    return match ? parseInt(match[1], 10) : 0;
  }

  function getEndDateByCalendarMonths(date, months) {
    var targetFirstDay = new Date(date.getFullYear(), date.getMonth() + months, 1);
    var targetLastDay = new Date(targetFirstDay.getFullYear(), targetFirstDay.getMonth() + 1, 0).getDate();
    var targetDay = Math.min(date.getDate(), targetLastDay);
    var result = new Date(targetFirstDay.getFullYear(), targetFirstDay.getMonth(), targetDay);

    result.setDate(result.getDate() - 1);
    return result;
  }

  var monthDuration = getMonthDuration(period);
  if (monthDuration > 0) {
    return getEndDateByCalendarMonths(startDate, monthDuration);
  }

  if (period.indexOf('1 day') !== -1) {
    endDate.setDate(endDate.getDate() + 0);
    return endDate;
  }

  if (period.indexOf('2 day') !== -1) {
    endDate.setDate(endDate.getDate() + 1);
    return endDate;
  }

  if (period.indexOf('3 day') !== -1) {
    endDate.setDate(endDate.getDate() + 2);
    return endDate;
  }

  if (period.indexOf('4 day') !== -1) {
    endDate.setDate(endDate.getDate() + 3);
    return endDate;
  }

  if (period.indexOf('5 day') !== -1) {
    endDate.setDate(endDate.getDate() + 4);
    return endDate;
  }

  if (period.indexOf('6 day') !== -1) {
    endDate.setDate(endDate.getDate() + 5);
    return endDate;
  }

  if (period.indexOf('1 week') !== -1) {
    endDate.setDate(endDate.getDate() + 6);
    return endDate;
  }

  if (period.indexOf('2 week') !== -1) {
    endDate.setDate(endDate.getDate() + 13);
    return endDate;
  }

  if (period.indexOf('3 week') !== -1) {
    endDate.setDate(endDate.getDate() + 20);
    return endDate;
  }

  return null;
}

    function validateTimingFields() {
      var deliveryValid = deliveryTimeInput && deliveryTimeInput.value;
      var returnValid = returnTimeInput && returnTimeInput.value;

      return !!(deliveryValid && returnValid);
    }

    function clearRequiredDocumentsAttention() {
      if (requiredDocumentsPanel) {
        requiredDocumentsPanel.classList.remove('is-required-attention');
      }

      if (uploadDocumentsPanel) {
        uploadDocumentsPanel.classList.remove('is-required-attention');
      }

      if (jotformStatusNote) {
        jotformStatusNote.classList.remove('is-error');
      }
    }

    function focusRequiredDocumentsPanel() {
      if (!requiredDocumentsPanel) return;

      if (compatibilityPanel && compatibilityPanel.open) {
        compatibilityPanel.open = false;
      }

      requiredDocumentsPanel.open = true;
      requiredDocumentsPanel.classList.add('is-required-attention');
      suppressMobileSummaryJumpForValidation();

      if (uploadDocumentsPanel) {
        uploadDocumentsPanel.classList.add('is-required-attention');
      }

      if (jotformStatusNote) {
        jotformStatusNote.textContent = 'Please upload the required documents before selecting rental.';
        jotformStatusNote.classList.remove('is-success');
        jotformStatusNote.classList.add('is-error');
      }

      window.setTimeout(function () {
        (uploadDocumentsPanel || requiredDocumentsPanel).scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }, 80);
    }

    function updateRentalEndInfo() {
      var startValue = startDateInput ? startDateInput.value : '';
      var startDate = parseLocalDate(startValue);
      var rentalPeriod = getSelectedRentalPeriod();
      var endDate = getRentalEndDate(startDate, rentalPeriod);
      var selectedDeliveryTime = deliveryTimeInput && deliveryTimeInput.selectedIndex > 0
        ? stripDeliveryChargeSuffix(deliveryTimeInput.options[deliveryTimeInput.selectedIndex].text)
        : '';
      var selectedReturnTime = returnTimeInput && returnTimeInput.value ? returnTimeInput.value : 'before 1pm';

      if (!startDate || !rentalPeriod || !endDate) {
        if (endInfoWrap) endInfoWrap.style.display = 'none';
        if (startPreview) startPreview.textContent = '-';
        if (endPreview) endPreview.textContent = '-';
        if (returnNote) returnNote.textContent = 'Return timing: please select return timing';
        if (rentalPriceMobileTimingRows) rentalPriceMobileTimingRows.style.display = 'none';
        if (rentalPriceMobileStart) rentalPriceMobileStart.textContent = '-';
        if (rentalPriceMobileEnd) rentalPriceMobileEnd.textContent = '-';
        return;
      }

      if (endInfoWrap) endInfoWrap.style.display = 'block';

      if (startPreview) {
        startPreview.textContent = formatDisplayDate(startDate) + (selectedDeliveryTime ? ', ' + selectedDeliveryTime : '');
      }

      if (endPreview) {
        endPreview.textContent = formatDisplayDate(endDate) + ', ' + selectedReturnTime;
      }

      if (returnNote) {
        returnNote.textContent = 'Return timing: ' + selectedReturnTime;
      }

      if (rentalPriceMobileTimingRows) {
        rentalPriceMobileTimingRows.style.display = 'block';
      }

      if (rentalPriceMobileStart) {
        rentalPriceMobileStart.textContent = formatDisplayDate(startDate) + (selectedDeliveryTime ? ', ' + selectedDeliveryTime : '');
      }

      if (rentalPriceMobileEnd) {
        rentalPriceMobileEnd.textContent = formatDisplayDate(endDate) + ', ' + selectedReturnTime;
      }

      updateMobileSummaryJumpVisibility();
    }

    function restoreNodeToOriginalPosition(node, originalParent, originalNextSibling) {
      if (!node || !originalParent) return;

      if (node.parentNode === originalParent) {
        if (originalNextSibling && node.nextSibling === originalNextSibling) return;
        if (!originalNextSibling && node === originalParent.lastChild) return;
      }

      if (originalNextSibling && originalNextSibling.parentNode === originalParent) {
        originalParent.insertBefore(node, originalNextSibling);
      } else {
        originalParent.appendChild(node);
      }
    }

    function ensureMobileStandaloneReviewContainers() {
      if (!rentalDetails || !rentalFormWrap) return false;

      if (!mobileStandaloneReviewHost) {
        mobileStandaloneReviewHost = document.createElement('div');
        mobileStandaloneReviewHost.className = 'rental-mobile-standalone-review';
        mobileStandaloneReviewHost.setAttribute('data-rental-mobile-review-host', 'true');
      }

      if (mobileStandaloneReviewHost.parentNode !== rentalDetails ||
          mobileStandaloneReviewHost.previousElementSibling !== rentalFormWrap) {
        rentalDetails.insertBefore(mobileStandaloneReviewHost, rentalFormWrap.nextSibling);
      }

      if (!mobileFinalConfirmationCard) {
        mobileFinalConfirmationCard = document.createElement('div');
        mobileFinalConfirmationCard.className = 'rental-mobile-final-confirmation';
        mobileFinalConfirmationCard.setAttribute('data-rental-mobile-final-confirmation', 'true');
      }

      return true;
    }

    function updateMobileReviewFlowLayout() {
      if (!priceBoxEl || !documentsStepSection || !requiredDocumentsPanel || !rentalTermsField || !submitButton) return;
      if (!ensureMobileStandaloneReviewContainers()) return;

      var reviewOrderIsCorrect =
        documentsStepSection.parentNode === mobileStandaloneReviewHost &&
        priceBoxEl.parentNode === mobileStandaloneReviewHost &&
        mobileFinalConfirmationCard.parentNode === mobileStandaloneReviewHost &&
        rentalTermsField.parentNode === mobileFinalConfirmationCard &&
        submitButton.parentNode === mobileFinalConfirmationCard &&
        documentsStepSection.nextElementSibling === priceBoxEl &&
        priceBoxEl.nextElementSibling === mobileFinalConfirmationCard;

      if (!mobileReviewLayoutApplied || !reviewOrderIsCorrect) {
        mobileStandaloneReviewHost.appendChild(documentsStepSection);
        mobileStandaloneReviewHost.appendChild(priceBoxEl);
        mobileStandaloneReviewHost.appendChild(mobileFinalConfirmationCard);
        mobileFinalConfirmationCard.appendChild(rentalTermsField);
        mobileFinalConfirmationCard.appendChild(submitButton);
      }

      documentsStepSection.classList.add('rental-mobile-review-documents-step');
      priceBoxEl.classList.add('rental-mobile-review-summary');
      requiredDocumentsPanel.classList.add('rental-mobile-review-documents');
      rentalTermsField.classList.add('rental-mobile-review-terms');
      submitButton.classList.add('rental-mobile-review-submit');
      mobileReviewLayoutApplied = true;
    }

    function updateMobileSummaryJumpVisibility() {
      if (!mobileSummaryJump || !priceBoxEl) return;

      var isMobile = !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
      if (!isMobile) {
        mobileSummaryJumpSuppressedForValidation = false;
        mobileSummaryJump.classList.remove('is-visible');
        mobileSummaryJump.hidden = true;
        return;
      }

      if (mobileSummaryJumpSuppressedForValidation) {
        mobileSummaryJump.classList.remove('is-visible');
        mobileSummaryJump.hidden = true;
        return;
      }

      var summaryJumpTrigger = rentalGalleryMain || mainImage || rentalOptionsField || rentalForm;
      if (!summaryJumpTrigger) {
        mobileSummaryJump.classList.remove('is-visible');
        mobileSummaryJump.hidden = true;
        return;
      }

      var triggerRect = summaryJumpTrigger.getBoundingClientRect();
      var priceBoxRect = priceBoxEl.getBoundingClientRect();
      var rentalSummaryTitle = priceBoxEl.querySelector('.rental-price-mobile-period-title');
      var rentalSummaryTitleRect = rentalSummaryTitle
        ? rentalSummaryTitle.getBoundingClientRect()
        : null;
      var viewportHeight = window.visualViewport
        ? window.visualViewport.height
        : window.innerHeight;

      var hasFullyPassedTriggerAtTop = triggerRect.bottom <= 0;
      var rentalSummaryTitleHasFullyEnteredViewport = rentalSummaryTitleRect
        ? rentalSummaryTitleRect.bottom <= viewportHeight - 8
        : priceBoxRect.top <= viewportHeight - 8;
      var shouldShow = hasFullyPassedTriggerAtTop &&
        !rentalSummaryTitleHasFullyEnteredViewport;

      mobileSummaryJump.hidden = !shouldShow;
      mobileSummaryJump.classList.toggle('is-visible', shouldShow);
    }

    function handleMobileReviewFlowChange() {
      updateMobileReviewFlowLayout();
      window.requestAnimationFrame(updateMobileSummaryJumpVisibility);
    }

    function suppressMobileSummaryJumpForValidation() {
      var isMobile = !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
      if (!isMobile || !mobileSummaryJump) return;

      mobileSummaryJumpSuppressedForValidation = true;
      mobileSummaryJump.classList.remove('is-visible');
      mobileSummaryJump.hidden = true;
    }

    function resumeMobileSummaryJumpAfterUserScroll() {
      if (!mobileSummaryJumpSuppressedForValidation) return;

      mobileSummaryJumpSuppressedForValidation = false;
      window.requestAnimationFrame(updateMobileSummaryJumpVisibility);
    }

    function handleMobileSummaryJumpScrollKey(event) {
      if (!mobileSummaryJumpSuppressedForValidation || !event) return;

      var scrollKeys = [
        'ArrowUp',
        'ArrowDown',
        'PageUp',
        'PageDown',
        'Home',
        'End',
        ' ',
        'Spacebar'
      ];

      if (scrollKeys.indexOf(event.key) !== -1) {
        resumeMobileSummaryJumpAfterUserScroll();
      }
    }

    function scrollToRentalSummary() {
      if (!priceBoxEl) return;

      var isMobile = !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
      if (!isMobile) {
        priceBoxEl.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        return;
      }

      var stickyBarHeight = mobileSummaryJump && !mobileSummaryJump.hidden
        ? mobileSummaryJump.getBoundingClientRect().height
        : 0;
      var summaryTop = window.pageYOffset + priceBoxEl.getBoundingClientRect().top;
      var scrollOffset = stickyBarHeight + 12;

      window.scrollTo({
        top: Math.max(0, summaryTop - scrollOffset),
        behavior: 'smooth'
      });
    }

    function getRentalValidationScrollOffset() {
      var isMobile = !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);

      var offset = isMobile ? 84 : 20;

      if (isMobile && mobileSummaryJump && !mobileSummaryJump.hidden) {
        offset += mobileSummaryJump.getBoundingClientRect().height + 12;
      }

      return offset;
    }

    function alignNativeValidationAnchor(control, visibleTarget) {
      if (!control || !visibleTarget || control === visibleTarget) return;
      if (control !== startDateInput) return;

      var anchorParent = control.parentElement;
      if (!anchorParent) return;

      var parentRect = anchorParent.getBoundingClientRect();
      var targetRect = visibleTarget.getBoundingClientRect();

      control.style.position = 'absolute';
      control.style.left = (targetRect.left - parentRect.left) + 'px';
      control.style.top = (targetRect.top - parentRect.top) + 'px';
      control.style.width = targetRect.width + 'px';
      control.style.minWidth = targetRect.width + 'px';
      control.style.height = targetRect.height + 'px';
      control.style.minHeight = targetRect.height + 'px';
      control.style.padding = '0';
      control.style.margin = '0';
      control.style.border = '0';
      control.style.opacity = '0';
      control.style.pointerEvents = 'none';
    }

    function scrollToRentalFieldAndPrompt(control, visibleTarget, message, scrollTarget) {
      if (!control) return;

      suppressMobileSummaryJumpForValidation();

      var target = visibleTarget || control;
      var scrollAnchor = scrollTarget || target;
      alignNativeValidationAnchor(control, target);
      var targetTop = window.pageYOffset + scrollAnchor.getBoundingClientRect().top;
      var scrollTop = Math.max(0, targetTop - getRentalValidationScrollOffset());

      if (typeof control.setCustomValidity === 'function') {
        control.setCustomValidity(message || 'Please select an item in the list.');
      }

      window.scrollTo({
        top: scrollTop,
        behavior: 'smooth'
      });

      window.setTimeout(function () {
        try {
          control.focus({ preventScroll: true });
        } catch (error) {
          control.focus();
        }

        if (typeof control.reportValidity === 'function') {
          control.reportValidity();
        }

        var isMobile = !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
        if (isMobile) {
          window.setTimeout(function () {
            var correctedTop = window.pageYOffset + scrollAnchor.getBoundingClientRect().top;
            window.scrollTo({
              top: Math.max(0, correctedTop - getRentalValidationScrollOffset()),
              behavior: 'auto'
            });
          }, 80);
        }
      }, 360);
    }

    function clearRentalFieldPrompt(control) {
      if (control && typeof control.setCustomValidity === 'function') {
        control.setCustomValidity('');
      }
    }

    function promptRentalStartDateField() {
      var visibleDateTarget = rentalStartDateDisplay && !rentalStartDateDisplay.hidden
        ? rentalStartDateDisplay
        : startDateInput;

      scrollToRentalFieldAndPrompt(
        startDateInput,
        visibleDateTarget,
        'Please select an item in the list.',
        rentalStartDateLabel || visibleDateTarget
      );
    }

    function promptFirstMissingTimingField() {
      if (deliveryTimeInput && !deliveryTimeInput.value) {
        scrollToRentalFieldAndPrompt(
          deliveryTimeInput,
          deliveryTimeInput,
          'Please select an item in the list.',
          rentalDeliveryTimeLabel || deliveryTimeInput
        );
        return false;
      }

      if (returnTimeInput && !returnTimeInput.value) {
        scrollToRentalFieldAndPrompt(
          returnTimeInput,
          returnTimeInput,
          'Please select an item in the list.',
          rentalReturnTimeLabel || returnTimeInput
        );
        return false;
      }

      clearRentalFieldPrompt(deliveryTimeInput);
      clearRentalFieldPrompt(returnTimeInput);
      return true;
    }

    function validateRequiredRentalFieldsWithPrompt() {
      if (validateDateField()) {
        promptRentalStartDateField();
        return false;
      }

      clearRentalFieldPrompt(startDateInput);
      rebuildDeliveryOptions();

      return promptFirstMissingTimingField();
    }

    function validateDateField() {
      var selectedDate = startDateInput ? startDateInput.value : '';
      var invalid = !selectedDate || isInvalidDate(selectedDate);
      var errorMessage = invalid ? getRentalStartDateErrorMessage(selectedDate) : '';

      if (dateError) {
        dateError.textContent = errorMessage;
        dateError.hidden = !invalid || !errorMessage;
      }

      return invalid;
    }

    function getRequestedRentalQuantity() {
      var quantity = parseInt(rentalQuantityInput ? rentalQuantityInput.value : '1', 10);
      return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    }

    function setLoadingState(isLoading) {
      if (!submitButton) return;

      submitButton.disabled = isLoading;
      submitButton.classList.toggle('is-disabled', isLoading);

      if (rentalEditModeActive) {
        if (isLoading) {
          submitButton.innerHTML =
            '<span aria-hidden="true" style="display:inline-flex;width:16px;height:16px;margin-right:9px;vertical-align:-3px;">' +
              '<svg viewBox="0 0 16 16" width="16" height="16" focusable="false" aria-hidden="true">' +
                '<circle cx="8" cy="8" r="6" fill="none" stroke="rgba(255,255,255,.35)" stroke-width="2"></circle>' +
                '<path d="M8 2a6 6 0 0 1 6 6" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round">' +
                  '<animateTransform attributeName="transform" type="rotate" from="0 8 8" to="360 8 8" dur="0.7s" repeatCount="indefinite"></animateTransform>' +
                '</path>' +
              '</svg>' +
            '</span>' +
            '<span>Updating Rental</span>';
        } else {
          submitButton.textContent = 'Update Rental';
        }
      } else {
        submitButton.textContent = isLoading ? 'Adding Rental...' : 'Select Rental';
      }
    }

    function postCartItems(payload) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            console.log('Shopify add-to-cart error payload:', data);
            throw new Error(data.description || data.message || JSON.stringify(data));
          }
          return data;
        });
      });
    }


    function getRentalEditCacheKey(groupId) {
      return RENTAL_EDIT_CACHE_PREFIX + String(groupId || '').trim();
    }

    function clearRentalEditCache(groupId) {
      if (!groupId) return;

      try {
        window.sessionStorage.removeItem(getRentalEditCacheKey(groupId));
      } catch (error) {}
    }

    function readRentalEditCache(groupId) {
      if (!groupId) return null;

      try {
        var raw = window.sessionStorage.getItem(getRentalEditCacheKey(groupId));
        if (!raw) return null;

        var snapshot = JSON.parse(raw);
        if (!snapshot || snapshot.version !== 1 || String(snapshot.groupId || '') !== String(groupId)) {
          clearRentalEditCache(groupId);
          return null;
        }

        var savedAt = Number(snapshot.savedAt || 0);
        if (!savedAt || Date.now() - savedAt > RENTAL_EDIT_CACHE_MAX_AGE_MS) {
          clearRentalEditCache(groupId);
          return null;
        }

        var currentProductId = Number(rentalPageConfig.productId || 0);
        var cachedProductId = Number(snapshot.productId || snapshot.mainItem && snapshot.mainItem.product_id || 0);
        if (currentProductId && cachedProductId && currentProductId !== cachedProductId) {
          return null;
        }

        return snapshot;
      } catch (error) {
        clearRentalEditCache(groupId);
        return null;
      }
    }

    function getRentalEditItemSignature(item) {
      if (!item) return '';

      var properties = item.properties || {};
      return JSON.stringify([
        Number(item.variant_id || item.id || 0),
        Math.max(1, parseInt(item.quantity, 10) || 1),
        String(properties['Rental start date'] || ''),
        String(properties['Delivery timing'] || ''),
        String(properties['Return timing'] || ''),
        String(properties['Additional notes'] || ''),
        String(properties['Connectivity'] || ''),
        String(properties['32GB addon selected'] || ''),
        String(properties['Microsoft Office addon selected'] || ''),
        String(properties['Apple Mouse optional extra selected'] || ''),
        String(properties['HDMI Port optional extra selected'] || ''),
        String(properties['Pencil optional extra selected'] || ''),
        String(properties['Documents submitted'] || '')
      ]);
    }

    function runRentalInitialValidationLoads(force) {
      if (rentalInitialValidationPromise && !force) {
        return rentalInitialValidationPromise;
      }

      function runTask(label, task) {
        try {
          return Promise.resolve(task()).catch(function (error) {
            console.error(label + ' error:', error);
            return null;
          });
        } catch (error) {
          console.error(label + ' error:', error);
          return Promise.resolve(null);
        }
      }

      rentalInitialValidationPromise = Promise.all([
        runTask('Initial live rental price lookup', function () {
          return loadInitialLiveVariantPrices();
        }),
        runTask('Security deposit stock lookup', function () {
          return loadSecurityDepositStockAvailability();
        }),
        runTask('Apple Mouse stock lookup', function () {
          return loadAppleMouseAddonStockAvailability(false);
        }),
        runTask('Pencil stock lookup', function () {
          return loadPencilAddonStockAvailability(false);
        }),
        runTask('Selected security deposit lead-day lookup', function () {
          return loadSelectedSecurityDepositLeadDays().then(function () {
            updateProcessorAvailabilityNote();
          });
        }),
        runTask('Processor deposit availability lookup', function () {
          return loadProcessorSecurityDepositAvailabilityLabels();
        }),
        runTask('PlayTime availability lookup', function () {
          return loadPlayTimeAvailability();
        })
      ]).then(function () {
        updateAppleMouseAddonAvailability();
        updatePencilAddonAvailability();
        updateAddonCards();
        updateProcessorAvailabilityNote();
        updateRentalInfoPanels();
        updateTotal();
        updateRentalEndInfo();
        return true;
      });

      return rentalInitialValidationPromise;
    }

    function fetchRentalCartForEdit(marker) {
      return fetch('/cart.js?rental_edit=' + encodeURIComponent(marker || Date.now()), {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Cache-Control': 'no-cache'
        },
        cache: 'no-store'
      }).then(function (response) {
        setTrustedNowFromResponse(response);
        if (!response.ok) {
          throw new Error('Unable to read the current rental cart.');
        }
        return response.json();
      });
    }

    function getRentalCartItemGroupId(item) {
      var properties = item && item.properties ? item.properties : {};
      return String(properties['Rental group ID'] || '').trim();
    }

    function rentalCartItemIsLinkedCharge(item) {
      var properties = item && item.properties ? item.properties : {};
      return !!(
        String(properties['Charge type'] || '').trim() ||
        String(properties['Linked rental product'] || '').trim() ||
        String(properties['Linked rental variant'] || '').trim()
      );
    }

    function getRentalEditGroupItems(cart, groupId) {
      if (!cart || !Array.isArray(cart.items) || !groupId) return [];
      return cart.items.filter(function (item) {
        return getRentalCartItemGroupId(item) === groupId;
      });
    }

    function getRentalEditMainItem(groupItems) {
      var expectedProductId = Number(rentalPageConfig.productId || 0);

      return groupItems.find(function (item) {
        if (!item || rentalCartItemIsLinkedCharge(item)) return false;
        if (!expectedProductId) return true;
        return Number(item.product_id || 0) === expectedProductId;
      }) || null;
    }

    function normaliseEditText(value) {
      return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
    }

    function cartEditGroupHasCharge(groupItems, chargeType) {
      var target = normaliseEditText(chargeType);
      return groupItems.some(function (item) {
        var properties = item && item.properties ? item.properties : {};
        return normaliseEditText(properties['Charge type']) === target;
      });
    }

    function cartEditPropertyIsYes(properties, propertyName) {
      return normaliseEditText(properties && properties[propertyName]) === 'yes';
    }

    function setRentalOptionValueForEdit(optionPosition, optionValue) {
      if (!optionPosition || optionValue == null) return false;

      var targetValue = String(optionValue);
      var matchingInput = Array.prototype.find.call(optionInputs, function (input) {
        return input.getAttribute('data-option-position') === String(optionPosition) &&
          String(input.value) === targetValue &&
          input.getAttribute('data-internal-cellular-processor') !== 'true';
      });

      if (!matchingInput) return false;
      matchingInput.checked = true;
      return true;
    }

    function setRentalSelectFromStoredText(select, storedValue, normaliser) {
      if (!select || !storedValue) return false;

      var target = normaliseEditText(storedValue);
      var matchedOption = Array.prototype.find.call(select.options, function (option) {
        var optionValue = normaliseEditText(option.value);
        var optionText = normaliseEditText(
          typeof normaliser === 'function' ? normaliser(option.textContent || '') : option.textContent || ''
        );
        return optionValue === target || optionText === target;
      });

      if (!matchedOption || matchedOption.disabled) return false;
      select.value = matchedOption.value;
      return true;
    }

    function markDocumentsAsSubmittedForActiveRentalCart(message) {
      if (!jotformSubmittedInput) return false;

      jotformSubmittedInput.value = 'Yes';
      documentsReusedFromActiveRentalCart = true;

      if (requiredDocumentsHeading) {
        requiredDocumentsHeading.textContent = 'Documents Submitted';
      }
      if (requiredDocumentsStepNote) {
        requiredDocumentsStepNote.textContent = 'Already submitted for this active checkout — no need to upload again';
      }
      if (jotformStatusNote) {
        jotformStatusNote.textContent = message || 'Your documents are already submitted and remain valid while this rental cart checkout timer is active.';
        jotformStatusNote.classList.remove('is-error');
        jotformStatusNote.classList.add('is-success');
      }
      if (uploadDocumentsPanel) {
        uploadDocumentsPanel.hidden = true;
        uploadDocumentsPanel.style.display = 'none';
      }
      if (requiredDocumentsPanel) {
        requiredDocumentsPanel.removeAttribute('open');
        requiredDocumentsPanel.setAttribute('data-rental-documents-preserved', 'true');
      }

      return true;
    }

    function restoreRequiredDocumentsUpload() {
      documentsReusedFromActiveRentalCart = false;

      if (!jotformSubmittedInput || documentsSubmittedOnCurrentPage) return;

      jotformSubmittedInput.value = 'No';

      if (requiredDocumentsHeading) {
        requiredDocumentsHeading.innerHTML = 'Upload Required Documents <span class="rental-required-docs-asterisk" aria-hidden="true">*</span>';
      }
      if (requiredDocumentsStepNote) {
        requiredDocumentsStepNote.textContent = 'Upload documents for rental verification';
      }
      if (jotformStatusNote) {
        jotformStatusNote.textContent = 'Please submit the required documents before proceeding. Rental is confirmed after verification and all documents are kept confidential.';
        jotformStatusNote.classList.remove('is-success', 'is-error');
      }
      if (uploadDocumentsPanel) {
        uploadDocumentsPanel.hidden = false;
        uploadDocumentsPanel.style.display = '';
      }
      if (requiredDocumentsPanel) {
        requiredDocumentsPanel.removeAttribute('data-rental-documents-preserved');
      }
    }

    function getRentalCartGroupCreatedAtMs(item) {
      var groupId = getRentalCartItemGroupId(item);
      var match = groupId.match(/^rental-(\d{13})(?:-|$)/);
      var createdAtMs = match ? Number(match[1]) : 0;
      return Number.isFinite(createdAtMs) ? createdAtMs : 0;
    }

    function getActiveRentalCartDocumentExpiryMs(cart) {
      if (!cart || !Array.isArray(cart.items)) return 0;

      var earliestRentalCreatedAtMs = 0;
      cart.items.forEach(function (item) {
        if (!getRentalCartItemGroupId(item)) return;
        var createdAtMs = getRentalCartGroupCreatedAtMs(item);
        if (!createdAtMs) return;
        if (!earliestRentalCreatedAtMs || createdAtMs < earliestRentalCreatedAtMs) {
          earliestRentalCreatedAtMs = createdAtMs;
        }
      });

      var groupExpiryMs = earliestRentalCreatedAtMs
        ? earliestRentalCreatedAtMs + (RENTAL_DOCUMENT_SESSION_MINUTES * 60 * 1000)
        : 0;

      var attributes = cart.attributes && typeof cart.attributes === 'object' ? cart.attributes : {};
      var attributeExpiryMs = Date.parse(String(attributes['Rental cart expires at'] || ''));
      if (!Number.isFinite(attributeExpiryMs)) attributeExpiryMs = 0;

      var configuredMinutes = Number(attributes['Rental cart expiry minutes'] || RENTAL_DOCUMENT_SESSION_MINUTES);
      if (Number.isFinite(configuredMinutes) && configuredMinutes !== RENTAL_DOCUMENT_SESSION_MINUTES) {
        attributeExpiryMs = 0;
      }

      var candidates = [groupExpiryMs, attributeExpiryMs].filter(function (value) {
        return Number.isFinite(value) && value > 0;
      });

      return candidates.length ? Math.min.apply(Math, candidates) : 0;
    }

    function cartHasSubmittedRentalDocuments(cart) {
      if (!cart || !Array.isArray(cart.items)) return false;

      return cart.items.some(function (item) {
        if (!item || rentalCartItemIsLinkedCharge(item)) return false;
        if (!getRentalCartItemGroupId(item)) return false;
        var properties = item.properties || {};
        return normaliseEditText(properties['Documents submitted']) === 'yes';
      });
    }

    function activeRentalCartDocumentsAreReusable(cart) {
      if (!cartHasSubmittedRentalDocuments(cart)) return false;

      var expiryMs = getActiveRentalCartDocumentExpiryMs(cart);
      if (!expiryMs) return false;

      return expiryMs > getTrustedNowMs();
    }

    function initialiseActiveRentalCartDocumentReuse(existingCart) {
      if (documentsSubmittedOnCurrentPage) return Promise.resolve(true);

      var cartPromise = existingCart
        ? Promise.resolve(existingCart)
        : fetchRentalCartForEdit('documents-' + Date.now());

      return cartPromise
        .then(function (cart) {
          if (!activeRentalCartDocumentsAreReusable(cart)) {
            restoreRequiredDocumentsUpload();
            return false;
          }

          markDocumentsAsSubmittedForActiveRentalCart(
            'Documents already submitted for this active rental checkout. You do not need to upload them again for another rental while the checkout timer remains active.'
          );
          return true;
        })
        .catch(function (error) {
          console.error('Active rental document session check error:', error);
          restoreRequiredDocumentsUpload();
          return false;
        });
    }

    function revalidateActiveRentalCartDocumentsBeforeSubmit() {
      if (!documentsReusedFromActiveRentalCart || documentsSubmittedOnCurrentPage) {
        return Promise.resolve(true);
      }

      return fetchRentalCartForEdit('documents-submit-' + Date.now())
        .then(function (cart) {
          if (activeRentalCartDocumentsAreReusable(cart)) return true;

          restoreRequiredDocumentsUpload();
          var error = new Error('Your previous document submission is no longer valid because the rental checkout session has ended. Please submit the required documents again.');
          error.code = 'RENTAL_DOCUMENT_SESSION_EXPIRED';
          throw error;
        });
    }

    function preserveSubmittedDocumentsForEdit(mainItem) {
      var properties = mainItem && mainItem.properties ? mainItem.properties : {};
      var documentsWereSubmitted = normaliseEditText(properties['Documents submitted']) === 'yes';
      if (!documentsWereSubmitted) return false;

      return markDocumentsAsSubmittedForActiveRentalCart(
        'Documents are already submitted for this active rental checkout. They remain valid while the checkout timer is active.'
      );
    }

    function clearRentalEditRequestFromUrl() {
      try {
        var url = new URL(window.location.href);
        url.searchParams.delete('edit_rental');
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      } catch (error) {}
    }

    function refreshSelectedRentalConfigurationForEditFastPath() {
      updateIpadCellularModeAvailability();
      updatePencilAddonAvailability();
      updateMemoryAddonAvailability();
      applyMinimumRentalPeriodRule();
      syncRentalPeriodSelectFromRadio();
      syncRentalPeriodSelectDisabledOptions();
      syncRentalProcessorSelectFromRadio();
      syncRentalProcessorSelectDisabledOptions();
      updateSelectedCards();

      var matchedVariant = findMatchingVariant();

      if (matchedVariant) {
        variantIdInput.value = matchedVariant.id;
        var matchedLivePrice = getLiveVariantPriceCents(matchedVariant.id);
        setBasePrice(Number.isFinite(matchedLivePrice) ? matchedLivePrice : matchedVariant.price);
      } else {
        variantIdInput.value = '';
        setBasePrice(0);
      }

      refreshPlayTimeDependentUi(true);
      updateRentalInfoPanels();
    }

    function applyRentalConfigurationFromItem(mainItem, groupItems, options) {
      options = options || {};
      if (!mainItem) throw new Error('Rental item could not be identified.');

      var variantId = Number(mainItem.variant_id || mainItem.id || 0);
      var matchedVariant = allVariants.find(function (variant) {
        return Number(variant && variant.id) === variantId;
      });

      if (!matchedVariant || !Array.isArray(matchedVariant.options)) {
        throw new Error('The rental variant saved in the cart is no longer available on this product page.');
      }

      rentalEditQuantity = Math.max(1, parseInt(mainItem.quantity, 10) || 1);
      if (rentalQuantityInput) rentalQuantityInput.value = String(rentalEditQuantity);

      var processorIndex = getRentalProcessorOptionIndex();
      var restoreCellularMode = false;

      matchedVariant.options.forEach(function (optionValue, optionIndex) {
        var optionPosition = String(optionIndex + 1);
        var valueToRestore = String(optionValue || '');

        if (
          isIpadRentalPage() &&
          processorIndex === optionIndex &&
          isIpadCellularProcessorValue(valueToRestore)
        ) {
          restoreCellularMode = true;
          valueToRestore = getBaseIpadProcessorValue(valueToRestore);
        }

        setRentalOptionValueForEdit(optionPosition, valueToRestore);
      });

      var properties = mainItem.properties || {};

      if (cellularAddonInput) {
        cellularAddonInput.checked = restoreCellularMode || normaliseEditText(properties['Connectivity']) === 'cellular';
      }

      refreshSelectedRentalConfigurationForEditFastPath();

      var storedStartDate = String(properties['Rental start date'] || '').trim();
      if (startDateInput && /^\d{4}-\d{2}-\d{2}$/.test(storedStartDate)) {
        startDateInput.value = storedStartDate;
        setRentalStartDateDisplayText();
      }

      if (rentalNotes) {
        rentalNotes.value = String(properties['Additional notes'] || '');
      }

      rebuildDeliveryOptions();

      setRentalSelectFromStoredText(
        deliveryTimeInput,
        properties['Delivery timing'],
        stripDeliveryChargeSuffix
      );

      if (returnTimeInput && properties['Return timing']) {
        setRentalSelectFromStoredText(returnTimeInput, properties['Return timing']);
      }

      if (memoryAddonInput) {
        memoryAddonInput.checked = cartEditPropertyIsYes(properties, '32GB addon selected') ||
          cartEditGroupHasCharge(groupItems || [], '32GB memory addon');
      }

      if (officeAddonInput) {
        officeAddonInput.checked = cartEditPropertyIsYes(properties, 'Microsoft Office addon selected') ||
          cartEditGroupHasCharge(groupItems || [], 'Microsoft Office addon');
      }

      if (appleMouseAddonInput) {
        appleMouseAddonInput.checked = cartEditPropertyIsYes(properties, 'Apple Mouse optional extra selected') ||
          cartEditGroupHasCharge(groupItems || [], 'Apple Mouse optional extra');
      }

      if (hdmiAddonInput) {
        hdmiAddonInput.checked = cartEditPropertyIsYes(properties, 'HDMI Port optional extra selected') ||
          cartEditGroupHasCharge(groupItems || [], 'HDMI Port optional extra');
      }

      if (pencilAddonInput) {
        pencilAddonInput.checked = (
          cartEditPropertyIsYes(properties, 'Pencil optional extra selected') ||
          cartEditGroupHasCharge(groupItems || [], 'Pencil optional extra')
        ) && !!selectedPencilAddonConfig;
      }

      updateAddonCards();
      updateRentalInfoPanels();
      updateRentalEndInfo();
      updateTotal();
      setRentalStartDateDisplayText();

      if (options.preserveDocuments !== false) {
        preserveSubmittedDocumentsForEdit(mainItem);
      }

      if (rentalOptionsStepTitle) {
        rentalOptionsStepTitle.textContent = 'Update Rental Options';
      }

      if (rentalOptionsStepNote) {
        rentalOptionsStepNote.textContent = options.verifying
          ? 'Your saved rental is loaded. Verifying current availability...'
          : 'Your existing cart rental is loaded below.';
      }

      return matchedVariant;
    }

    function initialiseRentalEditFastPath() {
      if (!rentalEditRequestedGroupId) return false;

      var snapshot = readRentalEditCache(rentalEditRequestedGroupId);
      if (!snapshot || !snapshot.mainItem) return false;

      try {
        rentalEditCachedSnapshot = snapshot;
        rentalEditFastPathApplied = true;
        rentalEditModeActive = true;
        rentalEditMainItem = snapshot.mainItem;
        rentalEditOriginalItems = Array.isArray(snapshot.groupItems) ? snapshot.groupItems.slice() : [];
        applyRentalConfigurationFromItem(
          snapshot.mainItem,
          rentalEditOriginalItems,
          {
            preserveDocuments: true,
            verifying: true
          }
        );
        return true;
      } catch (error) {
        console.warn('Rental edit fast cache restore failed:', error);
        rentalEditCachedSnapshot = null;
        rentalEditFastPathApplied = false;
        rentalEditModeActive = false;
        rentalEditMainItem = null;
        rentalEditOriginalItems = [];
        clearRentalEditCache(rentalEditRequestedGroupId);
        return false;
      }
    }

    function restoreRentalConfigurationFromCart(mainItem, groupItems, forceValidation) {
      try {
        applyRentalConfigurationFromItem(
          mainItem,
          groupItems,
          {
            preserveDocuments: true,
            verifying: false
          }
        );
        setLoadingState(false);
      } catch (error) {
        return Promise.reject(error);
      }

      runRentalInitialValidationLoads(!!forceValidation)
        .then(function () {
          if (!rentalEditModeActive || !rentalEditMainItem) return;

          try {
            applyRentalConfigurationFromItem(
              rentalEditMainItem,
              rentalEditOriginalItems,
              {
                preserveDocuments: true,
                verifying: false
              }
            );
          } catch (error) {
            console.error('Rental edit post-validation refresh error:', error);
          }
        });

      return Promise.resolve(true);
    }

    function initialiseRentalEditMode() {
      if (!rentalEditRequestedGroupId) return Promise.resolve(false);

      setLoadingState(true);

      return fetchRentalCartForEdit('load-' + Date.now())
        .then(function (cart) {
          rentalEditLoadedCart = cart;

          var groupItems = getRentalEditGroupItems(cart, rentalEditRequestedGroupId);
          var mainItem = getRentalEditMainItem(groupItems);

          if (!groupItems.length || !mainItem) {
            var missingGroupId = rentalEditRequestedGroupId;
            rentalEditRequestedGroupId = '';
            rentalEditModeActive = false;
            rentalEditOriginalItems = [];
            rentalEditMainItem = null;
            rentalEditLoadedCart = null;
            clearRentalEditCache(missingGroupId);
            clearRentalEditRequestFromUrl();
            restoreRequiredDocumentsUpload();
            setLoadingState(false);
            window.alert('This rental is no longer in your cart. Please configure a new rental.');
            return false;
          }

          var cachedMainItem = rentalEditCachedSnapshot && rentalEditCachedSnapshot.mainItem
            ? rentalEditCachedSnapshot.mainItem
            : null;
          var cacheDiffersFromCart = !!(
            cachedMainItem &&
            getRentalEditItemSignature(cachedMainItem) !== getRentalEditItemSignature(mainItem)
          );

          rentalEditModeActive = true;
          rentalEditOriginalItems = groupItems.slice();
          rentalEditMainItem = mainItem;

          return restoreRentalConfigurationFromCart(mainItem, groupItems, cacheDiffersFromCart)
            .then(function () { return true; });
        })
        .catch(function (error) {
          console.error('Rental edit initialisation error:', error);
          rentalEditModeActive = false;
          rentalEditLoadedCart = null;
          setLoadingState(false);
          window.alert(error && error.message ? error.message : 'Unable to load this rental for editing.');
          return false;
        });
    }

    function cloneRentalCartItemForRestore(item) {
      var restoreItem = {
        id: Number(item.variant_id || item.id || 0),
        quantity: Math.max(1, Number(item.quantity) || 1)
      };

      if (item.properties && typeof item.properties === 'object') {
        restoreItem.properties = Object.assign({}, item.properties);
      }

      if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
        var sellingPlanId = Number(item.selling_plan_allocation.selling_plan.id || 0);
        if (sellingPlanId > 0) restoreItem.selling_plan = sellingPlanId;
      }

      return restoreItem;
    }

    function removeRentalEditGroupFromCart(groupId) {
      return fetchRentalCartForEdit('remove-' + Date.now())
        .then(function (cart) {
          var updates = {};

          getRentalEditGroupItems(cart, groupId).forEach(function (item) {
            if (item && item.key) updates[item.key] = 0;
          });

          if (!Object.keys(updates).length) return cart;

          return fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ updates: updates })
          }).then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) {
                throw new Error(data.description || data.message || 'Unable to update the rental cart.');
              }
              return data;
            });
          });
        });
    }

    function replaceRentalEditGroup(newItems) {
      if (!rentalEditModeActive || !rentalEditRequestedGroupId) {
        return postCartItems({ items: newItems });
      }

      var originalRestoreItems = rentalEditOriginalItems.map(cloneRentalCartItemForRestore)
        .filter(function (item) { return Number(item.id) > 0; });

      return removeRentalEditGroupFromCart(rentalEditRequestedGroupId)
        .then(function () {
          return postCartItems({ items: newItems });
        })
        .catch(function (updateError) {
          if (!originalRestoreItems.length) throw updateError;

          return fetchRentalCartForEdit('rollback-check-' + Date.now())
            .then(function (cart) {
              var currentGroupItems = getRentalEditGroupItems(cart, rentalEditRequestedGroupId);
              if (!currentGroupItems.length) return null;
              return removeRentalEditGroupFromCart(rentalEditRequestedGroupId);
            })
            .then(function () {
              return postCartItems({ items: originalRestoreItems });
            })
            .then(function () {
              var rollbackError = new Error('Unable to update the rental. Your original rental has been restored in the cart.');
              rollbackError.originalUpdateError = updateError;
              throw rollbackError;
            })
            .catch(function (rollbackFailure) {
              if (
                rollbackFailure &&
                rollbackFailure.message === 'Unable to update the rental. Your original rental has been restored in the cart.'
              ) {
                throw rollbackFailure;
              }

              console.error('Rental edit rollback error:', rollbackFailure);
              var criticalError = new Error('Unable to update the rental and the original rental could not be restored automatically. Please review your cart before proceeding.');
              criticalError.originalUpdateError = updateError;
              throw criticalError;
            });
        });
    }

      window.addEventListener('message', function (event) {
        if (!event || !event.data) return;

        var data = event.data;
        var messageText = '';
        var jotformFrame = document.getElementById('RentalJotform');
        var jotformOrigin = String(event.origin || '');
        var isAllowedJotformOrigin = /^https:\/\/([a-z0-9-]+\.)*jotform\.com$/i.test(jotformOrigin);
        var isJotformFrameMessage = !!(
          jotformFrame &&
          event.source === jotformFrame.contentWindow &&
          isAllowedJotformOrigin
        );

        if (isJotformFrameMessage && typeof data === 'string') {
          var heightMatch = data.match(/^setHeight:(\d+)(?::.*)?$/);
          var submissionAlreadyCompleted = jotformSubmittedInput && jotformSubmittedInput.value === 'Yes';
          if (heightMatch && !submissionAlreadyCompleted) {
            var requestedHeight = parseInt(heightMatch[1], 10);
            if (Number.isFinite(requestedHeight)) {
              jotformFrame.style.height = Math.max(560, Math.min(requestedHeight, 1600)) + 'px';
            }
          }
        }

        if (typeof data === 'string') {
          messageText = data;
        } else {
          try {
            messageText = JSON.stringify(data);
          } catch (error) {
            messageText = '';
          }
        }

        var isSubmitted = isJotformFrameMessage && (
          messageText.indexOf('submission-completed') !== -1 ||
          messageText.indexOf('formID:260751691108053') !== -1 && messageText.indexOf('submission') !== -1 ||
          messageText.indexOf('thankYouPage') !== -1
        );

        if (isSubmitted) {
          documentsSubmittedOnCurrentPage = true;
          documentsReusedFromActiveRentalCart = false;

          if (jotformSubmittedInput) {
            jotformSubmittedInput.value = 'Yes';
          }

          if (jotformStatusNote) {
            jotformStatusNote.textContent = 'Documents submitted successfully.';
            jotformStatusNote.classList.remove('is-error');
            jotformStatusNote.classList.add('is-success');
          }

          var jotformUploadWrap = jotformFrame ? jotformFrame.closest('.rental-doc-upload') : null;
          if (jotformUploadWrap) {
            jotformUploadWrap.classList.add('is-submitted');
          }

          if (jotformFrame) {
            jotformFrame.style.height = '430px';
            jotformFrame.style.minHeight = '0';
          }

          clearRequiredDocumentsAttention();
        }
      });

    if (rentalTermsToggle && rentalTermsBox) {
      rentalTermsToggle.addEventListener('click', function () {
        var isHidden = rentalTermsBox.hasAttribute('hidden');

        if (isHidden) {
          rentalTermsBox.removeAttribute('hidden');
          rentalTermsToggle.textContent = 'Hide ‹';
        } else {
          rentalTermsBox.setAttribute('hidden', '');
          rentalTermsToggle.textContent = 'Terms ›';
        }
      });
    }

    if (thumbs.length && mainImage) {
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          thumbs.forEach(function (item) { item.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          mainImage.src = thumb.getAttribute('data-image-src');
        });
      });
    }

    function refreshSelectedRentalConfiguration() {
      updateIpadCellularModeAvailability();
      updatePencilAddonAvailability();
      updateMemoryAddonAvailability();
      applyMinimumRentalPeriodRule();
      syncRentalPeriodSelectFromRadio();
      syncRentalPeriodSelectDisabledOptions();
      syncRentalProcessorSelectFromRadio();
      syncRentalProcessorSelectDisabledOptions();
      updateSelectedCards();

      var matchedVariant = findMatchingVariant();

      if (matchedVariant) {
        variantIdInput.value = matchedVariant.id;
        var matchedLivePrice = getLiveVariantPriceCents(matchedVariant.id);
        setBasePrice(Number.isFinite(matchedLivePrice) ? matchedLivePrice : matchedVariant.price);
      } else {
        variantIdInput.value = '';
        setBasePrice(0);
      }

      refreshPlayTimeDependentUi(true);
      loadSelectedSecurityDepositLeadDays().then(function () {
        updateProcessorAvailabilityNote();
      });
      loadSelectedVariantAndDepositPrices(false).catch(function (error) {
        console.error('Selected variant live price lookup error:', error);
        updateTotal();
      });
      updateRentalInfoPanels();
    }

    hideInternalIpadCellularProcessorOptions();
    updateIpadCellularModeAvailability();

    if (optionInputs.length) {
      optionInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          if (input.getAttribute('data-internal-cellular-processor') === 'true') return;
          refreshSelectedRentalConfiguration();

          if (
            isIpadRentalPage() &&
            input.getAttribute('data-option-position') === getRentalProcessorSelectPosition()
          ) {
            loadPencilAddonStockAvailability(false);
          }
        });
      });

      if (!rentalEditRequestedGroupId) {
        refreshSelectedRentalConfiguration();
      }
    }

    if (rentalPeriodSelect) {
      rentalPeriodSelect.addEventListener('change', handleRentalPeriodSelectChange);
    }

    if (rentalProcessorSelect) {
      
      rentalProcessorSelect.addEventListener('change', handleRentalProcessorSelectChange);

      var rentalProcessorMobileLabelMode = isRentalProcessorMobileLabelMode();

      function refreshRentalProcessorLabelsForViewport() {
        var currentMobileLabelMode = isRentalProcessorMobileLabelMode();
        if (currentMobileLabelMode === rentalProcessorMobileLabelMode) return;

        rentalProcessorMobileLabelMode = currentMobileLabelMode;
        updateProcessorAvailabilityNote();
      }

      window.addEventListener('resize', function () {
        window.requestAnimationFrame(refreshRentalProcessorLabelsForViewport);
      });

      window.addEventListener('orientationchange', function () {
        window.setTimeout(refreshRentalProcessorLabelsForViewport, 80);
      });

      updateRentalProcessorClosedDisplay();
    }

    if (startDateInput) {
      refreshRentalStartDateMinimum(true);
      setupCustomRentalDatePicker();

      function prepareRentalStartDatePicker() {
        refreshRentalStartDateMinimum(true);
        setRentalStartDateDisplayText();

        if (useCustomRentalDatePicker) {
          renderRentalMobileCalendar();
        }
      }

      function handleRentalStartDateChange() {
        clearRentalFieldPrompt(startDateInput);
        refreshRentalStartDateMinimum(false);
        var rejectedInvalidDate = rejectInvalidRentalStartDateSelection();

        setRentalStartDateDisplayText();
        validateDateField();

        if (rejectedInvalidDate && dateError) {
          dateError.hidden = false;
        }

        if (useCustomRentalDatePicker) {
          renderRentalMobileCalendar();
        }

        rebuildDeliveryOptions();
        updateTotal();
        updateRentalEndInfo();
      }

      if (useCustomRentalDatePicker) {
        if (rentalStartDateDisplay) {
          rentalStartDateDisplay.addEventListener('click', function (event) {
            event.preventDefault();
            toggleRentalStartDateCalendar();
          });
        }

        if (rentalMobileCalendarPrev) {
          rentalMobileCalendarPrev.addEventListener('click', function () {
            changeRentalCalendarMonth(-1);
          });
        }

        if (rentalMobileCalendarNext) {
          rentalMobileCalendarNext.addEventListener('click', function () {
            changeRentalCalendarMonth(1);
          });
        }

        document.addEventListener('click', function (event) {
          if (!rentalMobileCalendar || rentalMobileCalendar.hidden) return;

          var target = event.target;
          var clickedCalendar = rentalMobileCalendar.contains(target);
          var clickedDateButton = rentalStartDateDisplay && rentalStartDateDisplay.contains(target);

          if (!clickedCalendar && !clickedDateButton) {
            setRentalMobileCalendarOpen(false);
          }
        });

        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && rentalMobileCalendar && !rentalMobileCalendar.hidden) {
            setRentalMobileCalendarOpen(false);
          }
        });
      } else {
        if (window.PointerEvent) {
          startDateInput.addEventListener('pointerdown', prepareRentalStartDatePicker, { capture: true });
        } else {
          startDateInput.addEventListener('touchstart', prepareRentalStartDatePicker, { capture: true, passive: true });
        }

        startDateInput.addEventListener('focus', prepareRentalStartDatePicker);
        startDateInput.addEventListener('click', prepareRentalStartDatePicker, { capture: true });
      }

      startDateInput.addEventListener('input', handleRentalStartDateChange);
      startDateInput.addEventListener('change', handleRentalStartDateChange);
    }

    if (deliveryTimeInput) {
      deliveryTimeInput.addEventListener('change', function () {
        clearRentalFieldPrompt(deliveryTimeInput);
        validateTimingFields();
        updateRentalEndInfo();
        updateTotal();
      });
    }

    if (returnTimeInput) {
      returnTimeInput.addEventListener('change', function () {
        clearRentalFieldPrompt(returnTimeInput);
        validateTimingFields();
        updateRentalEndInfo();
        updateTotal();
      });
    }

    if (memoryAddonInput) {
      memoryAddonInput.addEventListener('change', function () {
        updateAddonCards();
        updateTotal();
      });
    }

    if (officeAddonInput) {
      officeAddonInput.addEventListener('change', function () {
        updateAddonCards();
        updateTotal();
      });
    }

    if (appleMouseAddonInput) {
      appleMouseAddonInput.addEventListener('change', function () {
        if (
          appleMouseAddonInput.checked &&
          !appleMouseStockCanFulfil(
            appleMouseAddonStockStatus,
            getRequestedAppleMouseQuantity()
          )
        ) {
          appleMouseAddonInput.checked = false;
        }

        updateAddonCards();
        updateTotal();
      });
    }

    if (hdmiAddonInput) {
      hdmiAddonInput.addEventListener('change', function () {
        updateAddonCards();
        updateRentalInfoPanels();
        updateTotal();
      });
    }

    if (cellularAddonInput) {
      cellularAddonInput.addEventListener('change', function () {
        if (
          cellularAddonInput.getAttribute('data-cellular-forced') === 'true' &&
          !cellularAddonInput.checked
        ) {
          cellularAddonInput.checked = true;
          updateAddonCards();
          return;
        }

        updateAddonCards();
        refreshSelectedRentalConfiguration();
        loadSecurityDepositStockAvailability();
      });
    }

    if (pencilAddonInput) {
      pencilAddonInput.addEventListener('change', function () {
        if (pencilAddonInput.checked && !selectedPencilAddonConfig) {
          pencilAddonInput.checked = false;
        }

        updateAddonCards();
        updateTotal();
      });
    }

    updateAppleMouseAddonAvailability();
    updateAddonCards();
    bindRentalCardTapHandlers();

    var rentalTimingRevalidatedForSubmit = false;

    function revalidateRentalTimingBeforeAdd() {
      var appleMouseWasSelected = appleMouseAddonApplied();
      var pencilWasSelected = pencilAddonApplied();

      return Promise.all([
        loadPlayTimeAvailability(),
        loadSelectedSecurityDepositLeadDays(),
        loadAppleMouseAddonStockAvailability(true),
        loadPencilAddonStockAvailability(true),
        revalidateActiveRentalCartDocumentsBeforeSubmit()
      ])
        .then(function () {
          if (appleMouseWasSelected && !appleMouseAddonApplied()) {
            throw new Error('Apple Mouse is no longer available. Please review Optional Extras.');
          }

          if (pencilWasSelected && !pencilAddonApplied()) {
            throw new Error('Pencil is no longer available for the selected iPad model. Please review Optional Extras.');
          }

          refreshPlayTimeDependentUi(false);
          return loadLiveVariantPrices(getRequiredLivePriceVariantIdsForCurrentSelection(), true);
        })
        .then(function () {
          refreshUiAfterLiveVariantPrices();
        });
    }

    if (rentalForm) {
      if (mobileSummaryJump) {
        mobileSummaryJump.addEventListener('click', scrollToRentalSummary);
        window.addEventListener('scroll', updateMobileSummaryJumpVisibility, { passive: true });
        window.addEventListener('touchmove', resumeMobileSummaryJumpAfterUserScroll, { passive: true });
        window.addEventListener('wheel', resumeMobileSummaryJumpAfterUserScroll, { passive: true });
        document.addEventListener('keydown', handleMobileSummaryJumpScrollKey);
        window.addEventListener('resize', handleMobileReviewFlowChange);
        if (window.visualViewport) {
          window.visualViewport.addEventListener('resize', updateMobileSummaryJumpVisibility, { passive: true });
        }
        handleMobileReviewFlowChange();
      } else {
        updateMobileReviewFlowLayout();
      }

      rentalForm.addEventListener('submit', function (event) {
        event.preventDefault();

        if (!validateRequiredRentalFieldsWithPrompt()) {
          rentalTimingRevalidatedForSubmit = false;
          setLoadingState(false);
          return;
        }

        if (!rentalTimingRevalidatedForSubmit) {
          rentalTimingRevalidatedForSubmit = true;
          setLoadingState(true);

          revalidateRentalTimingBeforeAdd()
            .then(function () {
              setLoadingState(false);
              rentalForm.dispatchEvent(new Event('submit', {
                bubbles: true,
                cancelable: true
              }));
            })
            .catch(function (error) {
              console.error('Rental availability and live pricing revalidation error:', error);
              rentalTimingRevalidatedForSubmit = false;
              setLoadingState(false);
              var revalidationMessage = error && error.message
                ? String(error.message)
                : '';

              window.alert(
                revalidationMessage.indexOf('Pencil is no longer available') === 0 ||
                revalidationMessage.indexOf('Apple Mouse is no longer available') === 0 ||
                revalidationMessage.indexOf('Your previous document submission is no longer valid') === 0
                  ? revalidationMessage
                  : 'Unable to refresh the latest availability and pricing. Please try again.'
              );
            });

          return;
        }

        rentalTimingRevalidatedForSubmit = false;

        var invalid = validateDateField();
        if (invalid) {
          promptRentalStartDateField();
          return;
        }

        rebuildDeliveryOptions();

        if (!validateTimingFields()) {
          promptFirstMissingTimingField();
          return;
        }

        if (!jotformSubmittedInput || jotformSubmittedInput.value !== 'Yes') {
          focusRequiredDocumentsPanel();
          return;
        }

        var needsWeekendSurcharge = weekendApplied();
        var needsEarlyDeliverySurcharge = earlyDeliveryApplied();
        var needsPriorityUrgentCharge = priorityUrgentChargeApplied();
        var needsStandardUrgentCharge = standardUrgentChargeApplied();
        var needsStandardReturnExtension = standardReturnExtensionApplied();
        var needsPriorityReturnExtension = priorityReturnExtensionApplied();
        var needsMemoryAddon = memoryAddonApplied();
        var needsOfficeAddon = officeAddonApplied();
        var needsAppleMouseAddon = appleMouseAddonApplied();
        var needsHdmiAddon = hdmiAddonApplied();
        var cellularModeSelected = cellularAddonApplied();
        var needsPencilAddon = pencilAddonApplied();
        var securityDepositConfig = getSecurityDepositConfig();

        if (!selectedRentalOptionIsAvailable()) {
          window.alert('The selected rental item is currently unavailable. Please choose another option.');
          return;
        }

        if (needsWeekendSurcharge && (!weekendSurchargeVariantId || Number(weekendSurchargeVariantId) <= 0)) {
          window.alert('Weekend surcharge variant ID has not been configured yet.');
          return;
        }

        if (needsEarlyDeliverySurcharge && (!earlyDeliveryVariantId || Number(earlyDeliveryVariantId) <= 0)) {
          window.alert('Early delivery variant ID has not been configured yet.');
          return;
        }

        if (needsPriorityUrgentCharge && (!priorityUrgentChargeVariantId || Number(priorityUrgentChargeVariantId) <= 0)) {
          window.alert('Priority urgent delivery variant ID has not been configured.');
          return;
        }

        if (needsStandardUrgentCharge && (!standardUrgentChargeVariantId || Number(standardUrgentChargeVariantId) <= 0)) {
          window.alert('Standard urgent delivery variant ID has not been configured.');
          return;
        }

        if (needsStandardReturnExtension && (!standardReturnExtensionVariantId || Number(standardReturnExtensionVariantId) <= 0)) {
          window.alert('Standard return extension variant ID has not been configured.');
          return;
        }

        if (needsPriorityReturnExtension && (!priorityReturnExtensionVariantId || Number(priorityReturnExtensionVariantId) <= 0)) {
          window.alert('Priority return extension variant ID has not been configured.');
          return;
        }

        if (!securityDepositConfig.variantId || Number(securityDepositConfig.variantId) <= 0) {
          window.alert('Security deposit variant ID has not been configured for the selected option.');
          return;
        }

        if (needsMemoryAddon && (!memoryAddonVariantId || Number(memoryAddonVariantId) <= 0)) {
          window.alert('32GB addon variant ID has not been configured.');
          return;
        }

        if (needsOfficeAddon && (!officeAddonVariantId || Number(officeAddonVariantId) <= 0)) {
          window.alert('Microsoft Office addon variant ID has not been configured.');
          return;
        }

        if (needsAppleMouseAddon && (!appleMouseAddonVariantId || Number(appleMouseAddonVariantId) <= 0)) {
          window.alert('Apple Mouse optional extra variant ID has not been configured.');
          return;
        }

        if (
          needsAppleMouseAddon &&
          !appleMouseStockCanFulfil(
            appleMouseAddonStockStatus,
            getRequestedAppleMouseQuantity()
          )
        ) {
          window.alert('Apple Mouse is currently unavailable. Please review Optional Extras.');
          return;
        }

        if (needsHdmiAddon && (!hdmiAddonVariantId || Number(hdmiAddonVariantId) <= 0)) {
          window.alert('HDMI Port optional extra variant ID has not been configured.');
          return;
        }

        if (needsPencilAddon && (!pencilAddonVariantId || Number(pencilAddonVariantId) <= 0)) {
          window.alert('Pencil optional extra variant ID has not been configured.');
          return;
        }

        var missingLivePriceVariantIds = getRequiredLivePriceVariantIdsForCurrentSelection().filter(function (variantId) {
          return !Number.isFinite(getLiveVariantPriceCents(variantId));
        });

        if (missingLivePriceVariantIds.length) {
          window.alert('Unable to verify the latest Shopify price for one or more selected items. Please try again.');
          return;
        }

        securityDepositConfig = getSecurityDepositConfig();
        if (!securityDepositConfig || !Number.isFinite(securityDepositConfig.cents)) {
          window.alert('Unable to verify the latest security deposit price. Please try again.');
          return;
        }

        setLoadingState(true);

        var matchedVariant = findMatchingVariant();

        if (!matchedVariant || !variantIdInput.value) {
          window.alert(
            cellularModeSelected
              ? 'The Cellular rental configuration is not available for the selected model and period.'
              : 'The selected rental configuration is unavailable. Please choose another option.'
          );
          setLoadingState(false);
          return;
        }

        var rentalGroupId = rentalEditModeActive && rentalEditRequestedGroupId
          ? rentalEditRequestedGroupId
          : 'rental-' + Math.floor(getTrustedNowMs()) + '-' + Math.random().toString(36).slice(2, 10);
        var requestedRentalQuantity = getRequestedRentalQuantity();
        var rentalEndDateValue = formatDateProperty(
          getRentalEndDate(parseLocalDate(startDateInput.value), getSelectedRentalPeriod())
        );

        var rentalProperties = {
          'Rental group ID': rentalGroupId,
          'Rental start date': startDateInput.value,
          'Rental end date': rentalEndDateValue,
          'Delivery timing': deliveryTimeInput && deliveryTimeInput.selectedIndex > 0
            ? stripDeliveryChargeSuffix(deliveryTimeInput.options[deliveryTimeInput.selectedIndex].text)
            : '',
          'Return timing': returnTimeInput ? returnTimeInput.value : '',
          'Additional notes': rentalNotes ? rentalNotes.value : '',
          'Documents submitted': jotformSubmittedInput ? jotformSubmittedInput.value : 'No',
          'Security deposit amount': formatMoney(securityDepositConfig.cents)
        };

        if (needsWeekendSurcharge) {
          rentalProperties['Weekend surcharge applied'] = 'Yes';
          rentalProperties['Weekend surcharge amount'] = formatMoney(weekendSurchargeCents);
        }

        if (needsEarlyDeliverySurcharge) {
          rentalProperties['Early delivery applied'] = 'Yes';
          rentalProperties['Early delivery amount'] = formatMoney(earlyDeliverySurchargeCents);
        }

        if (needsPriorityUrgentCharge) {
          rentalProperties['Priority urgent delivery applied'] = 'Yes';
          rentalProperties['Priority urgent delivery amount'] = formatMoney(priorityUrgentChargeCents);
        }

        if (needsStandardUrgentCharge) {
          rentalProperties['Standard urgent delivery applied'] = 'Yes';
          rentalProperties['Standard urgent delivery amount'] = formatMoney(standardUrgentChargeCents);
        }

        if (needsStandardReturnExtension) {
          rentalProperties['Standard return extension applied'] = 'Yes';
          rentalProperties['Standard return extension amount'] = formatMoney(standardReturnExtensionCents);
        }

        if (needsPriorityReturnExtension) {
          rentalProperties['Priority return extension applied'] = 'Yes';
          rentalProperties['Priority return extension amount'] = formatMoney(priorityReturnExtensionCents);
        }

        if (memoryAddonInput && memoryAddonInput.checked) {
          rentalProperties['32GB addon selected'] = 'Yes';
          rentalProperties['32GB addon amount'] = formatMoney(memoryAddonCents);
        }

        if (officeAddonInput && officeAddonInput.checked) {
          rentalProperties['Microsoft Office addon selected'] = 'Yes';
          rentalProperties['Microsoft Office addon amount'] = formatMoney(officeAddonCents);
        }

        if (appleMouseAddonInput && appleMouseAddonInput.checked) {
          rentalProperties['Apple Mouse optional extra selected'] = 'Yes';
          rentalProperties['Apple Mouse optional extra amount'] = formatMoney(appleMouseAddonCents);
        }

        if (hdmiAddonInput && hdmiAddonInput.checked) {
          rentalProperties['HDMI Port optional extra selected'] = 'Yes';
          rentalProperties['HDMI Port optional extra amount'] = formatMoney(hdmiAddonCents);
        }

        if (cellularModeSelected) {
          rentalProperties['Connectivity'] = 'Cellular';
        }

        if (pencilAddonInput && pencilAddonInput.checked) {
          rentalProperties['Pencil optional extra selected'] = 'Yes';
          rentalProperties['Pencil optional extra amount'] = formatMoney(pencilAddonCents);
        }

        var items = [
          {
            id: Number(variantIdInput.value),
            quantity: requestedRentalQuantity,
            properties: rentalProperties
          },
          {
            id: Number(securityDepositConfig.variantId),
            quantity: requestedRentalQuantity,
            properties: {
              'Rental group ID': rentalGroupId,
              'Linked rental product': String(rentalPageConfig.productTitle || ''),
              'Linked rental variant': matchedVariant ? matchedVariant.title : '',
              'Rental start date': startDateInput.value,
              'Rental end date': rentalEndDateValue,
              'Charge type': 'Security deposit'
            }
          }
        ];

        if (needsWeekendSurcharge) {
          items.push({
            id: Number(weekendSurchargeVariantId),
            quantity: requestedRentalQuantity,
            properties: {
              'Rental group ID': rentalGroupId,
              'Linked rental product': String(rentalPageConfig.productTitle || ''),
              'Linked rental variant': matchedVariant ? matchedVariant.title : '',
              'Rental start date': startDateInput.value,
              'Rental end date': rentalEndDateValue,
              'Charge type': 'Weekend surcharge'
            }
          });
        }

        if (needsEarlyDeliverySurcharge) {
          items.push({
            id: Number(earlyDeliveryVariantId),
            quantity: requestedRentalQuantity,
            properties: {
              'Rental group ID': rentalGroupId,
              'Linked rental product': String(rentalPageConfig.productTitle || ''),
              'Linked rental variant': matchedVariant ? matchedVariant.title : '',
              'Rental start date': startDateInput.value,
              'Rental end date': rentalEndDateValue,
              'Charge type': 'Early delivery'
            }
          });
        }

        if (needsPriorityUrgentCharge) {
          items.push({
            id: Number(priorityUrgentChargeVariantId),
            quantity: requestedRentalQuantity,
            properties: {
              'Rental group ID': rentalGroupId,
              'Linked rental product': String(rentalPageConfig.productTitle || ''),
              'Linked rental variant': matchedVariant ? matchedVariant.title : '',
              'Rental start date': startDateInput.value,
              'Rental end date': rentalEndDateValue,
              'Charge type': 'Priority urgent delivery'
            }
          });
        }

        if (needsStandardUrgentCharge) {
          items.push({
            id: Number(standardUrgentChargeVariantId),
            quantity: requestedRentalQuantity,
            properties: {
              'Rental group ID': rentalGroupId,
              'Linked rental product': String(rentalPageConfig.productTitle || ''),
              'Linked rental variant': matchedVariant ? matchedVariant.title : '',
              'Rental start date': startDateInput.value,
              'Rental end date': rentalEndDateValue,
              'Charge type': 'Standard urgent delivery'
            }
          });
        }

        if (needsStandardReturnExtension) {
          items.push({
            id: Number(standardReturnExtensionVariantId),
            quantity: requestedRentalQuantity,
            properties: {
              'Rental group ID': rentalGroupId,
              'Linked rental product': String(rentalPageConfig.productTitle || ''),
              'Linked rental variant': matchedVariant ? matchedVariant.title : '',
              'Rental start date': startDateInput.value,
              'Rental end date': rentalEndDateValue,
              'Charge type': 'Standard return extension'
            }
          });
        }

        if (needsPriorityReturnExtension) {
          items.push({
            id: Number(priorityReturnExtensionVariantId),
            quantity: requestedRentalQuantity,
            properties: {
              'Rental group ID': rentalGroupId,
              'Linked rental product': String(rentalPageConfig.productTitle || ''),
              'Linked rental variant': matchedVariant ? matchedVariant.title : '',
              'Rental start date': startDateInput.value,
              'Rental end date': rentalEndDateValue,
              'Charge type': 'Priority return extension'
            }
          });
        }

        if (needsMemoryAddon) {
          items.push({
            id: Number(memoryAddonVariantId),
            quantity: requestedRentalQuantity,
            properties: {
              'Rental group ID': rentalGroupId,
              'Linked rental product': String(rentalPageConfig.productTitle || ''),
              'Linked rental variant': matchedVariant ? matchedVariant.title : '',
              'Rental start date': startDateInput.value,
              'Rental end date': rentalEndDateValue,
              'Charge type': '32GB memory addon'
            }
          });
        }

        if (needsOfficeAddon) {
          items.push({
            id: Number(officeAddonVariantId),
            quantity: requestedRentalQuantity,
            properties: {
              'Rental group ID': rentalGroupId,
              'Linked rental product': String(rentalPageConfig.productTitle || ''),
              'Linked rental variant': matchedVariant ? matchedVariant.title : '',
              'Rental start date': startDateInput.value,
              'Rental end date': rentalEndDateValue,
              'Charge type': 'Microsoft Office addon'
            }
          });
        }

        if (needsAppleMouseAddon) {
          items.push({
            id: Number(appleMouseAddonVariantId),
            quantity: getRequestedAppleMouseQuantity(),
            properties: {
              'Rental group ID': rentalGroupId,
              'Linked rental product': String(rentalPageConfig.productTitle || ''),
              'Linked rental variant': matchedVariant ? matchedVariant.title : '',
              'Rental start date': startDateInput.value,
              'Rental end date': rentalEndDateValue,
              'Charge type': 'Apple Mouse optional extra'
            }
          });
        }

        if (needsHdmiAddon) {
          items.push({
            id: Number(hdmiAddonVariantId),
            quantity: requestedRentalQuantity,
            properties: {
              'Rental group ID': rentalGroupId,
              'Linked rental product': String(rentalPageConfig.productTitle || ''),
              'Linked rental variant': matchedVariant ? matchedVariant.title : '',
              'Rental start date': startDateInput.value,
              'Rental end date': rentalEndDateValue,
              'Charge type': 'HDMI Port optional extra'
            }
          });
        }

        if (needsPencilAddon) {
          items.push({
            id: Number(pencilAddonVariantId),
            quantity: getRequestedPencilQuantity(),
            properties: {
              'Rental group ID': rentalGroupId,
              'Linked rental product': String(rentalPageConfig.productTitle || ''),
              'Linked rental variant': matchedVariant ? matchedVariant.title : '',
              'Rental start date': startDateInput.value,
              'Rental end date': rentalEndDateValue,
              'Charge type': 'Pencil optional extra'
            }
          });
        }

        replaceRentalEditGroup(items)
          .then(function () {
            if (rentalEditModeActive && rentalEditRequestedGroupId) {
              clearRentalEditCache(rentalEditRequestedGroupId);
            }
            window.location.href = '/cart';
          })
          .catch(function (error) {
            console.error(rentalEditModeActive ? 'Rental update error:' : 'Rental add-to-cart error:', error);
            window.alert(
              error && error.message
                ? error.message
                : rentalEditModeActive
                  ? 'Unable to update the rental. Please review your cart and try again.'
                  : 'Something went wrong while adding the rental to cart.'
            );

            if (rentalEditModeActive && error && /original rental has been restored|review your cart/i.test(String(error.message || ''))) {
              window.location.href = '/cart';
            }
          })
          .finally(function () {
            setLoadingState(false);
          });
      });
    }

    rebuildDeliveryOptions();

    window.setInterval(function () {
      if (startDateInput) {
        refreshPlayTimeDependentUi(true);
      }
    }, 60000);

    var initialSecurityDepositStockCount = hydrateInitialSecurityDepositStockAvailability();

    if (initialSecurityDepositStockCount > 0) {
      
      applySecurityDepositStockStatusToOptions();
      updateProcessorAvailabilityNote();
    }

    updateAppleMouseAddonAvailability();
    updatePencilAddonAvailability();
    updateRentalInfoPanels();
    updateTotal();
    updateRentalEndInfo();

    var editFastPathLoaded = initialiseRentalEditFastPath();

    if (rentalEditRequestedGroupId) {
      if (editFastPathLoaded) {
        runRentalInitialValidationLoads(false);
      }

      initialiseRentalEditMode()
        .catch(function () { return false; })
        .then(function () {
          if (!editFastPathLoaded && rentalEditModeActive) {
            return runRentalInitialValidationLoads(false);
          }
          return true;
        })
        .then(function () {
          return initialiseActiveRentalCartDocumentReuse(rentalEditLoadedCart);
        });
    } else {
      runRentalInitialValidationLoads(false);
      initialiseActiveRentalCartDocumentReuse();
    }
  })();
